<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <!-- <b-icon
          style="cursor: pointer; margin-top: 10px; margin-left: 20px"
          pack="fas"
          icon="arrow-left"
          size="is-small"
        >
        </b-icon> -->

        <div class="columns">
          <div class="column is-1">
            <b-button
              icon-left="arrow-left"
              icon-pack="fas"
              type="is-info is-light"
              @click="$router.go(-1)"
              expanded
              >{{ i18n.goBack[iso] }}</b-button
            >
          </div>
        </div>

        <!-- <p class="subtitle">Hero subtitle</p> -->
        <!-- <div
          style="display: flex; align-items: center; justify-content: center"
        >
          <b-button
            style="position: relative; bottom: 5%"
            type="is-link is-light"
            icon-left="arrow-left"
            icon-pack="fas"
          >
            {{ i18n.hide[iso] }}
          </b-button>
        </div> -->
      </div>
    </section>

    <section style="margin-top: -90px">
      <div class="card article" :style="isVip ? 'border: #FFB744 3px solid;' : ''">
        <div class="card-content">
          <div class="media">
            <div class="media-center">
              <img
                :src="isVip ? 'img/pase-vip.png' : 'img/profile.png'"
                :class="isVip ? 'author-image-vip' : 'author-image'"
                alt="Placeholder image"
              />
            </div>
            <div class="media-content has-text-centered">
              <p class="title article-title"> 
                <b>{{ member.Nombre }} {{ member.ApellidoPaterno }}</b
                ><small
                  ><span v-if="coOwner.Nombre && coOwner.Nombre !== ''"
                    >, {{ coOwner.Nombre }} {{ coOwner.ApellidoPaterno }}</span
                  ></small
                >
              </p>
              <p class="subtitle is-6 article-subtitle">
                <b-tag
                  >LoginID: <b>{{ contract.LoginID }}</b></b-tag
                >
                <b-tag style="margin-left: 10px"
                  >{{ i18n.contract[iso] }}: <b>{{ contract.Numero }}</b></b-tag
                >

                <!-- <b-tag style="margin-left: 10px"
                  >{{ i18n.coOwner[iso] }}:
                  <b
                    >{{ coOwner.Nombre }} {{ coOwner.ApellidoPaterno }}</b
                  ></b-tag
                > -->
                <b-tag style="margin-left: 10px"
                  >Club:
                  <b
                    >{{ club.Nombre
                    }}{{
                      club && club.NombreSecundario
                        ? ` ${club.NombreSecundario}`
                        : ""
                    }}</b
                  ></b-tag
                >
                <b-tag
                  style="margin-left: 10px"
                  v-for="item in infoContract"
                  v-if="item.key === 'FechaRenovacion'"
                  :type="isExpired ? 'is-danger' : 'is-success'"
                >
                  {{ i18n.subscription[iso] }}:
                  <b v-if="item.type === 'date'">{{
                    item.isParse
                      ? item.parse(contract[item.key], contract)
                      : contract[item.key]
                  }}</b></b-tag
                >
              </p>
              <p class="subtitle is-6 article-subtitle" v-if="!isCap">
                <b-tag 
                  style="margin-left: 10px; background-color: #ff6b35; color: #fff; cursor: pointer" 
                  @click.native="openHubSpotContract"
                  :title="(contract.HsData && contract.HsData.id_hs_contract) ? 'Click para abrir en HubSpot' : ''"
                >
                  HubSpot: <b>{{ (contract.HsData && contract.HsData.id_hs_contract) || i18n.notFound[iso] }}</b>
                </b-tag>
                <b-tag
                  style="margin-left: 10px"
                  type="is-primary is-light"
                  v-if="FechaUltimoInicioSesion"
                  >{{ i18n.lastLogin[iso] }} ({{ i18n.owner[iso] }}):
                  <b>{{ FechaUltimoInicioSesion }}</b></b-tag
                >
                <b-tag
                  style="margin-left: 10px"
                  type="is-primary is-light"
                  v-if="coMemberId && FechaUltimoInicioSesionCoOwner"
                  >{{ i18n.lastLogin[iso] }} ({{ i18n.coOwner[iso] }}):
                  <b>{{ FechaUltimoInicioSesionCoOwner }}</b></b-tag
                >
                <b-tag style="margin-left: 10px" type="is-light"
                  >{{ i18n.agentRenewal[iso] }}:
                  <b style="color: #167df0">{{
                    AgenteRenovacion || i18n.notFound[iso]
                  }}</b></b-tag
                >
              </p>
              <p class="subtitle is-6 article-subtitle" v-if="contract && contract.UltimoResetRenovacion && contract.UltimoResetRenovacion.FechaAnterior && contract.UltimoResetRenovacion.FechaNueva">
                <b-tag type="is-warning is-light"
                  >Reset:
                  <b>{{ parseDate(contract.UltimoResetRenovacion.FechaAnterior) }} ➝ {{ parseDate(contract.UltimoResetRenovacion.FechaNueva) }}</b></b-tag
                >
              </p>
            </div>
          </div>

          <b-tabs
            v-model="activeTab"
            position="is-centered"
            type="is-boxed"
            @input="actionTab"
          >
            <!-- Pestaña de Detalles -->
            <b-tab-item>
              <template #header>
                <b-icon icon="user" pack="fas" type="is-info"></b-icon>
                <b>{{ i18n.details[iso] }}</b>
              </template>
              <!-- Titular -->
              <div class="columns is-multiline">
                <div class="column is-12">
                  <div class="content">
                    <h3>{{ i18n.owner[iso] }}</h3>
                  </div>
                </div>

                <div :class="`column is-${m.size}`" v-for="m in infoMembers">
                  <b-field
                    label-position="on-border"
                    :label="`${i18n[m.fieldIso][iso]} ${m.required ? '*' : ''}`"
                    v-if="m.isInfo"
                  >
                    <b-input
                      v-model="member[m.key]"
                      type="text"
                      expanded
                      :disabled="true"
                    >
                    </b-input>
                  </b-field>

                  <b-field
                    label-position="on-border"
                    :label="`${i18n[m.fieldIso][iso]} ${m.required ? '*' : ''}`"
                    v-if="m.type === 'text' && m.isInfo === false"
                    :type="checkFieldsOK(member, m.key) ? 'is-success' : ''"
                  >
                    <b-input
                      v-model="member[m.key]"
                      type="text"
                      :icon-right="checkFieldsOK(member, m.key) ? '' : 'times'"
                      :icon-right-clickable="
                        checkFieldsOK(member, m.key) ? false : true
                      "
                      expanded
                      :disabled="!isEdit"
                    >
                    </b-input>
                  </b-field>

                  <b-field
                    label-position="on-border"
                    :label="`${i18n[m.fieldIso][iso]} ${m.required ? '*' : ''}`"
                    v-if="m.type === 'date' && m.isInfo === false"
                  >
                    <b-datepicker
                      v-model="member[m.key]"
                      :locale="iso"
                      :disabled="!isEdit"
                    >
                    </b-datepicker>
                  </b-field>

                  <b-field
                    label-position="on-border"
                    :label="`${i18n[m.fieldIso][iso]} ${m.required ? '*' : ''}`"
                    v-if="m.type === 'select' && m.isInfo === false"
                  >
                    <b-select
                      v-model="member[m.key]"
                      expanded
                      :disabled="!isEdit"
                    >
                      <option
                        v-if="!m.optionsIsCatalogue"
                        v-for="cc in m.options"
                        :value="cc[m.valueOption]"
                      >
                        {{ m.showOption(cc) }}
                      </option>
                      <option
                        v-if="m.optionsIsCatalogue"
                        v-for="cc in m.withFilters
                          ? m.optionsFilters(catalogues[m.options])
                          : catalogues[m.options]"
                        :value="cc[m.valueOption]"
                      >
                        {{ m.showOption(cc) }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
              </div>

              <div class="columns is-multiline is-flex-direction-row-reverse">
                <!-- <div
                  :class="`column is-${
                    (isEdit && (!contract.FechaActivacion || !Tutorial)) ||
                    (isEdit && (contract.FechaActivacion || !Tutorial)) ||
                    (!isEdit && (!contract.FechaActivacion || !Tutorial))
                      ? 8
                      : 10
                  }`"
                ></div> -->

                <div
                  class="column is-2"
                  v-if="
                    !isCap &&
                    contract.EstadoMembresia &&
                    contract.FechaActivacion
                  "
                >
                  <b-button
                    :icon-left="'award'"
                    icon-pack="fas"
                    type="is-primary"
                    expanded
                    @click="openTutorialModal"
                    :loading="loadingAddCommentTutorial"
                    >{{ i18n.addTutorial[iso] }}</b-button
                  >
                </div>

                <div class="column is-2" v-if="!isCap && memberId && !isEdit">
                  <b-button
                    icon-left="sms"
                    icon-pack="fas"
                    type="is-link is-light"
                    expanded
                    @click="openSmsModal(member, memberId, 'T')"
                    >{{ iso === "es" ? "Enviar SMS" : "Send SMS" }}</b-button
                  >
                </div>

                <div
                  class="column is-2"
                  v-if="
                    !contract.FechaActivacion &&
                    !isEdit &&
                    contract.FechaProcesable
                  "
                >
                  <b-button
                    :icon-left="
                      contract.EstadoMembresia ? 'check-circle' : 'check'
                    "
                    icon-pack="fas"
                    :type="contract.EstadoMembresia ? 'is-light' : 'is-primary'"
                    expanded
                    @click="activateMembership"
                    :loading="loadingButtonEditStatusMembership"
                    >{{ i18n.activate[iso] }}</b-button
                  >
                </div>

                <div class="column is-2" v-if="isEdit">
                  <b-button
                    icon-left="times"
                    icon-pack="fas"
                    type="is-danger"
                    expanded
                    @click="cancelEdit"
                    >{{ i18n.cancel[iso] }}</b-button
                  >
                </div>

                <div class="column is-2" v-if="member.HsData">
                  <b-button
                    icon-left="hubspot"
                    icon-pack="fab"
                    style="background-color: #ff6b35; border-color: #ff6b35; color: white;"
                    expanded
                    @click="openHubSpotContact(member.HsData)"
                    >Ver en HubSpot</b-button
                  >
                </div>
                <div class="column is-2">
                  <b-button
                    icon-left="save"
                    icon-pack="fas"
                    type="is-success"
                    expanded
                    @click="editProfile"
                    v-if="isEdit"
                    >{{ i18n.save[iso] }}</b-button
                  >
                  <b-button
                    icon-left="edit"
                    icon-pack="fas"
                    type="is-info"
                    expanded
                    @click="allowEdit"
                    v-else
                    >{{ i18n.edit[iso] }}</b-button
                  >
                </div>
              </div>

              <!-- CoTitular -->
              <div class="columns is-multiline" v-if="coMemberId">
                <div class="column is-12">
                  <div class="content">
                    <h3>{{ i18n.coOwner[iso] }}</h3>
                  </div>
                </div>

                <div
                  :class="`column is-${m.size}`"
                  v-for="m in infoCoMembers()"
                >
                  <b-field
                    label-position="on-border"
                    :label="`${i18n[m.fieldIso][iso]} ${m.required ? '*' : ''}`"
                    v-if="m.isInfo"
                  >
                    <b-input
                      v-model="coOwner[m.key]"
                      type="text"
                      expanded
                      :disabled="true"
                    >
                    </b-input>
                  </b-field>

                  <b-field
                    label-position="on-border"
                    :label="`${i18n[m.fieldIso][iso]} ${m.required ? '*' : ''}`"
                    v-if="m.type === 'text' && m.isInfo === false"
                    :type="checkFieldsOK(coOwner, m.key) ? 'is-success' : ''"
                  >
                    <b-input
                      v-model="coOwner[m.key]"
                      type="text"
                      :icon-right="checkFieldsOK(coOwner, m.key) ? '' : 'times'"
                      :icon-right-clickable="
                        checkFieldsOK(coOwner, m.key) ? false : true
                      "
                      expanded
                      :disabled="!isCoEdit"
                    >
                    </b-input>
                  </b-field>

                  <b-field
                    label-position="on-border"
                    :label="`${i18n[m.fieldIso][iso]} ${m.required ? '*' : ''}`"
                    v-if="m.type === 'date' && m.isInfo === false"
                  >
                    <b-datepicker
                      v-model="coOwner[m.key]"
                      :locale="iso"
                      :disabled="!isCoEdit"
                    >
                    </b-datepicker>
                  </b-field>

                  <!-- <b-field
                    label-position="on-border"
                    :label="`${i18n[m.fieldIso][iso]} ${m.required ? '*' : ''}`"
                    v-if="m.type === 'select' && m.isInfo === false"
                  >
                    <b-select
                      v-model="coOwner[m.key]"
                      expanded
                      :disabled="!isCoEdit"
                    >
                      <option
                        v-if="!m.optionsIsCatalogue"
                        v-for="cc in m.options"
                        :value="cc[m.valueOption]"
                      >
                        {{ m.showOption(cc) }}
                      </option>
                      <option
                        v-if="m.optionsIsCatalogue"
                        v-for="cc in catalogues[m.options]"
                        :value="cc[m.valueOption]"
                      >
                        {{ m.showOption(cc) }}
                      </option>
                    </b-select>
                  </b-field> -->
                  <b-field
                    label-position="on-border"
                    :label="`${i18n[m.fieldIso][iso]} ${m.required ? '*' : ''}`"
                    v-if="m.type === 'select' && m.isInfo === false"
                  >
                    <b-select
                      v-model="coOwner[m.key]"
                      expanded
                      :disabled="!isCoEdit"
                    >
                      <option
                        v-if="!m.optionsIsCatalogue"
                        v-for="cc in m.options"
                        :value="cc[m.valueOption]"
                      >
                        {{ m.showOption(cc) }}
                      </option>
                      <option
                        v-if="m.optionsIsCatalogue"
                        v-for="cc in m.withFilters
                          ? m.optionsFilters(catalogues[m.options])
                          : catalogues[m.options]"
                        :value="cc[m.valueOption]"
                      >
                        {{ m.showOption(cc) }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
              </div>

              <!-- Campo HubSpot ID para CoTitular -->
              
              <div class="columns is-multiline" v-if="coMemberId">
                <div :class="`column is-${(isCoEdit ? 8 : 10) - (coOwner.HsData ? 2 : 0) - (!isCap && !isCoEdit ? 2 : 0)}`"></div>
                <div class="column is-2" v-if="!isCap && !isCoEdit">
                  <b-button
                    icon-left="sms"
                    icon-pack="fas"
                    type="is-link is-light"
                    expanded
                    @click="openSmsModal(coOwner, coMemberId, 'C')"
                    >{{ iso === "es" ? "Enviar SMS" : "Send SMS" }}</b-button
                  >
                </div>
                <div class="column is-2" v-if="isCoEdit">
                  <b-button
                    icon-left="times"
                    icon-pack="fas"
                    type="is-danger"
                    expanded
                    @click="cancelCoEdit"
                    >{{ i18n.cancel[iso] }}</b-button
                  >
                </div>
                <div class="column is-2">
                  <b-button
                    icon-left="save"
                    icon-pack="fas"
                    type="is-success"
                    expanded
                    @click="editCoProfile"
                    v-if="isCoEdit"
                    >{{ i18n.save[iso] }}</b-button
                  >
                  <b-button
                    icon-left="edit"
                    icon-pack="fas"
                    type="is-info"
                    expanded
                    @click="allowCoEdit"
                    v-else
                    >{{ i18n.edit[iso] }}</b-button
                  >
                </div>
                <div class="column is-2" v-if="coOwner.HsData">
                  <b-button
                    icon-left="hubspot"
                    icon-pack="fab"
                    style="background-color: #ff6b35; border-color: #ff6b35; color: white;"
                    expanded
                    @click="openHubSpotContact(coOwner.HsData)"
                    >Ver en HubSpot</b-button
                  >
                </div>
              </div>

              <div
                class="columns is-multiline"
                v-if="
                  !coMemberId &&
                  (permissions === 'admin' ||
                    permissions.includes('add-co-owner-cap'))
                "
              >
                <div class="column is-2">
                  <div class="content">
                    <h3>{{ i18n.coOwner[iso] }}</h3>
                  </div>
                </div>
                <div class="column is-3">
                  <b-button
                    icon-left="plus"
                    icon-pack="fas"
                    type="is-success"
                    expanded
                    :loading="loadingAddCoOwner"
                    @click="addCoOwner"
                    >{{ i18n.addCoOwner[iso] }}</b-button
                  >
                </div>
              </div>

              <hr />

              <div class="columns is-multiline">
                <div class="column is-2">
                  <div class="content">
                    <h3>{{ i18n.fraf[iso] }}</h3>
                  </div>
                </div>
                <div class="column is-1" v-if="beneficiaries.length < 5">
                  <b-button
                    icon-left="user-plus"
                    icon-pack="fas"
                    type="is-info"
                    @click="
                      beneficiaries = [
                        ...beneficiaries,
                        {
                          Nombre: null,
                          ApellidoPaterno: null,
                          Email: null,
                          LadaTelefono: null,
                          Telefono: null,
                          Parentesco: null,
                          edit: true,
                        },
                      ]
                    "
                    expanded
                  ></b-button>
                </div>
              </div>
              <div
                class="columns is-multiline"
                v-if="beneficiaries && beneficiaries.length > 0"
                v-for="(ff, ffidx) in beneficiaries"
              >
                <div :class="`column is-3`">
                  <b-field
                    label-position="on-border"
                    :label="`${i18n.name[iso]} *`"
                  >
                    <b-input
                      v-model="beneficiaries[ffidx].Nombre"
                      type="text"
                      icon-right="times"
                      icon-right-clickable
                      expanded
                      :disabled="!ff.edit"
                    >
                    </b-input>
                  </b-field>
                </div>
                <div :class="`column is-3`">
                  <b-field
                    label-position="on-border"
                    :label="`${i18n.lastname[iso]} *`"
                  >
                    <b-input
                      v-model="beneficiaries[ffidx].ApellidoPaterno"
                      type="text"
                      icon-right="times"
                      icon-right-clickable
                      expanded
                      :disabled="!ff.edit"
                    >
                    </b-input>
                  </b-field>
                </div>
                <div :class="`column is-3`">
                  <b-field
                    label-position="on-border"
                    :label="`${i18n.email[iso]} *`"
                  >
                    <b-input
                      v-model="beneficiaries[ffidx].Email"
                      type="text"
                      icon-right="times"
                      icon-right-clickable
                      expanded
                      :disabled="!ff.edit"
                    >
                    </b-input>
                  </b-field>
                </div>
                <div :class="`column is-3`">
                  <b-field
                    label-position="on-border"
                    :label="`${i18n.codCellphone[iso]}`"
                  >
                    <b-select
                      v-model="beneficiaries[ffidx].LadaTelefono"
                      expanded
                      :disabled="!ff.edit"
                    >
                      <option v-for="cc in clearCatPaises()" :value="cc.Lada">
                        +{{ cc.Lada }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
                <div :class="`column is-3`">
                  <b-field
                    label-position="on-border"
                    :label="`${i18n.cellphone[iso]}`"
                  >
                    <b-input
                      v-model="beneficiaries[ffidx].Telefono"
                      type="text"
                      icon-right="times"
                      icon-right-clickable
                      expanded
                      :disabled="!ff.edit"
                    >
                    </b-input>
                  </b-field>
                </div>
                <div :class="`column is-3`">
                  <b-field
                    label-position="on-border"
                    :label="`${i18n.relationship[iso]} *`"
                  >
                    <b-select
                      v-model="beneficiaries[ffidx].Parentesco"
                      expanded
                      :disabled="!ff.edit"
                    >
                      <option
                        v-for="cc in catalogues.CatParentescos"
                        :value="cc.Id"
                      >
                        {{ iso === "es" ? cc.Nombre : cc.NombreEn }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
                <div :class="`column is-2`">
                  <b-button
                    icon-left="user-edit"
                    icon-pack="fas"
                    :type="ff.edit ? 'is-success' : 'is-info'"
                    expanded
                    :loading="ff.loading"
                    @click="!ff._id ? openFFAgeWarning(ffidx) : editFF(ff._id, ffidx)"
                    >{{ ff.edit ? i18n.save[iso] : "" }}</b-button
                  >
                </div>
                <div :class="`column is-1`" v-if="ff.edit">
                  <b-button
                    icon-left="times"
                    icon-pack="fas"
                    type="is-danger"
                    expanded
                    @click="cancelOrRemoveFF(ffidx)"
                  ></b-button>
                </div>
                <div class="column is-12 ff-invitation-row" v-if="ff._id">
                  <span class="tag" :class="ffStatusBadge(ffStatus(ff))">
                    {{ i18n[ffStatusLabel(ffStatus(ff))][iso] }}
                  </span>
                  <span
                    class="is-size-7 ml-2 has-text-grey"
                    v-if="ff.FFInvitacion && ff.FFInvitacion.FechaEnvio"
                  >
                    {{ formatFFDate(ff.FFInvitacion.FechaEnvio) }}
                  </span>
                  <b-button
                    v-if="ffCanResend(ff)"
                    size="is-small"
                    type="is-info"
                    icon-left="paper-plane"
                    icon-pack="fas"
                    class="ml-2"
                    @click="resendFFInvitation(ff)"
                  >
                    {{ i18n.friendsFamily__resendInvitation[iso] }}
                  </b-button>
                  <b-button
                    v-if="ffCanRevoke(ff)"
                    size="is-small"
                    type="is-danger"
                    icon-left="ban"
                    icon-pack="fas"
                    class="ml-2"
                    @click="revokeFFInvitation(ff)"
                  >
                    {{ i18n.friendsFamily__revokeInvitation[iso] }}
                  </b-button>
                </div>
              </div>
            </b-tab-item>
            <!-- Fin de  la Pestaña de Detalles -->

            <!-- Pestaña de Contrato -->
            <b-tab-item>
              <template #header>
                <b-icon icon="file-contract" pack="fas" type="is-info"></b-icon>
                <b>{{ i18n.contract[iso] }}</b>
              </template>

              <!-- Botones superiores -->
              <div class="columns">
                <div class="column is-3"></div>
              </div>

              <div class="columns is-multiline">
                <div class="column is-12">
                  <div class="content">
                    <h3>{{ i18n.contract[iso] }}</h3>
                  </div>
                </div>
                <div class="columns is-multiline">
                  <!-- <div class="row-content"> -->
                  <div
                    v-for="item in infoContract"
                    :key="item.key"
                    v-if="item.section === 'contrat'"
                    :class="`column is-${item.size}`"
                  >
                    <b-field
                      label-position="on-border"
                      :label="`${i18n[item.fieldIso][iso]}`"
                      v-if="item.type === 'select' && item.isInfo === false"
                    >
                      <b-select
                        v-model="contract[item.key]"
                        @input="openModal(item.key)"
                        expanded
                      >
                        <option
                          v-if="!item.optionsIsCatalogue"
                          v-for="cc in catalogues[item.options]"
                          :value="cc[item.valueOption]"
                          :key="cc[item.valueOption]"
                        >
                          {{ item.showOption(cc) }}
                        </option>
                        <option
                          v-if="item.optionsIsCatalogue"
                          v-for="cc in catalogues[item.options]"
                          :value="cc[item.valueOption]"
                          :key="cc[item.valueOption]"
                        >
                          {{ item.showOption(cc) }}
                        </option>
                      </b-select>
                    </b-field>

                    <b-field
                      label-position="on-border"
                      :label="`${i18n[item.fieldIso][iso]}`"
                      v-if="item.type === 'text' && item.isInfo === false"
                    >
                      <b-input
                        :value="
                          item.isParse
                            ? item.parse(contract[item.key], contract)
                            : contract[item.key]
                        "
                        disabled
                      >
                      </b-input>
                    </b-field>
                  </div>
                </div>
                <div v-if="contract.HsData && contract.HsData.id_hs_contract" style="display: flex; justify-content: flex-end; width: 100%;">
                      <b-button
                      v-if="contract.HsData && contract.HsData.id_hs_contract"
                      icon-left="hubspot"
                      icon-pack="fab"
                      style="background-color: #ff6b35; border-color: #ff6b35; color: white;"
                      @click="openHubSpotContract"
                      >Ver en HubSpot</b-button
                      >
                </div>
                <div>
                  <!-- Detalles del contrato -->
                  <div class="columns is-multiline" v-if="detailsContract">
                    <div class="column is-12">
                      <div class="content">
                        <h3>{{ i18n.detailsContract[iso] }}</h3>
                      </div>
                    </div>
                    <div
                      class="column is-2"
                      v-for="item in infoDetailsContract"
                    >
                      <table v-if="!item.isCustom">
                        <thead>
                          <tr>
                            <th>{{ i18n[item.fieldIso][iso] }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              {{
                                item.isParse
                                  ? item.parse(
                                      detailsContract[item.key],
                                      detailsContract
                                    )
                                  : detailsContract[item.key]
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-12" v-if="travelVoucher.length > 0">
                  <div class="content">
                    <h3>{{ i18n.incentives[iso] }}</h3>
                  </div>
                  <div>
                    <div class="row-content">
                      <div
                        class="row-content-benef"
                        v-for="(travelVoucher, index) in travelVoucher"
                        :key="travelVoucher._id"
                        style="gap: 1em"
                      >
                        <div v-for="item in infoVoucher" :key="item.key">
                          <b-field
                            label-position="on-border"
                            :label="`${i18n[item.fieldIso][iso]}`"
                            v-if="item.key === 'Monto'"
                          >
                            <b-input
                              type="text"
                              icon-right="times"
                              icon-right-clickable
                              expanded
                              :value="'$ ' + travelVoucher[item.key] + ' USD'"
                              disabled
                            />
                          </b-field>
                          <b-field
                            label-position="on-border"
                            :label="`${i18n[item.fieldIso][iso]}`"
                            v-else
                          >
                            <b-input
                              type="text"
                              icon-right="times"
                              icon-right-clickable
                              expanded
                              :value="travelVoucher[item.key]"
                              disabled
                            />
                          </b-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div class="column is-12">
                  <div class="content">
                    <h3>{{ i18n.beneficiaries[iso] }}</h3>
                  </div>

                  <div
                    class="row-content-benef"
                    v-for="(beneficiaries, index) in beneficiaries"
                    :key="beneficiaries._id"
                  >
                    <div
                      class="column is-half"
                      v-for="item in infoBeneficiares"
                      :key="item.key"
                      label-position="on-border"
                      v-if="!item.isInfo"
                    >
                      <b-field
                        :label="`${i18n[item.fieldIso][iso]} ${
                          item.required ? '*' : ''
                        }`"
                        v-if="item.type === 'text'"
                      >
                        <b-input
                          v-model="beneficiaries[item.key]"
                          type="text"
                          icon-right="times"
                          icon-right-clickable
                          expanded
                          :disabled="!isEdit"
                        ></b-input>
                      </b-field>
                      <b-field
                        :label="`${i18n[item.fieldIso][iso]} ${
                          item.required ? '*' : ''
                        }`"
                        v-if="item.type === 'select' && item.isInfo === false"
                      >
                        <b-select
                          v-model="beneficiaries[item.key]"
                          :disabled="!isEdit"
                        >
                          <option
                            v-if="!item.optionsIsCatalogue"
                            v-for="cc in catalogues[item.options]"
                            :value="cc[item.valueOption]"
                            :key="cc[item.valueOption]"
                          >
                            {{ item.showOption(cc) }}
                          </option>
                          <option
                            v-if="item.optionsIsCatalogue"
                            v-for="cc in catalogues[item.options]"
                            :value="cc[item.valueOption]"
                            :key="cc[item.valueOption]"
                          >
                            {{ item.showOption(cc) }}
                          </option>
                        </b-select>
                      </b-field>
                    </div>
                  </div>

                  <div :class="`column is-${isEdit ? 12 : 12}`"></div>

                  <div class="row-friendsfamily is-2" v-if="isEdit">
                    <b-button
                      style="width: 200px"
                      icon-left="save"
                      icon-pack="fas"
                      type="is-success"
                      expanded
                      @click="editFriendsAndFamily"
                      >{{ i18n.save[iso] }}</b-button
                    >
                    <b-button
                      style="width: 200px"
                      icon-left="times"
                      icon-pack="fas"
                      type="is-danger"
                      expanded
                      @click="cancelEdit"
                      >{{ i18n.cancel[iso] }}</b-button
                    >
                  </div>

                  <div class="row-friendsfamily is-2" v-else>
                    <b-button
                      style="width: 40px"
                      class="btns"
                      icon-left="edit"
                      icon-pack="fas"
                      type="is-info"
                      expanded
                      @click="allowEdit"
                    ></b-button>
                    <b-button
                      style="width: 40px"
                      class="btns"
                      icon-left="plus"
                      icon-pack="fas"
                      type="is-info"
                      expanded
                      :disabled="isDisabled()"
                      @click="openModal('formulario')"
                    ></b-button>
                  </div>
                </div> -->
              </div>

              <b-modal :active.sync="showModal" scroll="keep" has-modal-card>
                <div
                  v-if="this.modalType === 'idioma'"
                  class="card"
                  style="width: 400px"
                >
                  <header class="modal-card-head">
                    <p class="modal-card-title">
                      {{ i18n.changeLenguage[iso] }}
                    </p>
                    <button class="delete" @click="showModal = false"></button>
                  </header>
                  <section class="modal-card-body">
                    <p>{{ i18n.changeIso[iso] }}</p>
                  </section>
                  <footer class="modal-card-foot">
                    <button
                      class="button is-primary"
                      @click="handleButtonStatus(newStatus)"
                    >
                      {{ i18n.accept[iso] }}
                    </button>
                    <button class="button" @click="showModal = false">
                      {{ i18n.cancel[iso] }}
                    </button>
                  </footer>
                </div>

                <div
                  v-if="this.modalType === 'contrato'"
                  class="card"
                  style="width: 500px"
                >
                  <header class="modal-card-head">
                    <p class="modal-card-title">
                      {{ i18n.changeStatusContract[iso] }}
                    </p>
                    <button class="delete" @click="showModal = false"></button>
                  </header>
                  <section class="modal-card-body">
                    <p>{{ i18n.confirmChangeStatusContract[iso] }}</p>
                  </section>
                  <footer class="modal-card-foot">
                    <button
                      class="button is-primary"
                      @click="handleButtonStatus(newStatus)"
                    >
                      {{ i18n.accept[iso] }}
                    </button>
                    <button class="button" @click="showModal = false">
                      {{ i18n.cancel[iso] }}
                    </button>
                  </footer>
                </div>

                <div
                  v-else-if="this.modalType === 'formulario'"
                  class="card"
                  style="width: 500px"
                >
                  <header class="modal-card-head">
                    <p class="modal-card-title">{{ i18n.form[iso] }}</p>
                    <button class="delete" @click="showModal = false"></button>
                  </header>

                  <section class="modal-card-body">
                    <b-field :label="`${i18n.name[iso]} *`">
                      <b-input v-model="newBeneficiario.Nombre"></b-input>
                    </b-field>
                    <b-field :label="`${i18n.lastname[iso]} *`">
                      <b-input
                        v-model="newBeneficiario.ApellidoPaterno"
                      ></b-input>
                    </b-field>

                    <b-field :label="`${i18n.email[iso]} *`">
                      <b-input
                        v-model="newBeneficiario.Email"
                        type="email"
                      ></b-input>
                    </b-field>
                    <b-field :label="`${i18n.cellphone[iso]}`">
                      <b-input
                        v-model="newBeneficiario.Telefono"
                        type="text"
                      ></b-input>
                    </b-field>

                    <b-field
                      :label="`${i18n[item.fieldIso][iso]} ${
                        item.required ? '*' : ''
                      }`"
                      v-for="item in infoBeneficiares"
                      v-if="item.type === 'select' && item.isInfo === false"
                      :key="item.key"
                    >
                      <b-select
                        v-model="newBeneficiario[item.key]"
                      >
                        <option
                          v-if="!item.optionsIsCatalogue"
                          v-for="cc in catalogues[item.options]"
                          :value="cc[item.valueOption]"
                          :key="cc[item.valueOption]"
                        >
                          {{ item.showOption(cc) }}
                        </option>
                        <option
                          v-if="item.optionsIsCatalogue"
                          v-for="cc in catalogues[item.options]"
                          :value="cc[item.valueOption]"
                          :key="cc[item.valueOption]"
                        >
                          {{ item.showOption(cc) }}
                        </option>
                      </b-select>
                    </b-field>
                  </section>

                  <div
                    class="box py-3 px-4 mb-3"
                    style="background: #fff8e1; border-left: 4px solid #f0b429"
                  >
                    <p class="is-size-7 mb-0">
                      {{ i18n.friendsFamily__ageWarningMessage[iso] }}
                    </p>
                  </div>
                  <b-checkbox v-model="newBeneficiarioAgeConfirmed">
                    {{ i18n.friendsFamily__ageWarningCheck[iso] }}
                  </b-checkbox>

                  <footer class="modal-card-foot">
                    <b-button
                      type="is-primary"
                      :disabled="!newBeneficiarioAgeConfirmed"
                      @click="createBenef()"
                      >{{ i18n.send[iso] }}</b-button
                    >
                    <button class="button" @click="showModal = false">
                      {{ i18n.cancel[iso] }}
                    </button>
                  </footer>
                </div>
              </b-modal>

              <hr />
              <div
                v-if="
                  contract && contract.Id && club && club.Plantillas.length > 0
                "
              >
                <ContractMember
                  :contract="contract"
                  :templateDocuments="club.Plantillas"
                  :firmasPlantillas="club.FirmasPlantillas"
                  :member="member"
                  @refreshProfile="getProfile"
                />
              </div>
            </b-tab-item>
            <!-- Fin de  la pestaña Contrato -->

            <!-- Pestaña de membresia -->
            <b-tab-item>
              <template #header>
                <b-icon type="is-info" class="fas fa-id-card"></b-icon>
                <b>{{ i18n.membership[iso] }}</b>
              </template>

             

              <div class="columns is-multiline">
                <div class="column is-12">
                  <div class="content">
                    <h3>{{ i18n.membership[iso] }}</h3>
                  </div>

                  <div class="row-content">
                    <div
                      v-for="item in infoContract"
                      :key="item.key"
                      v-if="item.section === 'membresia'"
                    >
                      <div>
                        <div
                          v-if="item.key === 'membershipStatus' && !item.edit"
                        >
                          <b-field
                            label-position="on-border"
                            :label="`${i18n[item.fieldIso][iso]}`"
                          >
                            <b-input
                              :value="
                                item.isParse
                                  ? item.parse(contract[item.key], contract)
                                  : contract[item.key]
                              "
                            >
                            </b-input>
                          </b-field>
                        </div>
                      </div>

                      <div
                        class="column-content"
                        v-if="
                          item.edit &&
                          !isCap &&
                          (permissions === 'admin' ||
                            allPermissions.includes('edit-contract-fee'))
                        "
                      >
                        <b-field
                          label-position="on-border"
                          :label="`${i18n[item.fieldIso][iso]}`"
                        >
                          <b-input
                            v-if="item.type === 'number'"
                            type="number"
                            v-model="contract[item.key]"
                          >
                          </b-input>
                          <b-input
                            v-if="item.type === 'text'"
                            type="text"
                            v-model="contract[item.key]"
                          >
                          </b-input>
                          <p class="control">
                            <b-button
                              class="is-success"
                              icon-pack="fas"
                              icon-right="save"
                              @click="editFee"
                            ></b-button>
                          </p>
                        </b-field>
                      </div>
                      <div class="column-content" v-else>
                        <b-field
                          label-position="on-border"
                          :label="`${i18n[item.fieldIso][iso]}`"
                        >
                          <b-input
                            :value="
                              item.isParse
                                ? item.parse(contract[item.key], contract)
                                : contract[item.key]
                            "
                            disabled
                          >
                          </b-input>
                        </b-field>
                      </div>
                    </div>
                  </div>
                </div>

                 <div v-if="contract.HsData && contract.HsData.id_hs_membership" style="display: flex; justify-content: flex-end; width: 100%; margin-bottom: 1rem;">
                    <b-button
                    icon-left="hubspot"
                    icon-pack="fab"
                    style="background-color: #ff6b35; border-color: #ff6b35; color: white;"
                    @click="openHubSpotMembership"
                    >Ver en HubSpot</b-button
                    >
              </div>

                <div class="column is-12">
                  <div class="content">
                    <h3>{{ i18n.membershipBenefits[iso] }}</h3>
                  </div>
                  <div>
                    <div class="columns is-multiline">
                      <div v-for="item in infoNumberOfWeek" :key="item.key" class="column is-3">
                        <div>
                          <!-- <b-field
                            label-position="on-border"
                            :label="`${i18n[item.fieldIso][iso]}`"
                            v-if="item.key === 'LastMinuteWeeks'"
                          >
                            <b-input
                              type="text"
                              icon-right="times"
                              icon-right-clickable
                              :value="
                                item.isParse
                                  ? item.key === 'LastMinuteWeeks' &&
                                    item.parse(
                                      numberOfWeek[item.key],
                                      numberOfWeek
                                    ) === 99
                                    ? i18n.unlimited[iso]
                                    : item.parse(
                                        numberOfWeek[item.key],
                                        numberOfWeek
                                      )
                                  : item.key === 'LastMinuteWeeks' &&
                                    numberOfWeek[item.key] === 99
                                  ? i18n.unlimited[iso]
                                  : numberOfWeek[item.key]
                              "
                              :disabled="item.disabled || false"
                            />
                          </b-field> -->

                          <b-field
                            label-position="on-border"
                            :label="`${i18n[item.fieldIso][iso]}`"
                          >
                            <!-- <b-input
                              type="text"
                              icon-right="times"
                              icon-right-clickable
                              v-model="numberOfWeek[item.key]"
                              :disabled="item.disabled || false"
                              v-if="item.type === 'text'"
                            /> -->

                            <b-select
                              v-model="numberOfWeek[item.key]"
                              @input="openModal(item.key)"
                              expanded
                              :disabled="item.disabled || false"
                            >
                              <option
                                v-for="cc in [1,2,3,4,5,6,7,8,9,10]"
                                :value="cc"
                                :key="cc"
                              >
                                {{ cc }}
                              </option>

                              <option
                                :value="99"
                                :key="99"
                              >
                                {{ i18n.unlimited[iso] }}
                              </option>
                              <!-- <option
                                v-if="item.optionsIsCatalogue"
                                v-for="cc in catalogues[item.options]"
                                :value="cc[item.valueOption]"
                                :key="cc[item.valueOption]"
                              >
                                {{ item.showOption(cc) }}
                              </option> -->
                            </b-select>
                          </b-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-12" v-if="!isCap">
                  <div class="content">
                    <h3>{{ i18n.allowAccess[iso] }}</h3>
                  </div>
                </div>
                <div
                  class="column is-3"
                  v-if="
                    !isCap &&
                    (permissions === 'admin' ||
                      allPermissions.includes('edit-contract-webtemporary'))
                  "
                >
                  <b-field
                    label-position="on-border"
                    :label="i18n.accessWebMember[iso]"
                  >
                    <b-select
                      expanded
                      v-model="AccesoWebSocio"
                      @input="editAccesoWebSocio"
                    >
                      <!-- <option
                        :value="!contract.AccesoWebSocio"
                      >
                        {{ i18n.allow[iso] }}
                      </option> -->
                      <option
                        value="si"
                      >
                        {{ i18n.allow[iso] }}
                      </option>
                      <option value="si-sin-validar">
                        {{ i18n.allowWithoutValidate[iso] }}
                      </option>
                      <option value="no">
                        {{ i18n.notAllow[iso] }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
                <div
                  class="column is-2"
                  v-if="
                    !isCap &&
                    (permissions === 'admin' ||
                      allPermissions.includes('edit-contract-mydeals'))
                  "
                >
                  <b-field
                    label-position="on-border"
                    :label="i18n.myDealsAccess[iso]"
                  >
                    <b-select
                      expanded
                      v-model="contract.AccesoMyDeals"
                      @input="editAccesoMyDeals"
                    >
                      <!-- <option :value="null"></option> -->
                      <option
                        :value="null"
                        v-if="
                          contract.AccesoMyDeals !== true &&
                          contract.AccesoMyDeals !== false
                        "
                      >
                        {{ i18n.notAllow[iso] }}
                      </option>
                      <option :value="true">
                        {{ i18n.allow[iso] }}
                      </option>
                      <option :value="false">
                        {{ i18n.notAllow[iso] }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
              </div>
            </b-tab-item>
            <!-- Fin pestaña de membresia -->

            <!-- Pestaña de Reservaciones -->
            <b-tab-item>
              <template #header>
                <b-icon icon="plane-departure" pack="fas" type="is-info"></b-icon>
                <b>{{ i18n.bookings[iso] }}</b>
              </template>

              <MemberBookings :loginId="contract.LoginID || ''" :iso="iso" :active="activeTab === 3" />
            </b-tab-item>

            <!-- Pestaña de renovaciones -->
            <b-tab-item :visible="!isCap">
              <template #header>
                <b-icon icon="sync-alt" pack="fas" type="is-info"></b-icon>
                <b>{{ i18n.renovations[iso] }}</b>
              </template>

              <div>
                <p class="subtitle has-text-weight-bold">
                  {{ i18n.subscription[iso] }}
                </p>
                <hr />
                <div
                  class="columns is-vcentered is-justify-content-space-between"
                  style="padding-inline-start: 40px; padding-inline-end: 40px"
                >
                  <div class="is-flex is-align-items-center">
                    <div class="custom-icon">
                      <i class="fas fa-chart-pie fa-2x"></i>
                    </div>
                    <div class="ml-2">
                      <div class="is-flex is-align-items-center">
                        <p class="mr-2 has-text-weight-bold">
                          {{ i18n.annuaPlan[iso] }}
                        </p>
                        <b-tag :type="isExpired ? 'is-danger' : 'is-success'">
                          {{ isExpired ? i18n.expired[iso] : i18n.active[iso] }}
                        </b-tag>
                      </div>
                      <div
                        v-for="item in infoContract"
                        v-if="item.key === 'FechaRenovacion'"
                      >
                        <p
                          class="has-text-weight-medium"
                          v-if="item.type === 'date'"
                        >
                          {{ formattedAnnualPlan(item) }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="column is-2">
                    <b-dropdown aria-role="list" expanded>
                      <template #trigger="{ active }">
                        <b-button
                          :label="i18n.actions[iso]"
                          type="is-info"
                          :icon-right="active ? 'menu-up' : 'menu-down'"
                        />
                      </template>

                      <b-tooltip
                        :label="
                          payLink && payLink.length > 0
                            ? i18n.paymentLink__msg1[iso]
                            : ''
                        "
                        :always="payLink && payLink.length > 0 && true"
                        :active="payLink && payLink.length > 0 && true"
                        type="is-warning"
                        position="is-left"
                      >
                        <b-dropdown-item
                          aria-role="listitem"
                          @click="openModal('renovar')"
                          >{{ i18n.paymentLink[iso] }}</b-dropdown-item
                        >
                      </b-tooltip>
                      <b-dropdown-item
                        aria-role="listitem"
                        @click="openModal('renovarDiferido')"
                        :disabled="
                          (payLink && payLink.length > 0 && true) ||
                          paymentsDeferred.length > 0
                        "
                        >{{ i18n.paymentLinkDeferred[iso] }}</b-dropdown-item
                      >
                      <b-dropdown-item
                        aria-role="listitem"
                        @click="openModal('addPayment')"
                        :disabled="paymentsDeferred.length > 0"
                        >{{ i18n.addPayment[iso] }}</b-dropdown-item
                      >
                      <b-dropdown-item
                        :disabled="paymentsDeferred.length > 0"
                        aria-role="listitem"
                        @click="openModal('addPaymentDeferred')"
                        >{{ i18n.addPaymentDeferred[iso] }}</b-dropdown-item
                      >
                      <b-dropdown-item
                        aria-role="listitem"
                        @click="ModalOnlinePayment = true"
                        >{{ i18n.generateURLOnline[iso] }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>

                  <!-- <div
                    class="column is-3"
                    v-if="$checkPermission('renew-contract')"
                  >
                    <b-button
                      icon-left="sync"
                      icon-pack="fas"
                      type="is-info"
                      expanded
                      @click="openModal('renovar')"
                    >
                      {{ i18n.renew[iso] }}
                    </b-button>
                  </div> -->
                </div>
                <hr />
              </div>

              <div
                style="margin-top: 45px"
                v-if="paymentsDeferred && paymentsDeferred.length > 0"
              >
                <p class="subtitle has-text-weight-bold">
                  {{ i18n.paymentsDeferred[iso] }}
                </p>
                <b-table
                  :height="200"
                  :sticky-header="true"
                  :data="paymentsDeferred"
                  :striped="false"
                  :narrowed="isNarrowed"
                  :hoverable="false"
                  :focusable="isFocusable"
                  detailed
                >
                  <template #detail="props">
                    <b-table
                      :data="props.row.listPayments"
                      :bordered="true"
                      :striped="false"
                      :narrowed="isNarrowed"
                      :hoverable="true"
                      :focusable="isFocusable"
                    >
                      <b-table-column
                        field="stripeId"
                        :label="i18n.payConfirm[iso]"
                       
                        centered
                        v-slot="propss"
                      >
                        {{ propss.row.stripeId || "" }}
                      </b-table-column>

                      <b-table-column
                        field="type"
                        :label="i18n.paymentMethod[iso]"
                       
                        centered
                        v-slot="propss"
                      >
                        {{ propss.row.type || "" }}
                      </b-table-column>

                      <b-table-column
                        field="createdAtMs"
                        :label="i18n.payDay[iso]"
                       
                        centered
                        v-slot="propss"
                      >
                        {{
                          propss.row.createdAtMs
                            ? parseDate(propss.row.createdAtMs)
                            : ""
                        }}
                      </b-table-column>
                      <b-table-column
                        field="amount"
                        :label="i18n.amountPaid[iso]"
                       
                        centered
                        v-slot="propss"
                      >
                        $ {{ propss.row.amount || "" }} USD
                      </b-table-column>
                    </b-table>
                  </template>

                  <!-- <b-table-column
                    field="Referencia"
                    :label="i18n.payConfirm[iso]"
                   
                    centered
                    v-slot="props"
                  >
                    {{ props.row.main.stripeId || "" }}
                  </b-table-column>

                  <b-table-column
                    field="FechaPago"
                    :label="i18n.payDay[iso]"
                   
                    centered
                    v-slot="props"
                  >
                    {{
                      props.row.main.createdAtMs
                        ? parseDate(props.row.main.createdAtMs)
                        : ""
                    }}
                  </b-table-column> -->

                  <b-table-column
                    field="Anualidades"
                    :label="i18n.subtype[iso]"
                   
                    centered
                    v-slot="props"
                  >
                    {{ props.row.main.moreInfo.SubTipo || "" }}
                  </b-table-column>

                  <b-table-column
                    field="Anualidades"
                    :label="i18n.years[iso]"
                   
                    centered
                    v-slot="props"
                  >
                    {{ props.row.main.moreInfo.Years || "" }}
                  </b-table-column>

                  <b-table-column
                    field="Period"
                    :label="i18n.startEndPeriod[iso]"
                   
                    centered
                    v-slot="props"
                  >
                    <div>
                      {{
                        parseDate(
                          props.row.main.moreInfo.FechaInicioPeriodo || ""
                        )
                      }}{{
                        props.row.main.moreInfo.FechaFinPeriodo
                          ? " - " +
                            parseDate(props.row.main.moreInfo.FechaFinPeriodo)
                          : ""
                      }}
                    </div>
                  </b-table-column>

                  <!-- <b-table-column
                    field="Cargo"
                    :label="i18n.amountPaid[iso]"
                   
                    centered
                    v-slot="props"
                  >
                    $ {{ props.row.main.amount || "" }} USD
                  </b-table-column> -->

                  <b-table-column
                    field="Cargo"
                    :label="i18n.missingAmount[iso]"
                   
                    centered
                    v-slot="props"
                  >
                    $ {{ props.row.main.missingAmount || "0" }} USD
                  </b-table-column>

                  <b-table-column
                    field="Cargo"
                    :label="i18n.totalToPayment[iso]"
                   
                    centered
                    v-slot="props"
                  >
                    $ {{ props.row.main.MontoTotalPagoDiferido || "0" }} USD
                  </b-table-column>

                  <b-table-column
                    field="Cargo"
                    :label="i18n.createdBy[iso]"
                   
                    centered
                    v-slot="props"
                  >
                    {{ props.row.main.CreadoPor || "" }}
                  </b-table-column>

                  <b-table-column
                    label="Actions"
                    v-slot="props"
                    centered
                   
                  >
                    <!-- <b-tooltip
                      type="is-info"
                      position="is-left"
                      v-if="props.row.main.moreInfo.SubTipo === 'manual'"
                    >
                      <b-button
                        icon-left="plus"
                        icon-pack="fas"
                        size="is-small"
                        type="is-info"
                        @click="openModal('addPaymentDeferred__step1')"
                      ></b-button>
                      <template v-slot:content>
                        <b>{{ i18n.addPayment[iso] }}</b></template
                      >
                    </b-tooltip> -->
                    <!-- v-if="props.row.main.moreInfo.SubTipo === 'individual'" -->
                    <!-- <b-tooltip type="is-info" position="is-left">
                      <b-button
                        icon-left="plus"
                        icon-pack="fas"
                        size="is-small"
                        type="is-info"
                        @click="openModal('renovarDiferido__step1')"
                      ></b-button>
                      <template v-slot:content>
                        <b>{{ i18n.paymentLink[iso] }}</b></template
                      >
                    </b-tooltip> -->
                    <!-- <b-tooltip type="is-success" position="is-left">
                      <b-button
                        icon-left="check"
                        icon-pack="fas"
                        size="is-small"
                        type="is-success"
                        @click="openModal('addPaymentDeferred__step2')"
                      ></b-button>
                      <template v-slot:content>
                        <b>{{ i18n.completePayment[iso] }}</b></template
                      >
                    </b-tooltip> -->

                    <b-dropdown aria-role="list" expanded>
                      <template #trigger="{ active }">
                        <b-button
                          :label="i18n.addPayment[iso]"
                          type="is-info"
                          :icon-right="active ? 'menu-up' : 'menu-down'"
                          size="is-small"
                        />
                      </template>

                      <b-dropdown-item
                        aria-role="listitem"
                        @click="openModal('addPaymentDeferred__step1')"
                        >{{ i18n.payManual[iso] }}</b-dropdown-item
                      >
                      <b-dropdown-item
                        aria-role="listitem"
                        @click="openModal('renovarDiferido__step1')"
                        >{{ i18n.paymentLink[iso] }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </b-table-column>
                </b-table>
              </div>

              <div style="margin-top: 45px">
                <p class="subtitle has-text-weight-bold">
                  {{ i18n.payments[iso] }}
                </p>
                <b-table
                  :height="400"
                  :sticky-header="true"
                  :data="sortedRenovations"
                  :striped="false"
                  :narrowed="isNarrowed"
                  :hoverable="false"
                  :focusable="isFocusable"
                  :row-class="(row, index) => row.isPayLink && 'is-info'"
                  detailed
                >
                  <template #detail="props">
                    <b-table
                      :data="props.row.payments"
                      :bordered="true"
                      :striped="false"
                      :narrowed="isNarrowed"
                      :hoverable="true"
                      :focusable="isFocusable"
                    >
                      <b-table-column
                        field="stripeId"
                        :label="i18n.payConfirm[iso]"
                       
                        centered
                        v-slot="propss"
                      >
                        {{ propss.row.stripeId ||propss.row.Referencia || "" }}
                      </b-table-column>

                      <b-table-column
                        field="type"
                        :label="i18n.paymentMethod[iso]"
                       
                        centered
                        v-slot="propss"
                      >
                        {{ propss.row.type || "stripe" }}
                      </b-table-column>

                      <b-table-column
                        field="createdAtMs"
                        :label="i18n.payDay[iso]"
                       
                        centered
                        v-slot="propss"
                      >
                        {{
                          propss.row.createdAtMs || propss.row.FechaCreacion
                            ? parseDate(propss.row.createdAtMs || propss.row.FechaCreacion, false)
                            : ""
                        }}
                      </b-table-column>
                      <b-table-column
                        field="amount"
                        :label="i18n.amountPaid[iso]"
                       
                        centered
                        v-slot="propss"
                      >
                        $ {{ propss.row.amount || propss.row.Monto || "" }} USD
                      </b-table-column>
                    </b-table>
                  </template>

                  <b-table-column
                    field="SolicitudId"
                    :label="i18n.linkType[iso]"
                   
                    centered
                    v-slot="props"
                  >
                    <b-tag :type="props.row.Rollback ? 'is-danger' : 'is-info'" v-if="props.row.EsDiferido">{{
                      props.row.Rollback ? i18n.refund[iso] : i18n.deferred[iso]
                    }}</b-tag>
                    <b-tag :type="props.row.Rollback ? 'is-danger' : 'is-success'" v-else>{{
                      props.row.Rollback ? i18n.refund[iso] : i18n.notDeferred[iso]
                    }}</b-tag>
                  </b-table-column>

                  <b-table-column
                    field="SolicitudId"
                    label="Folio"
                   
                    centered
                    v-slot="props"
                  >
                    {{ props.row.SolicitudId }}
                  </b-table-column>

                  <b-table-column
                    field="FechaPago"
                    :label="i18n.payDay[iso]"
                   
                    centered
                    v-slot="props"
                  >
                    {{
                      props.row.FechaPago
                        ? parseDate(props.row.FechaPago, false)
                        : ""
                    }}
                  </b-table-column>

                  <b-table-column
                    field="Anualidades"
                    :label="i18n.periods[iso]"
                   
                    centered
                    v-slot="props"
                  >
                    {{ props.row.Anualidades }}
                  </b-table-column>

                  <b-table-column
                    field="Period"
                    :label="i18n.startEndPeriod[iso]"
                   
                    centered
                    v-slot="props"
                  >
                    <div>
                      {{ parseDate(props.row.FechaInicioPeriodo || "")
                      }}{{
                        props.row.FechaFinPeriodo
                          ? " - " + parseDate(props.row.FechaFinPeriodo)
                          : ""
                      }}
                    </div>
                  </b-table-column>
                  <!-- <b-table-column
                  field="FechaInicioPeriodo"
                  :label="i18n.dateStartPeriod[iso]"
                 
                  centered
                  v-slot="props"
                >
                  {{
                    props.row.FechaInicioPeriodo
                      ? parseDate(props.row.FechaInicioPeriodo)
                      : ""
                  }}
                </b-table-column>

                <b-table-column
                  field="FechaFinPeriodo"
                  :label="i18n.dateEndPeriod[iso]"
                 
                  centered
                  v-slot="props"
                >
                  {{
                    props.row.FechaFinPeriodo
                      ? parseDate(props.row.FechaFinPeriodo)
                      : ""
                  }}
                </b-table-column> -->

                  <b-table-column
                    field="ConfirmacionPago"
                    :label="i18n.payConfirm[iso]"
                   
                    centered
                    v-slot="props"
                  >
                    <div class="short-text">
                      {{ props.row.ConfirmacionPago || "" }}
                    </div>
                  </b-table-column>

                  <b-table-column
                    field="Cargo"
                    :label="i18n.amount[iso]"
                   
                    centered
                    v-slot="props"
                  >
                    $ {{ props.row.Cargo }} USD
                  </b-table-column>

                  <b-table-column
                    field="Codigo"
                    :label="i18n.user[iso]"
                   
                    centered
                    v-slot="props"
                  >
                    {{
                      props.row.MemberId === "na"
                        ? "Online"
                        : props.row.MemberId
                    }}
                  </b-table-column>
                  <!-- <b-table-column
                  field="Comentarios"
                  :label="i18n.comments[iso]"
                 
                  centered
                  v-slot="props"
                >
                  {{ props.row.Comentarios || "" }}
                </b-table-column> -->
                  <b-table-column
                    label="Actions"
                    v-slot="{ row }"
                    centered
                   
                  >
                    <div v-if="!row.isPayLink">
                      <!-- <b-tooltip type="is-success is-light">
                        <b-button
                          icon-left="eye"
                          icon-pack="fas"
                          size="is-small"
                          type="is-success is-light"
                          @click="goPath(row)"
                          style="margin-right: 10px"
                        ></b-button>
                        <template v-slot:content>
                          <b>{{ i18n.paymantDetails[iso] }}</b></template
                        >
                      </b-tooltip> -->
                    </div>
                    <div v-if="row.isPayLink">
                      <b-tooltip type="is-success" position="is-left">
                        <b-button
                          icon-left="copy"
                          icon-pack="fas"
                          size="is-small"
                          type="is-success"
                          @click="copyPaymentLink(row.PayLinkId)"
                          style="margin-right: 10px"
                        ></b-button>
                        <template v-slot:content>
                          <b>{{ i18n.copyPaymentLink[iso] }}</b></template
                        >
                      </b-tooltip>
                      <b-tooltip type="is-info" position="is-left">
                        <b-button
                          icon-left="paper-plane"
                          icon-pack="fas"
                          size="is-small"
                          type="is-info"
                          @click="reSendPaymentLink(row.PayLinkId)"
                          style="margin-right: 10px"
                          :loading="loadingResendPaymentLink === row.PayLinkId"
                        ></b-button>
                        <template v-slot:content>
                          <b>{{ i18n.sendLinkPayment[iso] }}</b></template
                        >
                      </b-tooltip>
                      <b-tooltip type="is-danger" position="is-left">
                        <b-button
                          icon-left="times"
                          icon-pack="fas"
                          size="is-small"
                          type="is-danger"
                          @click="cancelPaymentLink(row.PayLinkId)"
                          :loading="loadingCancelPaymentLink === row.PayLinkId"
                        ></b-button>
                        <template v-slot:content>
                          <b>{{ i18n.cancelLinkPayment[iso] }}</b></template
                        >
                      </b-tooltip>
                    </div>
                  </b-table-column>
                </b-table>
              </div>

              <template>
                <b-modal
                  :active.sync="showModal"
                  scroll="keep"
                  has-modal-card
                  v-if="modalType === 'renovar'"
                >
                  <div
                    v-if="modalStep === 'renew'"
                    class="card"
                    style="width: 600px"
                  >
                    <header class="modal-card-head">
                      <p class="modal-card-title">{{ i18n.renew[iso] }}</p>
                      <button
                        class="delete"
                        @click="showModal = false"
                      ></button>
                    </header>
                    <section class="modal-card-body">
                      <b-field
                        label-position="on-border"
                        :label="i18n.periods[iso]"
                      >
                        <b-select
                          v-model="yearsRenew"
                          placeholder="Select Periods"
                          expanded
                        >
                          <option
                            v-for="option in periodOptions"
                            :key="option.value"
                            :value="option.value"
                            class="p-3"
                          >
                            {{ option.label }}
                          </option>
                        </b-select></b-field
                      >

                      <!-- <b-field
                        label-position="on-border"
                        style="margin-bottom: 25px"
                      >
                        <p
                          v-if="yearsRenew"
                          class="has-text-weight-bold mt-3 has-background-success mb-2 p-2 has-text-white"
                          style="
                            width: 60%;
                            border-radius: 5px;
                            margin-bottom: 25px;
                          "
                        >
                          De
                          {{
                            parseDate(
                              contract.FechaRenovacion || contract.FechaRegistro
                            )
                          }}
                          A
                          {{
                            parseDate(
                              calculateNewExpirationDate(
                                contract.FechaRenovacion || contract.FechaRegistro,
                                yearsRenew
                              )
                            )
                          }}
                        </p>
                      </b-field> -->

                      <div class="columns">
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="i18n.promotionCode[iso]"
                          >
                            <b-select v-model="cuponRenew" expanded>
                              <option
                                v-for="option in cupons"
                                :key="option.code"
                                :value="option.code"
                              >
                                <span
                                  v-if="
                                    option.discount === 0 &&
                                    option.code !== 'RESET'
                                  "
                                ></span>
                                <span v-else-if="option.code === 'RESET'">
                                  {{ option.code }}
                                </span>
                                <span v-else
                                  >{{ option.code }} ({{
                                    option.discount
                                  }}%)</span
                                >
                              </option>
                            </b-select></b-field
                          >
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="i18n.sendMailToRenewal[iso]"
                          >
                            <b-select v-model="PrincipalPagador" expanded>
                              <option :value="'T'">
                                {{ i18n.owner[iso] }}
                              </option>
                              <option :value="'C'">
                                {{ i18n.coOwner[iso] }}
                              </option>
                              <option :value="'B'">
                                {{ i18n.both[iso] }}
                              </option>
                            </b-select></b-field
                          >
                        </div>
                      </div>

                      <div class="columns">
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="i18n.amount[iso]"
                          >
                            <b-input
                              type="text"
                              :value="totalAmountPaymentLink"
                              disabled
                            ></b-input>
                          </b-field>
                        </div>
                      </div>

                      <div
                        class="columns"
                        v-if="
                          permissions === 'admin' ||
                          allPermissions.includes('reset-renewal')
                        "
                      >
                        <div
                          class="column is-6"
                          style="padding-left: 60px; padding-top: 15px"
                        >
                          <b-tooltip
                            :label="i18n.forgiveDebt[iso]"
                            position="is-right"
                            type="is-info"
                          >
                            <b-field>
                              <b-switch
                                v-model="codeReset"
                                type="is-info"
                                size="is-medium"
                              >
                                <b>RESET</b>
                              </b-switch>
                            </b-field>
                          </b-tooltip>
                          <span v-if="codeReset">
                            <br />
                            <b-tag type="is-info is-light"
                              ><p>
                                <b>
                                  {{ i18n.condoned[iso] }}:
                                  {{
                                    periodOptions.find(
                                      (p) => p.value === yearsRenew
                                    ).YearsCondoned
                                  }}
                                  {{ i18n.years[iso] }}</b
                                >
                              </p></b-tag
                            >
                            <br />
                            <!-- <b-tag type="is-primary is-light"
                              ><p><b>{{
                                  periodOptions.find(
                                    (p) => p.value === yearsRenew
                                  ).showPeriodIfCodeReset
                                }}</b></p
                            ></b-tag> -->
                          </span>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="i18n.renewalAssign[iso]"
                          >
                            <b-select expanded v-model="agentEmail">
                              <option
                                :value="user.Email"
                                v-for="user in usersStaff"
                              >
                                {{ user.Nombre }} {{ user.Apellido }}
                              </option>
                              <!-- <option
                                value="dev@system.com"
                              >
                                Online
                              </option> -->
                            </b-select>
                          </b-field>
                        </div>
                      </div>

                      <!-- <b-field
                        label-position="on-border"
                        :label="i18n.promotionCode[iso]"
                      >
                        <b-select v-model="cuponRenew" expanded>
                          <option
                            v-for="option in cupons"
                            :key="option.code"
                            :value="option.code"
                          >
                            {{ option.code }}
                          </option>
                        </b-select></b-field
                      > -->

                      <!-- <b-field grouped style="margin-bottom: 25px">
                        <b-field
                          label-position="on-border"
                          :label="i18n.promotionCode[iso]"
                          expanded
                        >
                          <b-input type="text" v-model="cuponRenew"></b-input>
                        </b-field>
                        <b-field expanded>
                          <b-button class="is-primary" expanded>
                            {{ i18n.apply[iso] }}
                          </b-button>
                        </b-field>
                      </b-field> -->
                    </section>

                    <footer class="modal-card-foot">
                      <button class="button" @click="showModal = false">
                        {{ i18n.cancel[iso] }}
                      </button>
                      <b-button
                        :loading="loadingButtonRenewalPaymentLink"
                        type="is-success"
                        @click="sendRenew(yearsRenew, cuponRenew)"
                        >{{ i18n.create[iso] }}</b-button
                      >
                      <!--  <button
                        class="button is-primary"
                        @click="modalStep = 'options'"
                      >
                        Cambiar
                      </button> -->
                    </footer>
                  </div>

                  <div
                    v-if="modalStep === 'options'"
                    class="card"
                    style="width: 500px"
                  >
                    <header class="modal-card-head">
                      <p class="modal-card-title">{{ i18n.options[iso] }}</p>
                      <button
                        class="delete"
                        @click="showModal = false"
                      ></button>
                    </header>
                    <section class="modal-card-body">
                      <p>{{ i18n.selectAnOption[iso] }}</p>
                      <div class="buttons mt-3">
                        <div class="button-wrapper">
                          <b-button
                            @click="handleButtonClick('copy')"
                            :type="
                              selectedOption === 'copy' ? 'is-success' : ''
                            "
                          >
                            <i class="fas fa-copy"></i>
                          </b-button>
                        </div>

                        <div class="button-wrapper">
                          <b-button
                            @click="handleButtonClick('sms')"
                            :type="selectedOption === 'sms' ? 'is-success' : ''"
                          >
                            <i class="fas fa-comment-alt"></i>
                          </b-button>
                        </div>
                      </div>

                      <div
                        v-if="selectedOption === 'copy'"
                        class="has-text-centered mt-4"
                      >
                        <hr />
                        <p class="has-text-grey renewUrl">
                          <b-icon icon="link" class="mr-1"></b-icon>
                          <span class="truncated-url">{{ renewalUrl }}</span>
                        </p>
                      </div>

                      <div v-if="selectedOption === 'sms'" class="mt-4">
                        <div>
                          <hr />
                          <div>
                            <p class="subtitle">Sms</p>
                            <b-field grouped style="margin-bottom: 18px">
                              <b-field
                                expanded
                                label-position="on-border"
                                label="Owner"
                              >
                                <b-input
                                  :value="
                                    member.LadaTelefono && member.Telefono
                                      ? `+${member.LadaTelefono} ${member.Telefono}`
                                      : ''
                                  "
                                  type="text"
                                  disabled
                                  expanded
                                ></b-input>
                              </b-field>

                              <b-field
                                expanded
                                label-position="on-border"
                                label="Co-Owner"
                              >
                                <b-input
                                  :value="
                                    coOwner.LadaTelefono && coOwner.Telefono
                                      ? `+${coOwner.LadaTelefono} ${coOwner.Telefono}`
                                      : ''
                                  "
                                  type="text"
                                  disabled
                                  expanded
                                ></b-input>
                              </b-field>
                            </b-field>

                            <b-field grouped>
                              <b-field
                                label-position="on-border"
                                label="Phone Number"
                                expanded
                              >
                                <b-input
                                  placeholder="Ingresar número"
                                  type="phone"
                                  v-model="newPhoneNumber"
                                  expanded
                                ></b-input>
                              </b-field>
                              <b-field>
                                <b-button type="is-primary" @click="addNumber"
                                  >Agregar</b-button
                                >
                              </b-field>
                            </b-field>
                            <div
                              class="is-half"
                              v-for="(phone, index) in phones"
                              :key="index"
                              style="margin-bottom: 9px"
                            >
                              <b-field grouped>
                                <b-field expanded>
                                  <b-input
                                    :value="phone"
                                    disabled
                                    type="text"
                                    expanded
                                  ></b-input>
                                </b-field>
                                <b-field>
                                  <b-button
                                    type="is-danger"
                                    @click="removeNumber(index)"
                                    expanded
                                    ><b-icon
                                      icon="trash"
                                      class="fas fa-trash"
                                    ></b-icon
                                  ></b-button>
                                </b-field>
                              </b-field>
                            </div>
                          </div>
                          <hr />
                          <div>
                            <p class="subtitle">{{ i18n.email[iso] }}</p>
                            <b-field grouped style="margin-bottom: 18px">
                              <b-field
                                expanded
                                label-position="on-border"
                                label="Owner"
                              >
                                <b-input
                                  :value="member.Email ? member.Email : ''"
                                  type="text"
                                  disabled
                                  expanded
                                ></b-input>
                              </b-field>

                              <b-field
                                expanded
                                label-position="on-border"
                                label="Co-Owner"
                              >
                                <b-input
                                  :value="coOwner.Email ? coOwner.Email : ''"
                                  type="text"
                                  disabled
                                  expanded
                                ></b-input>
                              </b-field>
                            </b-field>

                            <b-field grouped style="margin-bottom: 15px">
                              <b-field
                                label-position="on-border"
                                :label="i18n.email[iso]"
                                expanded
                              >
                                <b-input
                                  placeholder="Ingresar correo"
                                  type="email"
                                  v-model="newEmail"
                                  expanded
                                ></b-input>
                              </b-field>
                              <b-field>
                                <b-button type="is-primary" @click="addEmails"
                                  >Agregar</b-button
                                >
                              </b-field>
                            </b-field>

                            <div
                              class="is-half"
                              v-for="(email, index) in emails"
                              :key="index"
                              style="margin-bottom: 9px"
                            >
                              <b-field grouped>
                                <b-field expanded>
                                  <b-input
                                    :value="email"
                                    disabled
                                    type="text"
                                    expanded
                                  ></b-input>
                                </b-field>
                                <b-field>
                                  <b-button
                                    type="is-danger"
                                    @click="removeEmail(index)"
                                    expanded
                                    ><b-icon
                                      icon="trash"
                                      class="fas fa-trash"
                                    ></b-icon
                                  ></b-button>
                                </b-field>
                              </b-field>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    <footer class="modal-card-foot">
                      <!-- <button
                        class="button is-primary"
                        @click="sendRenew(yearsRenew, cuponRenew)"
                      >
                        {{ i18n.accept[iso] }}
                      </button> -->
                      <button class="button" @click="modalStep = 'renew'">
                        {{ i18n.goBack[iso] }}
                      </button>
                      <button
                        class="button is-primary"
                        @click="showModal = false"
                      >
                        {{ i18n.accept[iso] }}
                      </button>
                    </footer>
                  </div>
                </b-modal>
              </template>
              <template>
                <b-modal
                  :active.sync="showModal"
                  scroll="keep"
                  has-modal-card
                  v-if="modalType === 'renovarDiferido'"
                >
                  <div
                    v-if="modalStep === 'renew'"
                    class="card"
                    style="width: 600px"
                  >
                    <header class="modal-card-head">
                      <p class="modal-card-title">
                        {{ i18n.paymentLinkDeferred[iso] }}
                      </p>
                      <button
                        class="delete"
                        @click="showModal = false"
                      ></button>
                    </header>
                    <section class="modal-card-body">
                      <b-field
                        label-position="on-border"
                        :label="i18n.periods[iso]"
                      >
                        <b-select
                          v-model="yearsRenew"
                          placeholder="Select Periods"
                          expanded
                        >
                          <option
                            v-for="option in periodOptions"
                            :key="option.value"
                            :value="option.value"
                            class="p-3"
                          >
                            {{ option.label }}
                          </option>
                        </b-select></b-field
                      >

                      <div class="columns">
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="i18n.promotionCode[iso]"
                          >
                            <b-select v-model="cuponRenew" expanded>
                              <option
                                v-for="option in cupons"
                                :key="option.code"
                                :value="option.code"
                              >
                                <span
                                  v-if="
                                    option.discount === 0 &&
                                    option.code !== 'RESET'
                                  "
                                ></span>
                                <span v-else-if="option.code === 'RESET'">
                                  {{ option.code }}
                                </span>
                                <span v-else
                                  >{{ option.code }} ({{
                                    option.discount
                                  }}%)</span
                                >
                              </option>
                            </b-select></b-field
                          >
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="i18n.sendMailToRenewal[iso]"
                          >
                            <b-select v-model="PrincipalPagador" expanded>
                              <option :value="'T'">
                                {{ i18n.owner[iso] }}
                              </option>
                              <option :value="'C'">
                                {{ i18n.coOwner[iso] }}
                              </option>
                              <option :value="'B'">
                                {{ i18n.both[iso] }}
                              </option>
                            </b-select></b-field
                          >
                        </div>
                      </div>

                      <div class="columns">
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="i18n.totalToPayment[iso]"
                          >
                            <b-input
                              type="text"
                              :value="totalAmountPaymentLink"
                              disabled
                            ></b-input>
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="i18n.initialPayment[iso]"
                          >
                            <b-numberinput
                              v-model="AbonoInicialDeferred"
                              :controls="false"
                              step="0.01"
                            >
                            </b-numberinput>
                            <!-- <b-input
                              type="text"
                              :value=""
                            ></b-input> -->
                          </b-field>
                        </div>
                      </div>

                      <div
                        class="columns"
                        v-if="
                          permissions === 'admin' ||
                          allPermissions.includes('reset-renewal')
                        "
                      >
                        <div
                          class="column is-6"
                          style="padding-left: 60px; padding-top: 15px"
                        >
                          <b-tooltip
                            :label="i18n.forgiveDebt[iso]"
                            position="is-right"
                            type="is-info"
                          >
                            <b-field>
                              <b-switch
                                v-model="codeReset"
                                type="is-info"
                                size="is-medium"
                              >
                                <b>RESET</b>
                              </b-switch>
                            </b-field>
                          </b-tooltip>
                          <span v-if="codeReset">
                            <br />
                            <b-tag type="is-info is-light"
                              ><p>
                                <b>
                                  {{ i18n.condoned[iso] }}:
                                  {{
                                    periodOptions.find(
                                      (p) => p.value === yearsRenew
                                    ).YearsCondoned
                                  }}
                                  {{ i18n.years[iso] }}</b
                                >
                              </p></b-tag
                            >
                            <br />
                            <!-- <b-tag type="is-primary is-light"
                              ><p><b>{{
                                  periodOptions.find(
                                    (p) => p.value === yearsRenew
                                  ).showPeriodIfCodeReset
                                }}</b></p
                            ></b-tag> -->
                          </span>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="i18n.renewalAssign[iso]"
                          >
                            <b-select expanded v-model="agentEmail">
                              <option
                                :value="user.Email"
                                v-for="user in usersStaff"
                              >
                                {{ user.Nombre }} {{ user.Apellido }}
                              </option>
                              <!-- <option
                                value="dev@system.com"
                              >
                                Online
                              </option> -->
                            </b-select>
                          </b-field>
                        </div>
                      </div>
                    </section>

                    <footer class="modal-card-foot">
                      <button class="button" @click="showModal = false">
                        {{ i18n.cancel[iso] }}
                      </button>
                      <b-button
                        :loading="loadingButtonRenewalPaymentLink"
                        type="is-success"
                        @click="sendRenewDeferred(yearsRenew, cuponRenew, true)"
                        >{{ i18n.create[iso] }}</b-button
                      >
                    </footer>
                  </div>

                  <div
                    v-if="modalStep === 'options'"
                    class="card"
                    style="width: 500px"
                  >
                    <header class="modal-card-head">
                      <p class="modal-card-title">{{ i18n.options[iso] }}</p>
                      <button
                        class="delete"
                        @click="showModal = false"
                      ></button>
                    </header>
                    <section class="modal-card-body">
                      <p>{{ i18n.selectAnOption[iso] }}</p>
                      <div class="buttons mt-3">
                        <div class="button-wrapper">
                          <b-button
                            @click="handleButtonClick('copy')"
                            :type="
                              selectedOption === 'copy' ? 'is-success' : ''
                            "
                          >
                            <i class="fas fa-copy"></i>
                          </b-button>
                        </div>

                        <div class="button-wrapper">
                          <b-button
                            @click="handleButtonClick('sms')"
                            :type="selectedOption === 'sms' ? 'is-success' : ''"
                          >
                            <i class="fas fa-comment-alt"></i>
                          </b-button>
                        </div>
                      </div>

                      <div
                        v-if="selectedOption === 'copy'"
                        class="has-text-centered mt-4"
                      >
                        <hr />
                        <p class="has-text-grey renewUrl">
                          <b-icon icon="link" class="mr-1"></b-icon>
                          <span class="truncated-url">{{ renewalUrl }}</span>
                        </p>
                      </div>

                      <div v-if="selectedOption === 'sms'" class="mt-4">
                        <div>
                          <hr />
                          <div>
                            <p class="subtitle">Sms</p>
                            <b-field grouped style="margin-bottom: 18px">
                              <b-field
                                expanded
                                label-position="on-border"
                                label="Owner"
                              >
                                <b-input
                                  :value="
                                    member.LadaTelefono && member.Telefono
                                      ? `+${member.LadaTelefono} ${member.Telefono}`
                                      : ''
                                  "
                                  type="text"
                                  disabled
                                  expanded
                                ></b-input>
                              </b-field>

                              <b-field
                                expanded
                                label-position="on-border"
                                label="Co-Owner"
                              >
                                <b-input
                                  :value="
                                    coOwner.LadaTelefono && coOwner.Telefono
                                      ? `+${coOwner.LadaTelefono} ${coOwner.Telefono}`
                                      : ''
                                  "
                                  type="text"
                                  disabled
                                  expanded
                                ></b-input>
                              </b-field>
                            </b-field>

                            <b-field grouped>
                              <b-field
                                label-position="on-border"
                                label="Phone Number"
                                expanded
                              >
                                <b-input
                                  placeholder="Ingresar número"
                                  type="phone"
                                  v-model="newPhoneNumber"
                                  expanded
                                ></b-input>
                              </b-field>
                              <b-field>
                                <b-button type="is-primary" @click="addNumber"
                                  >Agregar</b-button
                                >
                              </b-field>
                            </b-field>
                            <div
                              class="is-half"
                              v-for="(phone, index) in phones"
                              :key="index"
                              style="margin-bottom: 9px"
                            >
                              <b-field grouped>
                                <b-field expanded>
                                  <b-input
                                    :value="phone"
                                    disabled
                                    type="text"
                                    expanded
                                  ></b-input>
                                </b-field>
                                <b-field>
                                  <b-button
                                    type="is-danger"
                                    @click="removeNumber(index)"
                                    expanded
                                    ><b-icon
                                      icon="trash"
                                      class="fas fa-trash"
                                    ></b-icon
                                  ></b-button>
                                </b-field>
                              </b-field>
                            </div>
                          </div>
                          <hr />
                          <div>
                            <p class="subtitle">{{ i18n.email[iso] }}</p>
                            <b-field grouped style="margin-bottom: 18px">
                              <b-field
                                expanded
                                label-position="on-border"
                                label="Owner"
                              >
                                <b-input
                                  :value="member.Email ? member.Email : ''"
                                  type="text"
                                  disabled
                                  expanded
                                ></b-input>
                              </b-field>

                              <b-field
                                expanded
                                label-position="on-border"
                                label="Co-Owner"
                              >
                                <b-input
                                  :value="coOwner.Email ? coOwner.Email : ''"
                                  type="text"
                                  disabled
                                  expanded
                                ></b-input>
                              </b-field>
                            </b-field>

                            <b-field grouped style="margin-bottom: 15px">
                              <b-field
                                label-position="on-border"
                                :label="i18n.email[iso]"
                                expanded
                              >
                                <b-input
                                  placeholder="Ingresar correo"
                                  type="email"
                                  v-model="newEmail"
                                  expanded
                                ></b-input>
                              </b-field>
                              <b-field>
                                <b-button type="is-primary" @click="addEmails"
                                  >Agregar</b-button
                                >
                              </b-field>
                            </b-field>

                            <div
                              class="is-half"
                              v-for="(email, index) in emails"
                              :key="index"
                              style="margin-bottom: 9px"
                            >
                              <b-field grouped>
                                <b-field expanded>
                                  <b-input
                                    :value="email"
                                    disabled
                                    type="text"
                                    expanded
                                  ></b-input>
                                </b-field>
                                <b-field>
                                  <b-button
                                    type="is-danger"
                                    @click="removeEmail(index)"
                                    expanded
                                    ><b-icon
                                      icon="trash"
                                      class="fas fa-trash"
                                    ></b-icon
                                  ></b-button>
                                </b-field>
                              </b-field>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    <footer class="modal-card-foot">
                      <!-- <button
                        class="button is-primary"
                        @click="sendRenew(yearsRenew, cuponRenew)"
                      >
                        {{ i18n.accept[iso] }}
                      </button> -->
                      <button class="button" @click="modalStep = 'renew'">
                        {{ i18n.goBack[iso] }}
                      </button>
                      <button
                        class="button is-primary"
                        @click="showModal = false"
                      >
                        {{ i18n.accept[iso] }}
                      </button>
                    </footer>
                  </div>
                </b-modal>

                <b-modal
                  :active.sync="showModal"
                  scroll="keep"
                  has-modal-card
                  v-if="modalType === 'renovarDiferido__step1'"
                >
                  <div class="card" style="width: 700px">
                    <header class="modal-card-head">
                      <p class="modal-card-title">
                        {{ i18n.paymentLinkDeferred[iso] }}
                      </p>
                      <button
                        class="delete"
                        @click="showModal = false"
                      ></button>
                    </header>
                    <section class="modal-card-body">
                      <div class="columns">
                        <div class="column is-4">
                          <b-field
                            label-position="on-border"
                            :label="i18n.totalToPayment[iso]"
                          >
                            <b-input
                              type="text"
                              :value="
                                (paymentsDeferred &&
                                  paymentsDeferred[0] &&
                                  paymentsDeferred[0].main &&
                                  paymentsDeferred[0].main
                                    .MontoTotalPagoDiferido) ||
                                0
                              "
                              disabled
                            ></b-input>
                          </b-field>
                        </div>
                        <div class="column is-4">
                          <b-field
                            label-position="on-border"
                            :label="i18n.missingAmount[iso]"
                          >
                            <b-input
                              type="text"
                              :value="
                                (paymentsDeferred &&
                                  paymentsDeferred[0] &&
                                  paymentsDeferred[0].main &&
                                  paymentsDeferred[0].main.missingAmount) ||
                                0
                              "
                              disabled
                            ></b-input>
                          </b-field>
                        </div>
                        <div class="column is-4">
                          <b-field
                            label-position="on-border"
                            :type="
                              parseFloat(
                                paymentsDeferred &&
                                  paymentsDeferred[0] &&
                                  paymentsDeferred[0].main &&
                                  paymentsDeferred[0].main.missingAmount
                              ) === AbonoInicialDeferred
                                ? 'is-success'
                                : ''
                            "
                            :message="
                              parseFloat(
                                paymentsDeferred &&
                                  paymentsDeferred[0] &&
                                  paymentsDeferred[0].main &&
                                  paymentsDeferred[0].main.missingAmount
                              ) === AbonoInicialDeferred
                                ? i18n.paymentCompleted[iso]
                                : ''
                            "
                            :label="i18n.totalToPayment[iso]"
                          >
                            <b-numberinput
                              v-model="AbonoInicialDeferred"
                              :controls="false"
                              step="0.01"
                            >
                            </b-numberinput>
                          </b-field>
                        </div>
                      </div>
                    </section>

                    <footer class="modal-card-foot">
                      <button class="button" @click="showModal = false">
                        {{ i18n.cancel[iso] }}
                      </button>
                      <b-button
                        :loading="loadingButtonRenewalPaymentLink"
                        type="is-success"
                        @click="sendRenewDeferred__other()"
                        >{{ i18n.create[iso] }}</b-button
                      >
                    </footer>
                  </div>

                  <div
                    v-if="modalStep === 'options'"
                    class="card"
                    style="width: 500px"
                  >
                    <header class="modal-card-head">
                      <p class="modal-card-title">{{ i18n.options[iso] }}</p>
                      <button
                        class="delete"
                        @click="showModal = false"
                      ></button>
                    </header>
                    <section class="modal-card-body">
                      <p>{{ i18n.selectAnOption[iso] }}</p>
                      <div class="buttons mt-3">
                        <div class="button-wrapper">
                          <b-button
                            @click="handleButtonClick('copy')"
                            :type="
                              selectedOption === 'copy' ? 'is-success' : ''
                            "
                          >
                            <i class="fas fa-copy"></i>
                          </b-button>
                        </div>

                        <div class="button-wrapper">
                          <b-button
                            @click="handleButtonClick('sms')"
                            :type="selectedOption === 'sms' ? 'is-success' : ''"
                          >
                            <i class="fas fa-comment-alt"></i>
                          </b-button>
                        </div>
                      </div>

                      <div
                        v-if="selectedOption === 'copy'"
                        class="has-text-centered mt-4"
                      >
                        <hr />
                        <p class="has-text-grey renewUrl">
                          <b-icon icon="link" class="mr-1"></b-icon>
                          <span class="truncated-url">{{ renewalUrl }}</span>
                        </p>
                      </div>

                      <div v-if="selectedOption === 'sms'" class="mt-4">
                        <div>
                          <hr />
                          <div>
                            <p class="subtitle">Sms</p>
                            <b-field grouped style="margin-bottom: 18px">
                              <b-field
                                expanded
                                label-position="on-border"
                                label="Owner"
                              >
                                <b-input
                                  :value="
                                    member.LadaTelefono && member.Telefono
                                      ? `+${member.LadaTelefono} ${member.Telefono}`
                                      : ''
                                  "
                                  type="text"
                                  disabled
                                  expanded
                                ></b-input>
                              </b-field>

                              <b-field
                                expanded
                                label-position="on-border"
                                label="Co-Owner"
                              >
                                <b-input
                                  :value="
                                    coOwner.LadaTelefono && coOwner.Telefono
                                      ? `+${coOwner.LadaTelefono} ${coOwner.Telefono}`
                                      : ''
                                  "
                                  type="text"
                                  disabled
                                  expanded
                                ></b-input>
                              </b-field>
                            </b-field>

                            <b-field grouped>
                              <b-field
                                label-position="on-border"
                                label="Phone Number"
                                expanded
                              >
                                <b-input
                                  placeholder="Ingresar número"
                                  type="phone"
                                  v-model="newPhoneNumber"
                                  expanded
                                ></b-input>
                              </b-field>
                              <b-field>
                                <b-button type="is-primary" @click="addNumber"
                                  >Agregar</b-button
                                >
                              </b-field>
                            </b-field>
                            <div
                              class="is-half"
                              v-for="(phone, index) in phones"
                              :key="index"
                              style="margin-bottom: 9px"
                            >
                              <b-field grouped>
                                <b-field expanded>
                                  <b-input
                                    :value="phone"
                                    disabled
                                    type="text"
                                    expanded
                                  ></b-input>
                                </b-field>
                                <b-field>
                                  <b-button
                                    type="is-danger"
                                    @click="removeNumber(index)"
                                    expanded
                                    ><b-icon
                                      icon="trash"
                                      class="fas fa-trash"
                                    ></b-icon
                                  ></b-button>
                                </b-field>
                              </b-field>
                            </div>
                          </div>
                          <hr />
                          <div>
                            <p class="subtitle">{{ i18n.email[iso] }}</p>
                            <b-field grouped style="margin-bottom: 18px">
                              <b-field
                                expanded
                                label-position="on-border"
                                label="Owner"
                              >
                                <b-input
                                  :value="member.Email ? member.Email : ''"
                                  type="text"
                                  disabled
                                  expanded
                                ></b-input>
                              </b-field>

                              <b-field
                                expanded
                                label-position="on-border"
                                label="Co-Owner"
                              >
                                <b-input
                                  :value="coOwner.Email ? coOwner.Email : ''"
                                  type="text"
                                  disabled
                                  expanded
                                ></b-input>
                              </b-field>
                            </b-field>

                            <b-field grouped style="margin-bottom: 15px">
                              <b-field
                                label-position="on-border"
                                :label="i18n.email[iso]"
                                expanded
                              >
                                <b-input
                                  placeholder="Ingresar correo"
                                  type="email"
                                  v-model="newEmail"
                                  expanded
                                ></b-input>
                              </b-field>
                              <b-field>
                                <b-button type="is-primary" @click="addEmails"
                                  >Agregar</b-button
                                >
                              </b-field>
                            </b-field>

                            <div
                              class="is-half"
                              v-for="(email, index) in emails"
                              :key="index"
                              style="margin-bottom: 9px"
                            >
                              <b-field grouped>
                                <b-field expanded>
                                  <b-input
                                    :value="email"
                                    disabled
                                    type="text"
                                    expanded
                                  ></b-input>
                                </b-field>
                                <b-field>
                                  <b-button
                                    type="is-danger"
                                    @click="removeEmail(index)"
                                    expanded
                                    ><b-icon
                                      icon="trash"
                                      class="fas fa-trash"
                                    ></b-icon
                                  ></b-button>
                                </b-field>
                              </b-field>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    <footer class="modal-card-foot">
                      <!-- <button
                        class="button is-primary"
                        @click="sendRenew(yearsRenew, cuponRenew)"
                      >
                        {{ i18n.accept[iso] }}
                      </button> -->
                      <button class="button" @click="modalStep = 'renew'">
                        {{ i18n.goBack[iso] }}
                      </button>
                      <button
                        class="button is-primary"
                        @click="showModal = false"
                      >
                        {{ i18n.accept[iso] }}
                      </button>
                    </footer>
                  </div>
                </b-modal>

                <b-modal
                  :active.sync="showModal"
                  scroll="keep"
                  has-modal-card
                  v-if="modalType === 'addPayment'"
                >
                  <div class="card" style="width: 500px">
                    <header class="modal-card-head">
                      <p class="modal-card-title">
                        {{ i18n.addPayExternal[iso] }}
                      </p>
                      <button
                        class="delete"
                        @click="showModal = false"
                      ></button>
                    </header>
                    <section class="modal-card-body">
                      <div class="columns is-multiline">
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="i18n.paymentMethod[iso]"
                            required
                          >
                            <b-select v-model="formPayment.TipoPago" expanded>
                              <option
                                v-for="typeE in typePaymentsExternal"
                                :value="typeE.id"
                              >
                                {{
                                  iso == "en" ? typeE.NombreEN : typeE.NombreES
                                }}
                              </option>
                            </b-select>
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            label="Referencia"
                          >
                            <b-input
                              type="text"
                              v-model="formPayment.Referencia"
                            ></b-input>
                          </b-field>
                        </div>
                        <div class="column is-12">
                          <b-field
                            label-position="on-border"
                            :label="i18n.periods[iso]"
                          >
                            <b-select
                              v-model="formPayment.Years"
                              expanded
                              @input="onChangeYears"
                            >
                              <option
                                v-for="option in periodOptions"
                                :key="option.value"
                                :value="option.value"
                              >
                                {{ option.label }}
                              </option>
                            </b-select>
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="i18n.payDay[iso]"
                            expanded
                          >
                            <!-- <b-input
                              type="datetime-local"
                              v-model="formPayment.FechaPago"
                              :max="maxDate"
                              required
                            ></b-input> -->
                            <div class="datetime-input-container">
                              <b-input
                                type="datetime-local"
                                v-model="formPayment.FechaPago"
                                :max="maxDate"
                                id="myDatetimeInput"
                              ></b-input>

                              <span
                                class="datetime-icon"
                                @click="
                                  showDatetimepicker
                                    ? closeDatetimepicker()
                                    : openDatetimepicker()
                                "
                              ></span>
                            </div>
                            <!-- <b-datetimepicker
                              v-model="formPayment.FechaPago"
                              :locale="iso"
                              :max="maxDate"
                            >
                              <template #left>
                                <b-button
                                  label="Now"
                                  type="is-primary"
                                  icon-left="clock"
                                  @click="formPayment.FechaPago = new Date()"
                                />
                              </template>

                              <template #right>
                                <b-button
                                  label="Clear"
                                  type="is-danger"
                                  icon-left="close"
                                  outlined
                                  @click="formPayment.FechaPago = null"
                                />
                              </template>
                            </b-datetimepicker> -->
                            <!-- <b-datepicker
                              v-model="formPayment.FechaPago"
                              placeholder="DD/MM/YYYY"
                              :min-date="minDate"
                              :max-date="maxDateToday"
                              :locale="iso"
                              icon="calendar"
                              icon-pack="fas"
                              :icon-right="
                                formPayment.FechaPago ? 'times' : ''
                              "
                              icon-right-clickable
                              @icon-right-click="formPayment.FechaPago = null"
                            >
                            </b-datepicker> -->
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="`${i18n.amount[iso]} (USD)`"
                            expanded
                          >
                            <b-input
                              type="number"
                              v-model="formPayment.Monto"
                            ></b-input>
                          </b-field>
                        </div>
                        <div
                          class="column is-6"
                          v-if="
                            permissions === 'admin' ||
                            allPermissions.includes('reset-renewal')
                          "
                          style="padding-left: 10px; padding-top: 15px"
                        >
                          <b-tooltip
                            :label="i18n.forgiveDebt[iso]"
                            position="is-right"
                            type="is-info"
                          >
                            <b-field>
                              <b-switch
                                v-model="codeReset"
                                type="is-info"
                                size="is-medium"
                              >
                                <b>RESET</b>
                              </b-switch>
                            </b-field>
                          </b-tooltip>
                          <span v-if="codeReset">
                            <br />
                            <b-tag type="is-info is-light"
                              ><p>
                                <b>
                                  {{ i18n.condoned[iso] }}:
                                  {{
                                    periodOptions.find(
                                      (p) => p.value === yearsRenew
                                    ).YearsCondoned
                                  }}
                                  {{ i18n.years[iso] }}</b
                                >
                              </p></b-tag
                            >
                            <br />
                            <!-- <b-tag type="is-primary is-light"
                              ><p><b>{{
                                  periodOptions.find(
                                    (p) => p.value === yearsRenew
                                  ).showPeriodIfCodeReset
                                }}</b></p
                            ></b-tag> -->
                          </span>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="i18n.renewalAssign[iso]"
                          >
                            <b-select expanded v-model="agentEmail">
                              <option
                                :value="user.Email"
                                v-for="user in usersStaff"
                              >
                                {{ user.Nombre }} {{ user.Apellido }}
                              </option>
                              <option
                                value="dev@system.com"
                              >
                                Online
                              </option>
                            </b-select>
                          </b-field>
                        </div>
                      </div>

                      <!-- <b-field grouped style="margin-bottom: 25px">
                        <b-field
                          label-position="on-border"
                          :label="i18n.promotionCode[iso]"
                          expanded
                        >
                          <b-input
                            type="text"
                            v-model="formPayment.codeDiscount"
                          ></b-input>
                        </b-field>
                        <b-field expanded>
                          <b-button class="is-primary" expanded>
                            {{ i18n.apply[iso] }}
                          </b-button>
                        </b-field>
                      </b-field> -->

                      <!-- <b-field
                        label-position="on-border"
                        :label="i18n.payDay[iso]"
                        expanded
                        v-if="formPayment.type === paymentMethod[4]._id"
                      >
                        <b-input
                          type="date"
                          v-model="formPayment.datePay"
                          :max="maxDate"
                          required
                        ></b-input>
                      </b-field>

                      <b-field v-else grouped style="margin-bottom: 25px">
                        <b-field
                          label-position="on-border"
                          :label="i18n.payDay[iso]"
                          expanded
                        >
                          <b-input
                            type="date"
                            v-model="formPayment.datePay"
                            :max="maxDate"
                            required
                          ></b-input>
                        </b-field>

                        <b-field
                          label-position="on-border"
                          :label="i18n.amount[iso]"
                          expanded
                        >
                          <b-input
                            type="text"
                            :value="totalAmount"
                            disabled
                          ></b-input>
                        </b-field>
                      </b-field> -->
                    </section>

                    <footer class="modal-card-foot">
                      <button class="button" @click="showModal = false">
                        {{ i18n.cancel[iso] }}
                      </button>
                      <b-button
                        class="button is-success"
                        @click="sendPayment"
                        :loading="loadingButtonSendPaymentExternal"
                        >{{ i18n.accept[iso] }}</b-button
                      >
                    </footer>
                  </div>
                </b-modal>

                <b-modal
                  :active.sync="showModal"
                  scroll="keep"
                  has-modal-card
                  v-if="modalType === 'addPaymentDeferred'"
                >
                  <div class="card" style="width: 600px">
                    <header class="modal-card-head">
                      <p class="modal-card-title">
                        {{ i18n.addPaymentDeferred[iso] }}
                      </p>
                      <button
                        class="delete"
                        @click="showModal = false"
                      ></button>
                    </header>
                    <section class="modal-card-body">
                      <div class="columns is-multiline">
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="i18n.paymentMethod[iso]"
                            required
                          >
                            <b-select v-model="formPayment.TipoPago" expanded>
                              <option
                                v-for="typeE in typePaymentsExternal"
                                :value="typeE.id"
                              >
                                {{
                                  iso == "en" ? typeE.NombreEN : typeE.NombreES
                                }}
                              </option>
                            </b-select>
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            label="Referencia"
                          >
                            <b-input
                              type="text"
                              v-model="formPayment.Referencia"
                            ></b-input>
                          </b-field>
                        </div>
                        <div class="column is-12">
                          <b-field
                            label-position="on-border"
                            :label="i18n.periods[iso]"
                          >
                            <b-select
                              v-model="formPayment.Years"
                              expanded
                              @input="onChangeYears"
                            >
                              <option
                                v-for="option in periodOptions"
                                :key="option.value"
                                :value="option.value"
                              >
                                {{ option.label }}
                              </option>
                            </b-select>
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="i18n.payDay[iso]"
                            expanded
                          >
                            <!-- <b-input
                              type="datetime-local"
                              v-model="formPayment.FechaPago"
                              :max="maxDate"
                              required
                            ></b-input> -->
                            <div class="datetime-input-container">
                              <b-input
                                type="datetime-local"
                                v-model="formPayment.FechaPago"
                                :max="maxDate"
                                id="myDatetimeInput"
                              ></b-input>

                              <span
                                class="datetime-icon"
                                @click="
                                  showDatetimepicker
                                    ? closeDatetimepicker()
                                    : openDatetimepicker()
                                "
                              ></span>
                            </div>
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="`${i18n.initialPayment[iso]} (USD)`"
                            expanded
                          >
                            <!-- <b-input
                              type="number"
                              v-model="formPayment.AbonoInicial"
                            ></b-input> -->
                            <b-numberinput
                              v-model="formPayment.AbonoInicial"
                              :controls="false"
                              step="0.01"
                            ></b-numberinput>
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="`${i18n.totalPayment[iso]} (USD)`"
                            expanded
                          >
                            <b-input
                              type="number"
                              v-model="formPayment.Monto"
                            ></b-input>
                          </b-field>
                        </div>
                        <div
                          class="column is-6"
                          v-if="
                            permissions === 'admin' ||
                            allPermissions.includes('reset-renewal')
                          "
                          style="padding-left: 10px; padding-top: 15px"
                        >
                          <b-tooltip
                            :label="i18n.forgiveDebt[iso]"
                            position="is-right"
                            type="is-info"
                          >
                            <b-field>
                              <b-switch
                                v-model="codeReset"
                                type="is-info"
                                size="is-medium"
                              >
                                <b>RESET</b>
                              </b-switch>
                            </b-field>
                          </b-tooltip>
                          <span v-if="codeReset">
                            <br />
                            <b-tag type="is-info is-light"
                              ><p>
                                <b>
                                  {{ i18n.condoned[iso] }}:
                                  {{
                                    periodOptions.find(
                                      (p) => p.value === yearsRenew
                                    ).YearsCondoned
                                  }}
                                  {{ i18n.years[iso] }}</b
                                >
                              </p></b-tag
                            >
                            <br />
                            <!-- <b-tag type="is-primary is-light"
                              ><p><b>{{
                                  periodOptions.find(
                                    (p) => p.value === yearsRenew
                                  ).showPeriodIfCodeReset
                                }}</b></p
                            ></b-tag> -->
                          </span>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="i18n.renewalAssign[iso]"
                          >
                            <b-select expanded v-model="agentEmail">
                              <option
                                :value="user.Email"
                                v-for="user in usersStaff"
                              >
                                {{ user.Nombre }} {{ user.Apellido }}
                              </option>
                              <option
                                value="dev@system.com"
                              >
                                Online
                              </option>
                            </b-select>
                          </b-field>
                        </div>
                      </div>

                      <!-- <b-field grouped style="margin-bottom: 25px">
                        <b-field
                          label-position="on-border"
                          :label="i18n.promotionCode[iso]"
                          expanded
                        >
                          <b-input
                            type="text"
                            v-model="formPayment.codeDiscount"
                          ></b-input>
                        </b-field>
                        <b-field expanded>
                          <b-button class="is-primary" expanded>
                            {{ i18n.apply[iso] }}
                          </b-button>
                        </b-field>
                      </b-field> -->

                      <!-- <b-field
                        label-position="on-border"
                        :label="i18n.payDay[iso]"
                        expanded
                        v-if="formPayment.type === paymentMethod[4]._id"
                      >
                        <b-input
                          type="date"
                          v-model="formPayment.datePay"
                          :max="maxDate"
                          required
                        ></b-input>
                      </b-field>

                      <b-field v-else grouped style="margin-bottom: 25px">
                        <b-field
                          label-position="on-border"
                          :label="i18n.payDay[iso]"
                          expanded
                        >
                          <b-input
                            type="date"
                            v-model="formPayment.datePay"
                            :max="maxDate"
                            required
                          ></b-input>
                        </b-field>

                        <b-field
                          label-position="on-border"
                          :label="i18n.amount[iso]"
                          expanded
                        >
                          <b-input
                            type="text"
                            :value="totalAmount"
                            disabled
                          ></b-input>
                        </b-field>
                      </b-field> -->
                    </section>

                    <footer class="modal-card-foot">
                      <button class="button" @click="showModal = false">
                        {{ i18n.cancel[iso] }}
                      </button>
                      <b-button
                        class="button is-success"
                        @click="sendPaymentDeferred"
                        :loading="loadingButtonSendPaymentDeferred"
                        >{{ i18n.accept[iso] }}</b-button
                      >
                    </footer>
                  </div>
                </b-modal>

                <b-modal
                  :active.sync="showModal"
                  scroll="keep"
                  has-modal-card
                  v-if="modalType === 'addPaymentDeferred__step1'"
                >
                  <div class="card" style="width: 600px">
                    <header class="modal-card-head">
                      <p class="modal-card-title">
                        {{ i18n.addPayment[iso] }}
                      </p>
                      <button
                        class="delete"
                        @click="showModal = false"
                      ></button>
                    </header>
                    <section class="modal-card-body">
                      <div class="columns is-multiline">
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="i18n.paymentMethod[iso]"
                            required
                          >
                            <b-select v-model="formPayment.TipoPago" expanded>
                              <option
                                v-for="typeE in typePaymentsExternal"
                                :value="typeE.id"
                              >
                                {{
                                  iso == "en" ? typeE.NombreEN : typeE.NombreES
                                }}
                              </option>
                            </b-select>
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            label="Referencia"
                          >
                            <b-input
                              type="text"
                              v-model="formPayment.Referencia"
                            ></b-input>
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="i18n.payDay[iso]"
                            expanded
                          >
                            <!-- <b-input
                              type="datetime-local"
                              v-model="formPayment.FechaPago"
                              :max="maxDate"
                              required
                            ></b-input> -->
                            <div class="datetime-input-container">
                              <b-input
                                type="datetime-local"
                                v-model="formPayment.FechaPago"
                                :max="maxDate"
                                id="myDatetimeInput"
                              ></b-input>

                              <span
                                class="datetime-icon"
                                @click="
                                  showDatetimepicker
                                    ? closeDatetimepicker()
                                    : openDatetimepicker()
                                "
                              ></span>
                            </div>
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="`${i18n.amountToPay[iso]} (USD)`"
                            expanded
                            :type="
                              paymentsDeferred[0].main.missingAmount -
                                formPayment.AbonoInicial <
                              0
                                ? 'is-danger'
                                : ''
                            "
                            :message="
                              paymentsDeferred[0].main.missingAmount -
                                formPayment.AbonoInicial <
                              0
                                ? i18n.amountToPay__msg1[iso]
                                : ''
                            "
                          >
                            <!-- <b-input
                              type="number"
                              v-model="formPayment.AbonoInicial"
                            ></b-input> -->
                            <b-numberinput
                              v-model="formPayment.AbonoInicial"
                              :controls="false"
                              step="0.01"
                            ></b-numberinput>
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="`${i18n.totalPayment[iso]} (USD)`"
                            expanded
                          >
                            <b-input
                              disabled
                              type="number"
                              :value="
                                paymentsDeferred[0].main.MontoTotalPagoDiferido
                              "
                            ></b-input>
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label-position="on-border"
                            :label="`${i18n.missingAmount[iso]} (USD)`"
                            expanded
                            :type="
                              paymentsDeferred[0].main.missingAmount -
                                formPayment.AbonoInicial ===
                              0
                                ? 'is-success'
                                : ''
                            "
                            :message="
                              paymentsDeferred[0].main.missingAmount -
                                formPayment.AbonoInicial ===
                              0
                                ? i18n.paymentCompleted[iso]
                                : ''
                            "
                          >
                            <b-input
                              disabled
                              type="number"
                              :value="
                                (
                                  paymentsDeferred[0].main.missingAmount -
                                  formPayment.AbonoInicial
                                ).toFixed(2)
                              "
                            ></b-input>
                          </b-field>
                        </div>
                      </div>
                    </section>

                    <footer class="modal-card-foot">
                      <button class="button" @click="showModal = false">
                        {{ i18n.cancel[iso] }}
                      </button>
                      <b-button
                        :disabled="
                          paymentsDeferred[0].main.missingAmount -
                            formPayment.AbonoInicial <
                          0
                        "
                        class="button is-success"
                        @click="sendPaymentDeferred"
                        :loading="loadingButtonSendPaymentDeferred"
                        >{{ i18n.accept[iso] }}</b-button
                      >
                    </footer>
                  </div>
                </b-modal>
              </template>
            </b-tab-item>
            <!-- Fin Pestaña de renovaciones -->

            <!-- PESTAÑA FINANCIAMIENTO -->
            <b-tab-item>
              <template #header>
                <b-icon icon="credit-card" pack="fas" type="is-info"></b-icon>
                <b>{{ i18n.financing[iso] }}</b>
              </template>

              <FinancingMember
                :financing-data="financingData"
                :loading="loadingFinancing"
                :member="member"
                @payment-added="onPaymentAdded"
              ></FinancingMember>
            </b-tab-item>

            <!-- PESTAÑA DE COMENTARIOS -->
            <b-tab-item>
              <template #header>
                <b-icon icon="comment" pack="fas" type="is-info"></b-icon>
                <b>{{ i18n.comments[iso] }}</b>
              </template>
              <div class="columns is-multiline"></div>
              <comment-member
                ref="commentmember"
                v-if="contract.Id"
                :ContratoId="contract.Id"
              ></comment-member>
            </b-tab-item>

            <!-- Pestaña Puntos / Rewards -->
            <b-tab-item>
              <template #header>
                <b-icon icon="award" pack="fas" type="is-info"></b-icon>
                <b>{{ i18n.pointsRewards[iso] }}</b>
              </template>

              <div
                class="columns is-multiline"
                v-if="
                  !isCap &&
                  (permissions === 'admin' ||
                    allPermissions.includes('add-points'))
                "
              >
                <div
                  class="column is-12 is-flex is-justify-content-center"
                >
                  <b-button
                    icon-left="plus"
                    icon-pack="fas"
                    type="is-success"
                    @click="openAddPointsModal"
                    >{{ i18n.addPoints[iso] }}</b-button
                  >
                </div>
              </div>

              <div class="columns is-multiline">
                <div class="column is-6">
                  <div class="content">
                    <h3>{{ i18n.owner[iso] }}</h3>
                  </div>
                  <PointsContent
                    :puntos="memberPuntos"
                    :historial="memberPuntosHistorial"
                  />
                </div>

                <div class="column is-6">
                  <div class="content">
                    <h3>{{ i18n.coOwner[iso] }}</h3>
                  </div>
                  <PointsContent
                    v-if="coMemberId"
                    :puntos="coOwnerPuntos"
                    :historial="coOwnerPuntosHistorial"
                  />
                  <div
                    v-else
                    class="is-flex is-align-items-center is-justify-content-center"
                    style="min-height: 200px"
                  >
                    <p class="has-text-grey is-italic">
                      {{ i18n.noCoOwner[iso] }}
                    </p>
                  </div>
                </div>
              </div>
            </b-tab-item>

            <!-- Pestaña Travel Vouchers -->
            <b-tab-item>
              <template #header>
                <b-icon icon="ticket-alt" pack="fas" type="is-info"></b-icon>
                <b>{{ i18n.travelVouchersTab[iso] }}</b>
              </template>

              <div
                class="columns is-multiline"
                v-if="
                  !isCap &&
                  (permissions === 'admin' ||
                    allPermissions.includes('add-travel-voucher'))
                "
              >
                <div
                  class="column is-12 is-flex is-justify-content-center"
                >
                  <b-button
                    icon-left="plus"
                    icon-pack="fas"
                    type="is-success"
                    @click="openAddTravelVoucherModal"
                    >{{ i18n.addTravelVoucher[iso] }}</b-button
                  >
                </div>
              </div>

              <div class="columns is-multiline">
                <div class="column is-12">
                  <div class="content">
                    <h3>{{ i18n.travelVouchersTab[iso] }}</h3>
                  </div>
                  <b-table
                    :data="memberTravelVouchers"
                    :striped="true"
                    :narrowed="true"
                    :hoverable="true"
                    :focusable="false"
                    :paginated="memberTravelVouchers.length > 10"
                    :per-page="10"
                    pagination-simple
                    :empty-label="i18n.noTravelVouchers[iso]"
                  >
                    <b-table-column
                      field="Codigo"
                      :label="i18n.voucherCode[iso]"
                      centered
                      v-slot="props"
                    >
                      {{ (props.row.Codigo || []).join(", ") }}
                    </b-table-column>

                    <b-table-column
                      field="MontoDescuento"
                      :label="i18n.voucherAmount[iso]"
                      centered
                      v-slot="props"
                    >
                      $ {{ props.row.MontoDescuento || 0 }} USD
                    </b-table-column>

                    <b-table-column
                      field="CreadoPor"
                      :label="i18n.assignedBy[iso]"
                      centered
                      v-slot="props"
                    >
                      {{ voucherAsignadoPor(props.row) }}
                    </b-table-column>

                    <b-table-column
                      field="FechaCreacion"
                      :label="i18n.creationDate[iso]"
                      centered
                      v-slot="props"
                    >
                      {{
                        props.row.FechaCreacion
                          ? parseDate(props.row.FechaCreacion)
                          : ""
                      }}
                    </b-table-column>

                    <b-table-column
                      field="FechaVencimiento"
                      :label="i18n.expirationDate[iso]"
                      centered
                      v-slot="props"
                    >
                      {{
                        props.row.FechaVencimiento
                          ? parseDate(props.row.FechaVencimiento)
                          : ""
                      }}
                    </b-table-column>

                    <b-table-column
                      field="Estado"
                      :label="i18n.voucherStatus[iso]"
                      centered
                      v-slot="props"
                    >
                      <b-tag
                        :type="
                          props.row.Estado === 'active'
                            ? 'is-success'
                            : 'is-danger'
                        "
                      >
                        {{ props.row.Estado || "" }}
                      </b-tag>
                    </b-table-column>
                  </b-table>
                </div>
              </div>
            </b-tab-item>

            <!-- Pestaña de acciones -->
            <b-tab-item>
              <template #header>
                <b-icon icon="hand-pointer" pack="fas" type="is-info"></b-icon>
                <b>Acciones</b>
              </template>

              <div v-if="contract && member.Email">
                <ActionsMember
                  :contract="data.member.ContratoId"
                  :member="data.member"
                  :coOwner="coOwner"
                  :ifSyncBitrix="ifSyncBitrix"
                  :email="member.Email || ''"
                  @refresh-profile="getProfile"
                  :isAdmin="permissions === 'admin'"
                  :isCap="isCap"
                  :HsData="member.HsData ? false : true"
                />
              </div>
            </b-tab-item>
            <!-- Fin de pestaña de acciones -->
          </b-tabs>
          <hr />
          <!-- <div class="content article-body"></div> -->
        </div>
      </div>
    </section>

    <!-- Modal de Agregar puntos -->
    <b-modal
      v-model="showAddPointsModal"
      :width="500"
      :can-cancel="['x', 'escape', 'outside']"
    >
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">{{ i18n.addPoints__title[iso] }}</p>
          <button
            class="card-header-icon"
            aria-label="more options"
            @click="showAddPointsModal = false"
          >
            <b-icon pack="fas" icon="times" type="is-danger" size="is-small">
            </b-icon>
          </button>
        </header>
        <div class="card-content">
          <div class="content" v-if="pointsModalStep === 'form'">
            <div class="columns is-multiline">
              <div class="column is-12">
                <b-field
                  label-position="on-border"
                  :label="i18n.pointsRecipient[iso]"
                >
                  <b-select v-model="addPointsForm.destinatario" expanded>
                    <option value="titular">
                      {{ i18n.owner[iso] }}
                    </option>
                    <option value="cotitular" v-if="coMemberId">
                      {{ i18n.coOwner[iso] }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="column is-6">
                <b-field
                  label-position="on-border"
                  :label="i18n.amountPoint[iso]"
                >
                  <b-input
                    type="number"
                    v-model="addPointsForm.monto"
                    expanded
                  ></b-input>
                </b-field>
              </div>
              <div class="column is-6">
                <b-field
                  label-position="on-border"
                  :label="i18n.addPointsReason[iso]"
                >
                  <b-select v-model="addPointsForm.Motivo" expanded>
                    <option value="Incentivo por renovación">
                      {{ i18n.addPointsReasonRenewal[iso] }}
                    </option>
                    <option value="Incentivo por recuperación">
                      {{ i18n.addPointsReasonRecovery[iso] }}
                    </option>
                    <option value="Otro">
                      {{ i18n.addPointsReasonOther[iso] }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="column is-12">
                <b-field
                  label-position="on-border"
                  :label="i18n.addPointsReasonDetail[iso]"
                >
                  <b-input
                    type="textarea"
                    v-model="addPointsForm.MotivoDetalle"
                    expanded
                  ></b-input>
                </b-field>
              </div>
            </div>
          </div>
          <div class="content" v-else-if="pointsModalStep === 'otp'">
            <p class="has-text-centered mb-4">
              {{ i18n.otpSent[iso] }}
            </p>
            <b-field
              label-position="on-border"
              :label="i18n.otpCode[iso]"
            >
              <b-input
                type="text"
                :placeholder="i18n.otpPlaceholder[iso]"
                v-model="pointsOtpCode"
                maxlength="4"
                expanded
              ></b-input>
            </b-field>
          </div>
        </div>
        <footer class="modal-card-foot" style="justify-content: flex-end">
          <template v-if="pointsModalStep === 'form'">
            <b-button @click="showAddPointsModal = false">{{
              i18n.cancel[iso]
            }}</b-button>
            <b-button
              type="is-success"
              :loading="loadingPointsOtp"
              @click="sendPointsOtp"
              >{{ i18n.save[iso] }}</b-button
            >
          </template>
          <template v-else-if="pointsModalStep === 'otp'">
            <b-button @click="pointsModalStep = 'form'">{{
              i18n.goBack[iso]
            }}</b-button>
            <b-button :loading="loadingPointsOtp" @click="sendPointsOtp">{{
              i18n.otpResend[iso]
            }}</b-button>
            <b-button
              type="is-success"
              :loading="loadingAddPoints"
              @click="addPoints"
              >{{ i18n.accept[iso] }}</b-button
            >
          </template>
        </footer>
      </div>
    </b-modal>

    <!-- Modal de Crear Travel Voucher -->
    <b-modal
      v-model="showAddTravelVoucherModal"
      :width="500"
      :can-cancel="['x', 'escape', 'outside']"
    >
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">{{
            i18n.addTravelVoucher__title[iso]
          }}</p>
          <button
            class="card-header-icon"
            aria-label="more options"
            @click="showAddTravelVoucherModal = false"
          >
            <b-icon pack="fas" icon="times" type="is-danger" size="is-small">
            </b-icon>
          </button>
        </header>
        <div class="card-content">
          <div class="content">
            <div class="columns is-multiline">
              <div class="column is-12">
                <b-field
                  label-position="on-border"
                  :label="i18n.voucherAmount[iso]"
                >
                  <b-select
                    v-model="addTravelVoucherForm.monto"
                    expanded
                  >
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                    <option :value="200">200</option>
                    <option :value="300">300</option>
                  </b-select>
                </b-field>
              </div>
              <div class="column is-12">
                <b-field
                  label-position="on-border"
                  :label="i18n.sendCertificate[iso]"
                >
                  <b-select
                    v-model="addTravelVoucherForm.sendCertificate"
                    expanded
                  >
                    <option value="no">
                      {{ i18n.sendCertificateNo[iso] }}
                    </option>
                    <option value="si">
                      {{ i18n.sendCertificateYes[iso] }}
                    </option>
                  </b-select>
                </b-field>
              </div>
            </div>
          </div>
        </div>
        <footer class="modal-card-foot" style="justify-content: flex-end">
          <b-button @click="showAddTravelVoucherModal = false">{{
            i18n.cancel[iso]
          }}</b-button>
          <b-button
            type="is-success"
            :loading="loadingAddTravelVoucher"
            @click="createTravelVoucher"
            >{{ i18n.create[iso] }}</b-button
          >
        </footer>
      </div>
    </b-modal>

    <!-- Modal de Online payments -->
    <b-modal
      v-model="ModalOnlinePayment"
      :width="400"
      :can-cancel="['x', 'escape', 'outside']"
    >
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">{{ i18n.generateURLOnline[iso] }}</p>
          <button
            class="card-header-icon"
            aria-label="more options"
            @click="ModalOnlinePayment = false"
          >
            <b-icon pack="fas" icon="times" type="is-danger" size="is-small">
            </b-icon>
          </button>
        </header>
        <div class="card-content">
          <div class="content">

            <div class="columns is-multiline">

              <div class="column is-6"><b-field label="Promoción">
              <b-select v-model="onlinePaymentParams.promo" expanded>
                <option :value="null">No aplica</option>
                <option value="RNCC05">RNCC05 (5%)</option>
                <option value="RNCC10">RNCC10 (10%)</option>
                <option value="RNCC15">RNCC15 (15%)</option>
                <option value="RNCC20">RNCC20 (20%)</option>
                <option value="RNCC25">RNCC25 (25%)</option>
              </b-select>
            </b-field>
          </div>
              <div class="column is-6"><b-field label="Cantidad">
              <b-select v-model="onlinePaymentParams.qty" expanded>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="99">NMF</option>
              </b-select>
            </b-field></div>
              <div class="column is-6"><b-field label="Tarifa Adicional">
              <b-input type="number" v-model="onlinePaymentParams.feeextra" expanded placeholder="Ej. 50"></b-input>
            </b-field></div>
              <div class="column is-6"><b-field label="Condonar Deuda">
              <b-select v-model="onlinePaymentParams.reset" expanded>
                <option value="n">No Aplica</option>
                <option value="y">Sí</option>
              </b-select>
            </b-field></div>
              <div class="column is-12"><b-field label="Fecha de Expiración">
              <b-input type="datetime-local" v-model="onlinePaymentParams.exp" expanded></b-input>
            </b-field></div>

            </div>

            

            
            
            

            

            
            
            <div class="has-text-centered" style="margin-bottom: 1.5rem;" v-if="contract && contract.Tarifa">
              <p class="is-size-6 has-text-grey">Tarifa Base: ${{ contract.Tarifa }}</p>
              <p class="is-size-5 has-text-weight-bold has-text-primary" style="margin-top: 0.5rem;">Cálculo Total: ${{ onlinePaymentTotal }}</p>
            </div>

            <b-button type="is-primary" expanded @click="generateOnlinePaymentLink">{{ i18n.generateURLOnline__confirm[iso] }}</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Modal de Resultado de Online payments -->
    <b-modal
      v-model="ModalOnlinePaymentResult"
      :width="600"
      :can-cancel="['x', 'escape', 'outside']"
    >
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">Enlace generado</p>
          <button
            class="card-header-icon"
            aria-label="more options"
            @click="ModalOnlinePaymentResult = false"
          >
            <b-icon pack="fas" icon="times" type="is-danger" size="is-small">
            </b-icon>
          </button>
        </header>
        <div class="card-content">
          <div class="content has-text-centered">
            <b-field>
              <b-input type="text" :value="onlinePaymentGeneratedLink" readonly expanded></b-input>
            </b-field>
            <div style="margin-top: 15px;">
              <b-button type="is-primary" icon-left="copy" icon-pack="fas" @click="copyOnlinePaymentLink">Copiar enlace</b-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Modal de enlaces de pago -->
    <b-modal v-model="ModalOptionActive" :width="500" :can-cancel="['x']">
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">{{ i18n.selectedOptionActive[iso] }}</p>
          <button
            class="card-header-icon"
            aria-label="more options"
            @click="closeModalOptionActive"
          >
            <b-icon pack="fas" icon="times" type="is-danger" size="is-small">
            </b-icon>
          </button>
        </header>
        <div class="card-content">
          <div class="content">
            <div class="buttons">
              <b-button
                size="is-large"
                icon-pack="fas"
                icon-left="phone"
                type="is-success"
                @click="editStatusMembership('call')"
              >
                {{ i18n.call[iso] }}
              </b-button>
              <b-button
                size="is-large"
                icon-pack="fas"
                icon-left="hands-helping"
                type="is-warning"
                @click="editStatusMembership('protocol')"
              >
                {{ i18n.protocol[iso] }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Modal de Tutorial -->
    <!-- Enviar SMS al titular o cotitular por SMTP2GO; queda registrado en Comentarios -->
    <b-modal v-model="smsModal.isOpen" has-modal-card trap-focus :destroy-on-hide="true">
      <ModalSendSms
        v-if="smsModal.isOpen"
        :persona="smsModal.persona"
        :member-id="smsModal.memberId"
        :contrato-id="contract.Id"
        :rol="smsModal.rol"
        :paises="catalogues.CatPaises || []"
        :iso="iso"
        @close="smsModal.isOpen = false"
      />
    </b-modal>

    <b-modal v-model="tutorialModal.isOpen" has-modal-card trap-focus :width="700">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{
              tutorialModal.step === 'discovery'
                ? iso === 'es'
                  ? 'Discovery de la sesión de bienvenida'
                  : 'Welcome session discovery'
                : i18n.addTutorial[iso]
            }}
          </p>
          <button
            type="button"
            class="delete"
            @click="tutorialModal.isOpen = false"
          ></button>
        </header>
        <section class="modal-card-body">
          <template v-if="tutorialModal.step === 'tutorial'">
            <!-- Selector de Motivo -->
            <b-field :label="iso === 'es' ? 'Motivo del Tutorial' : 'Tutorial Reason'">
              <b-select
                v-model="tutorialModal.selectedMotivo"
                :placeholder="iso === 'es' ? 'Selecciona un motivo' : 'Select a reason'"
                expanded
              >
                <option value="">-- {{ iso === 'es' ? 'Seleccionar' : 'Select' }} --</option>
                <option
                  v-for="option in tutorialMotivos"
                  :key="option.value"
                  :value="option.value"
                  :disabled="option.value === 'Bienvenida' && hasBienvenidaTutorial"
                >
                  {{ iso === 'es' ? option.labelES : option.labelEN
                  }}{{
                    option.value === 'Bienvenida' && hasBienvenidaTutorial
                      ? iso === 'es'
                        ? ' (Ya completada)'
                        : ' (Already completed)'
                      : ''
                  }}
                </option>
              </b-select>
            </b-field>

            <!-- Selector de Resultado -->
            <b-field :label="iso === 'es' ? 'Resultado del Tutorial' : 'Tutorial Result'">
              <b-select
                v-model="tutorialModal.selectedTema"
                :placeholder="iso === 'es' ? 'Selecciona un resultado' : 'Select a result'"
                expanded
              >
                <option value="">-- {{ iso === 'es' ? 'Seleccionar' : 'Select' }} --</option>
                <option
                  v-for="option in tutorialOptions"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ iso === 'es' ? option.labelES : option.labelEN }}
                </option>
              </b-select>
            </b-field>

            <!-- Campo de Comentario -->
            <b-field :label="i18n.comment?.[iso] || 'Comentario'">
              <b-input
                v-model="tutorialModal.comentario"
                type="textarea"
                :placeholder="
                  iso === 'es'
                    ? 'Ingresa el comentario o detalles del tutorial'
                    : 'Enter the tutorial comment or details'
                "
                maxlength="1000"
              ></b-input>
            </b-field>

            <b-message
              v-if="isBienvenidaCompletada"
              type="is-info"
              size="is-small"
              :closable="false"
            >
              {{
                iso === 'es'
                  ? 'Al continuar se capturará el discovery de la sesión de bienvenida.'
                  : 'Next you will capture the welcome session discovery.'
              }}
            </b-message>
          </template>

          <!-- Paso 2: discovery, solo para Bienvenida + Completada -->
          <template v-else-if="tutorialModal.step === 'discovery'">
            <div class="columns is-multiline">
              <div class="column is-6">
                <b-field
                  label-position="on-border"
                  :label="iso === 'es' ? '¿Quién solicitó el tutorial?' : 'Who requested the tutorial?'"
                >
                  <b-select
                    v-model="tutorialModal.discovery.solicitanteTipo"
                    expanded
                  >
                    <option :value="null">
                      -- {{ iso === 'es' ? 'Seleccionar' : 'Select' }} --
                    </option>
                    <option value="T">{{ i18n.owner[iso] }}</option>
                    <option value="C" v-if="coMemberId">
                      {{ i18n.coOwner[iso] }}
                    </option>
                    <option value="F" v-if="beneficiaries.length">
                      Friends and Family
                    </option>
                  </b-select>
                </b-field>
              </div>

              <div
                class="column is-6"
                v-if="tutorialModal.discovery.solicitanteTipo === 'F'"
              >
                <b-field
                  label-position="on-border"
                  :label="iso === 'es' ? '¿Cuál?' : 'Which one?'"
                >
                  <b-select
                    v-model="tutorialModal.discovery.solicitanteBeneficiario"
                    expanded
                  >
                    <option :value="null">
                      -- {{ iso === 'es' ? 'Seleccionar' : 'Select' }} --
                    </option>
                    <option
                      v-for="(beneficiary, idx) in beneficiaries"
                      :key="idx"
                      :value="idx"
                    >
                      {{ beneficiary.Nombre }} {{ beneficiary.ApellidoPaterno }}
                    </option>
                  </b-select>
                </b-field>
              </div>

              <div class="column is-6">
                <b-field
                  label-position="on-border"
                  :label="iso === 'es' ? 'Interés principal' : 'Main interest'"
                >
                  <b-select
                    v-model="tutorialModal.discovery.interesPrincipal"
                    expanded
                  >
                    <option :value="null">
                      -- {{ iso === 'es' ? 'Seleccionar' : 'Select' }} --
                    </option>
                    <option
                      v-for="option in discoveryOptions.interesPrincipal"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ iso === 'es' ? option.value : option.labelEN }}
                    </option>
                  </b-select>
                </b-field>
              </div>

              <div class="column is-6">
                <b-field
                  label-position="on-border"
                  :label="
                    iso === 'es'
                      ? 'Frecuencia de viaje estimada'
                      : 'Estimated travel frequency'
                  "
                >
                  <b-select
                    v-model="tutorialModal.discovery.frecuenciaViaje"
                    expanded
                  >
                    <option :value="null">
                      -- {{ iso === 'es' ? 'Seleccionar' : 'Select' }} --
                    </option>
                    <option
                      v-for="option in discoveryOptions.frecuenciaViaje"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ iso === 'es' ? option.value : option.labelEN }}
                    </option>
                  </b-select>
                </b-field>
              </div>

              <div class="column is-6">
                <b-field
                  label-position="on-border"
                  :label="
                    iso === 'es'
                      ? 'Fricción con el Club detectada'
                      : 'Detected friction with the Club'
                  "
                >
                  <b-select
                    v-model="tutorialModal.discovery.friccionClub"
                    expanded
                  >
                    <option :value="null">
                      -- {{ iso === 'es' ? 'Seleccionar' : 'Select' }} --
                    </option>
                    <option
                      v-for="option in discoveryOptions.friccionClub"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ iso === 'es' ? option.value : option.labelEN }}
                    </option>
                  </b-select>
                </b-field>
              </div>

              <div class="column is-6">
                <b-field
                  label-position="on-border"
                  :label="
                    iso === 'es'
                      ? '¿Tiene fecha o destino en mente?'
                      : 'Has a date or destination in mind?'
                  "
                >
                  <b-select
                    v-model="tutorialModal.discovery.fechaDestino"
                    expanded
                  >
                    <option :value="null">
                      -- {{ iso === 'es' ? 'Seleccionar' : 'Select' }} --
                    </option>
                    <option
                      v-for="option in discoveryOptions.fechaDestino"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ iso === 'es' ? option.value : option.labelEN }}
                    </option>
                  </b-select>
                </b-field>
              </div>

              <div class="column is-6">
                <b-field
                  label-position="on-border"
                  :label="
                    iso === 'es'
                      ? 'Canal de seguimiento preferido'
                      : 'Preferred follow-up channel'
                  "
                >
                  <b-select
                    v-model="tutorialModal.discovery.canalPreferido"
                    expanded
                  >
                    <option :value="null">
                      -- {{ iso === 'es' ? 'Seleccionar' : 'Select' }} --
                    </option>
                    <option
                      v-for="option in discoveryOptions.canalPreferido"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ iso === 'es' ? option.value : option.labelEN }}
                    </option>
                  </b-select>
                </b-field>
              </div>

              <div class="column is-6">
                <b-field
                  label-position="on-border"
                  :label="
                    iso === 'es'
                      ? 'Horario de contacto preferido'
                      : 'Preferred contact time'
                  "
                >
                  <b-select
                    v-model="tutorialModal.discovery.horarioPreferido"
                    expanded
                  >
                    <option :value="null">
                      -- {{ iso === 'es' ? 'Seleccionar' : 'Select' }} --
                    </option>
                    <option
                      v-for="option in discoveryOptions.horarioPreferido"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ iso === 'es' ? option.value : option.labelEN }}
                    </option>
                  </b-select>
                </b-field>
              </div>
            </div>
          </template>
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end">
          <template v-if="tutorialModal.step === 'tutorial'">
            <b-button @click="tutorialModal.isOpen = false">
              {{ i18n.cancel?.[iso] || 'Cancelar' }}
            </b-button>
            <b-button
              type="is-primary"
              @click="saveTutorialComment"
              :loading="loadingAddCommentTutorial"
            >
              {{
                isBienvenidaCompletada
                  ? iso === 'es'
                    ? 'Siguiente'
                    : 'Next'
                  : i18n.save?.[iso] || 'Guardar'
              }}
            </b-button>
          </template>
          <template v-else-if="tutorialModal.step === 'discovery'">
            <b-button @click="tutorialModal.step = 'tutorial'">
              {{ i18n.goBack?.[iso] || 'Regresar' }}
            </b-button>
            <b-button
              type="is-primary"
              @click="saveTutorialComment"
              :loading="loadingAddCommentTutorial"
            >
              {{ i18n.save?.[iso] || 'Guardar' }}
            </b-button>
          </template>
        </footer>
      </div>
    </b-modal>

    <ModalFFAgeWarning
      :active="ffAgeModal.active"
      :names="ffAgeModal.names"
      :iso="iso"
      :loading="ffAgeModal.loading"
      @cancel="cancelFFAgeWarning"
      @confirm="confirmFFAgeWarning"
    />

    <b-loading
      :is-full-page="true"
      v-model="loading"
      :can-cancel="false"
    ></b-loading>
  </div>
</template>

<script>
import axios from "axios";
const API_URL = process.env.VUE_APP_API_URL;
import moment from "moment";
import i18n, {
  addPayment,
  amount,
  beneficiaries,
  contract,
  type,
} from "../../utils/i18n";
import codCountries from "../../utils/codeCountries";
import CommentMember from "./CommentMember";
import ActionsMember from "./ActionsMember.vue";
import MemberBookings from "./MemberBookings.vue";
import ContractMember from "./ContractMember.vue";
import ModalSendSms from "./ModalSendSms.vue";
import FinancingMember from "../../components/FinancingMember.vue";
import PointsContent from "./PointsContent.vue";
import ModalFFAgeWarning from "../../components/ModalFFAgeWarning.vue";
import {
  resolveFFInvitationStatus,
  ffInvitationLabelKey,
  ffInvitationBadgeType,
  canResendInvitation,
  canRevokeInvitation,
} from "../../utils/ffInvitation";

const NO_MORE_FEES = "No more fees";
const cupons = [
  {
    discount: 0,
    code: "",
  },
  {
    discount: 5,
    code: "RNCC05",
  },
  {
    discount: 10,
    code: "RNCC10",
  },
  {
    discount: 15,
    code: "RNCC15",
  },
  {
    discount: 20,
    code: "RNCC20",
  },
  {
    discount: 25,
    code: "RNCC25",
  },
];
// {
//   discount: 0,
//   code: "RESET",
// },

const typePaymentsExternal = [
  {
    NombreEN: "Stripe",
    NombreES: "Stripe",
    id: "stripe",
  },
  {
    NombreEN: "Cash",
    NombreES: "Efectivo",
    id: "cash",
  },
  {
    NombreEN: "Wire Transfer",
    NombreES: "Transferencia Bancaria",
    id: "transfer",
  },
  {
    NombreEN: "Tarjeta de Crédito Converge",
    NombreES: "Credit Card Converge",
    id: "cardConverge",
  },
  {
    NombreEN: "CXC Employee",
    NombreES: "CXC Empleado",
    id: "cxcEmployee",
  },
  {
    NombreEN: "Discount",
    NombreES: "Descuento",
    id: "discount",
  },
  // {
  //   NombreEN: "Travel Voucher Club",
  //   NombreES: "Travel Voucher Club",
  //   id: "travelVoucher",
  // },

  {
    NombreEN: "Courtesy",
    NombreES: "Cortesía",
    id: "courtesy",
  },
  {
    NombreEN: "Bitrix",
    NombreES: "Bitrix",
    id: "bitrix",
  },
];

const TEMPLATE_MEMBER = {
  Nombre: null,
  ApellidoPaterno: null,
  // ApellidoMaterno: null,
  Email: null,
  FechaNacimiento: null,
  LadaTelefono: null,
  Telefono: null,
  LadaCelular: null,
  Celular: null,
  Pais: null,
  Estado: null,
  Ciudad: null,
  Direccion: null,
  CodigoPostal: null,
  Nacionalidad: null,
  EstadoCivil: null,
  TipoSocio: null,
  FechaRegistro: null,
  Idioma: null,
  EmailOK: null,
  TelefonoOK: null,
};

const TEMPLATE_CONTRACT = {
  Numero: null,
  FechaRenovacion: null,
  FechaCancelado: null,
  LoginID: null,
  Id: null,
  EstadoMembresia: false,
  EstadoContrato: 1,
  DiscountTravelVoucher: null,
  Cantidad: null,
  Monto: null,
  Idioma: "",
  FechaRegistro: null,
  FechaExpiracion: null,
  FechaActivacion: null,
};

const listCatalogues = [
  "CatEstadosPais",
  "CatEstadoCivil",
  "CatIdiomas",
  "CatTipoSocio",
  "CatPaises",
  "CatPeriodicidad",
  "CatStatusContrato",
  "CatTipoVenta",
  "CatParentescos",
];

const today = new Date();

export default {
  data() {
    return {

      isVip: false,
      AccesoWebSocio: 'si',
      ModalOnlinePayment: false,
      ModalOnlinePaymentResult: false,
      onlinePaymentGeneratedLink: "",
      onlinePaymentParams: {
        promo: null,
        qty: "1",
        reset: "n",
        feeextra: null,
        exp: null
      },

      isPaginated: true,
      isPaginationSimple: true,
      isPaginationRounded: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 10,
      hasInput: false,
      paginationOrder: "",
      inputPosition: "",
      inputDebounce: "",
      isBordered: false,
      isStriped: true,
      isNarrowed: true,
      isHoverable: true,
      isFocusable: false,
      isExpired: false,
      hasMobileCards: true,
      memberId: null,
      coMemberId: null,
      beMemberId: null,
      showModal: false,
      coin: null,
      newStatus: "",
      modalType: "",
      yearsRenew: 1,
      cuponRenew: null,
      modalStep: "renew",
      selectedOption: null,
      renewalUrl: "",
      copyMessage: "",

      showDatetimepicker: false,

      //addPayment
      userId: null,
      //i18n
      i18n,
      iso: null,

      //Permissions
      permissions: "",
      allPermissions: [],
      showButtons: false,

      //SMS
      newPhoneNumber: null,
      newEmail: null,
      phones: [],
      emails: [],

      codCountries: codCountries.map((c) => {
        return {
          ...c,
          dial_code: c.dial_code.substring(1),
        };
      }),
      loading: false,
      loadingAddCoOwner: false,
      data: null,
      // date: new Date(),
      minDate: new Date(
        today.getFullYear() - 80,
        today.getMonth(),
        today.getDate()
      ),
      // maxDate: new Date(
      //   today.getFullYear() + 18,
      //   today.getMonth(),
      //   today.getDate()
      // ),
      // maxDateToday: new Date(),
      member: {
        ...TEMPLATE_MEMBER,
      },
      coOwner: {
        ...TEMPLATE_MEMBER,
      },

      memberPuntos: 0,
      memberPuntosHistorial: [],
      coOwnerPuntos: 0,
      coOwnerPuntosHistorial: [],
      activePointsTab: 0,
      showAddPointsModal: false,
      loadingAddPoints: false,
      pointsModalStep: "form",
      pointsOtpCode: "",
      loadingPointsOtp: false,
      addPointsForm: {
        monto: null,
        Motivo: "",
        MotivoDetalle: "",
        destinatario: "titular",
      },
      showAddTravelVoucherModal: false,
      loadingAddTravelVoucher: false,
      addTravelVoucherForm: {
        monto: null,
        sendCertificate: "no",
      },
      memberTravelVouchers: [],
      contract: {
        ...TEMPLATE_CONTRACT,
      },

      cupons,
      typePaymentsExternal,
      priceFinal: 0,
      discountCupon: null,
      discountYears: null,
      priceOriginal: 0,
      detailsContract: null,

      newBeneficiario: {
        ContratoId: null,
        Nombre: "",
        ApellidoPaterno: "",
        Parentesco: 0,
        TipoSocio: "F",
        LadaTelefono: null,
        Telefono: null,

        /*
         * OPCIONAL
         */
        Email: null,
        Nacionalidad: null,
        EstadoCivil: null,
        Idioma: null,
        Password: null,
        Pais: null,
        Estado: null,
        Ciudad: null,
        Direccion: null,
        CodigoPostal: null,
        FechaNacimiento: null,
        LadaCelular: null,
        Celular: null,
        LadaOtro: null,
        OtroCelular: null,
      },
      newBeneficiarioAgeConfirmed: false,
      numberOfWeek: {
        VipWeeks: "",
        SmartWeeks: "",
        LastMinuteWeeks: "",
      },
      formPayment: {
        Monto: 0,
        // ContratoId: null,
        FechaPago: null,
        TipoPago: null,
        Years: null,
        Referencia: null,
        AbonoInicial: null,
        // MontoTotalPagoDiferido: null,
      },
      club: {
        Nombre: null,
        Plantillas: [],
        FirmasPlantillas: null,
      },
      travelVoucher: [],
      beneficiaries: [],
      ffAgeModal: { active: false, names: [], index: null, loading: false },
      renovations: [],
      statusAccounts: [],
      paymentMethod: [],
      bitrix24: null,
      FechaUltimoInicioSesion: null,
      FechaUltimoInicioSesionCoOwner: null,
      AgenteRenovacion: null,
      Tutorial: false,
      ifSyncBitrix: false,
      PrincipalPagador: "B",
      paymentsDeferred: [],
      AbonoInicialDeferred: null,
      loadingAddCommentTutorial: false,
      smsModal: { isOpen: false, persona: null, memberId: null, rol: "T" },
      tutorialModal: {
        isOpen: false,
        step: 'tutorial',
        selectedMotivo: null,
        selectedTema: null,
        comentario: '',
        discovery: {
          solicitanteTipo: null,
          solicitanteBeneficiario: null,
          interesPrincipal: null,
          frecuenciaViaje: null,
          friccionClub: null,
          fechaDestino: null,
          canalPreferido: null,
          horarioPreferido: null
        }
      },
      tutorialMotivos: [
        { labelES: 'Bienvenida', labelEN: 'Welcome', value: 'Bienvenida' },
        { labelES: 'Inactividad', labelEN: 'Inactivity', value: 'Inactividad' },
        { labelES: 'Pre-renovación', labelEN: 'Pre-renewal', value: 'Pre-renovación' },
        { labelES: 'Reactivación', labelEN: 'Reactivation', value: 'Reactivación' },
        { labelES: 'Solicitud del socio', labelEN: 'Member Request', value: 'Solicitud del socio' }
      ],
      tutorialOptions: [
        { labelES: 'Tutorial Completada', labelEN: 'Tutorial Completed', value: 27, hubspot: 'Completada' },
        { labelES: 'Tutorial No Show', labelEN: 'Tutorial No Show', value: 70, hubspot: 'No-show' },
        { labelES: 'Tutorial Reagendada', labelEN: 'Tutorial Rescheduled', value: 80, hubspot: 'Reagendada' },
        { labelES: 'Tutorial Cancelada', labelEN: 'Tutorial Canceled', value: 85, hubspot: 'Cancelada' }
      ],
      hasBienvenidaTutorial: false,
      tutorialComments: [],
      // El value es lo que se escribe tal cual en las propiedades discovery_* del
      // contacto en HubSpot, por eso va en espanol aunque el usuario vea ingles.
      discoveryOptions: {
        interesPrincipal: [
          { value: 'Viaje en pareja', labelEN: 'Couple travel' },
          { value: 'Viaje familiar', labelEN: 'Family travel' },
          { value: 'Solo travel', labelEN: 'Solo travel' },
          { value: 'Sin interés claro aún', labelEN: 'No clear interest yet' }
        ],
        frecuenciaViaje: [
          { value: 'Viajero frecuente', labelEN: 'Frequent traveler' },
          { value: 'Viajero ocasional', labelEN: 'Occasional traveler' },
          { value: 'Rara vez viaja', labelEN: 'Rarely travels' },
          { value: 'No mencionado', labelEN: 'Not mentioned' }
        ],
        friccionClub: [
          { value: 'Ninguna', labelEN: 'None' },
          { value: 'Leve', labelEN: 'Mild' },
          { value: 'Alta', labelEN: 'High' }
        ],
        fechaDestino: [
          { value: 'Sí, tiene fecha/destino', labelEN: 'Yes, has date/destination' },
          { value: 'No todavía', labelEN: 'Not yet' }
        ],
        canalPreferido: [
          { value: 'WhatsApp', labelEN: 'WhatsApp' },
          { value: 'Email', labelEN: 'Email' },
          { value: 'Llamada', labelEN: 'Call' }
        ],
        horarioPreferido: [
          { value: 'Mañana', labelEN: 'Morning' },
          { value: 'Tarde - noche', labelEN: 'Afternoon - evening' },
          { value: 'Fines de semana', labelEN: 'Weekends' }
        ]
      },

      activeTab: 0,
      isEdit: false,
      isCoEdit: false,
      listCatalogues,
      catalogues: {},
      selectedRow: null,
      loadingButtonEditStatusMembership: false,
      loadingButtonEditStatusContract: false,
      loadingButtonSendEmailMembershipStatus: false,
      loadingButtonRenewalPaymentLink: false,
      loadingResendPaymentLink: null,
      loadingCancelPaymentLink: null,
      loadingButtonSendPaymentExternal: false,
      loadingButtonSendPaymentDeferred: false,
      loadingButtonSendPaymentDeferred__step1: false,

      payLink: [],
      codeReset: false,
      agentEmail: null,
      usersStaff: [],
      // allPeriods: [],

      // Financing data
      financingData: {
        member: {},
        mensualidades: [],
        total: 0,
      },
      loadingFinancing: false,

      /**
       * Info
       */
      infoMembers: [
        {
          key: "Nombre",
          fieldIso: "name",
          type: "text",
          size: 3,
          isInfo: false,
          required: true,
        },
        {
          key: "ApellidoPaterno",
          fieldIso: "lastname_ext",
          type: "text",
          size: 3,
          isInfo: false,
          required: true,
        },
        // {
        //   key: "ApellidoMaterno",
        //   fieldIso: "mothersLastname",
        //   type: "text",
        //   size: 3,
        //   isInfo: false,
        // },
        {
          key: "Email",
          fieldIso: "email",
          type: "text",
          size: 3,
          isInfo: false,
          required: true,
        },
        {
          key: "FechaNacimiento",
          fieldIso: "birthdate",
          type: "date",
          size: 3,
          isInfo: false,
          required: true,
        },
        {
          key: "LadaTelefono",
          fieldIso: "codPhone",
          type: "select",
          size: 3,
          isInfo: false,
          options: "CatPaises",
          optionsIsCatalogue: true,
          optionsFilters: (data) => {
            if (!data || data.length === 0) return [];
            let tmp = [...data];
            return tmp
              .reduce((acum, value) => {
                const exists = acum.find((a) => a.Lada === value.Lada);
                if (!exists) acum.push(value);
                return acum;
              }, [])
              .sort((a, b) => (a.Lada > b.Lada ? 1 : b.Lada > a.Lada ? -1 : 0));
          },
          withFilters: true,
          valueOption: "Lada",
          showOption: (tmp) => {
            return `+${tmp.Lada}`;
          },
          required: true,
        },
        {
          key: "Telefono",
          fieldIso: "phone",
          type: "text",
          size: 3,
          isInfo: false,
          required: true,
        },
        {
          key: "LadaCelular",
          fieldIso: "codCellphone",
          type: "select",
          size: 3,
          isInfo: false,
          options: "CatPaises",
          optionsIsCatalogue: true,
          optionsFilters: (data) => {
            if (!data || data.length === 0) return [];
            let tmp = [...data];
            return tmp
              .reduce((acum, value) => {
                const exists = acum.find((a) => a.Lada === value.Lada);
                if (!exists) acum.push(value);
                return acum;
              }, [])
              .sort((a, b) => (a.Lada > b.Lada ? 1 : b.Lada > a.Lada ? -1 : 0));
          },
          withFilters: true,
          valueOption: "Lada",
          showOption: (tmp) => {
            return `+${tmp.Lada}`;
          },
        },
        {
          key: "Celular",
          fieldIso: "cellphone",
          type: "text",
          size: 3,
          isInfo: false,
        },
        {
          key: "Pais",
          fieldIso: "country",
          type: "select",
          size: 3,
          isInfo: false,
          options: "CatPaises",
          optionsIsCatalogue: true,
          valueOption: "Id",
          showOption: (tmp) => {
            return this.iso === "es" ? tmp.Nombre : tmp.NombreEn;
          },
          required: true,
        },
        {
          key: "Estado",
          fieldIso: "state",
          type: "select",
          size: 3,
          isInfo: false,
          options: "CatEstadosPais",
          optionsIsCatalogue: true,
          valueOption: "Id",
          optionsFilters: (data) => {
            if (!data || data.length === 0) return [];
            else return data.filter((d) => d.PaisId === this.member.Pais);
          },
          withFilters: true,
          showOption: (tmp) => {
            return this.iso === "es" ? tmp.Nombre : tmp.NombreEng;
          },
          required: true,
        },
        {
          key: "Ciudad",
          fieldIso: "city",
          type: "text",
          size: 3,
          isInfo: false,
          required: true,
        },
        {
          key: "Direccion",
          fieldIso: "address",
          type: "text",
          size: 3,
          isInfo: false,
          required: true,
        },
        {
          key: "CodigoPostal",
          fieldIso: "zip",
          type: "text",
          size: 3,
          isInfo: false,
          required: true,
        },
        {
          key: "Nacionalidad",
          fieldIso: "nationality",
          type: "select",
          size: 3,
          isInfo: false,
          options: "CatPaises",
          optionsIsCatalogue: true,
          valueOption: "Id",
          showOption: (tmp) => {
            return this.iso === "es" ? tmp.Nacionalidad : tmp.NacionalidadEn;
          },
          required: true,
        },
        {
          key: "EstadoCivil",
          fieldIso: "civilStatus",
          type: "select",
          size: 3,
          isInfo: false,
          options: "CatEstadoCivil",
          optionsIsCatalogue: true,
          valueOption: "Id",
          showOption: (tmp) => {
            return this.iso === "es" ? tmp.Nombre : tmp.NombreEn;
          },
          required: true,
        },
        {
          key: "Idioma",
          fieldIso: "language",
          type: "select",
          size: 3,
          isInfo: false,
          options: "CatIdiomas",
          optionsIsCatalogue: true,
          valueOption: "Id",
          showOption: (tmp) => {
            return this.iso === "es" ? tmp.Nombre : tmp.NombreEn;
          },
          required: true,
        },
        // {
        //   key: "FechaRegistro",
        //   fieldIso: "registrationDate",
        //   type: "text",
        //   size: 3,
        //   isInfo: true,
        // },
      ],
      infoCoMembers: () => [
        ...this.infoMembers,
        // ...this.infoMembers.filter((t) =>
        //   [
        //     "Nombre",
        //     "ApellidoPaterno",
        //     "Email",
        //     "LadaTelefono",
        //     "Telefono",
        //   ].includes(t.key)
        // ),
      ],
      infoNumberOfWeek: [
        // {
        //   key: "VipWeeks",
        //   fieldIso: "vipWeeks",
        //   type: "text",
        //   size: 3,
        //   isInfo: false,
        //   required: true,
        // },
        {
          key: "VipWeeks",
          fieldIso: "vipWeeks",
          type: "select",
          size: 3,
          isInfo: false,
          required: true,
          options: () => [
            { Key: "1", Value: 1 },
            { Key: "2", Value: 2 },
            { Key: "3", Value: 3 },
            { Key: "4", Value: 4 },
            { Key: "5", Value: 5 },
            { Key: "6", Value: 6 },
            { Key: "7", Value: 7 },
            { Key: "8", Value: 8 },
            { Key: "9", Value: 9 },
            { Key: "10", Value: 10 },
            { Key: "Unlimited", Value: 99 },
          ],
          optionsExec: true,
          optionsIsCatalogue: false,
          withFilters: false,
          valueOption: "Value",
          showOption: (tmp) => {
            return tmp.Key;
          },
        },
        {
          key: "SmartWeeks",
          fieldIso: "smartWeeks",
          type: "text",
          size: 3,
          isInfo: false,
          required: true,
        },

        {
          key: "LastMinuteWeeks",
          fieldIso: "lastMinuteWeeks",
          type: "text",
          size: 3,
          isInfo: false,
          required: true,
        },
      ],
      infoBeneficiares: [
        {
          key: "Nombre",
          fieldIso: "name",
          type: "text",
          size: 3,
          isParse: false,
          isInfo: false,
          required: true,
        },
        {
          key: "ApellidoPaterno",
          fieldIso: "lastname",
          type: "text",
          isParse: false,
          size: 3,
          isInfo: false,
          required: true,
        },
        {
          key: "Parentesco",
          fieldIso: "relationship",
          type: "select",
          size: 3,
          isInfo: false,
          optionIsCatalogue: true,
          options: "CatParentescos",
          valueOption: "Id",
          showOption: (tmp) => {
            return this.iso === "es" ? tmp.Nombre : tmp.NombreEn;
          },
          required: true,
        },
        {
          key: "Email",
          fieldIso: "email",
          type: "text",
          isParse: false,
          size: 3,
          isInfo: false,
          required: true,
        },
        {
          key: "LadaTelefono",
          fieldIso: "codCellphone",
          type: "select",
          size: 3,
          isInfo: false,
          optionsIsCatalogue: true,
          options: "CatPaises",
          valueOption: "Lada",
          showOption: (tmp) => {
            return `+${tmp.Lada}`;
          },
          required: false,
        },
        {
          key: "Telefono",
          fieldIso: "cellphone",
          type: "text",
          isParse: false,
          size: 3,
          isInfo: false,
          required: false,
        },
      ],
      infoContract: [
        {
          key: "EstadoContrato",
          fieldIso: "contractStatus",
          section: "contrat",
          type: "select",
          size: 3,
          isInfo: false,
          options: "CatStatusContrato",
          optionsIsCatalogue: true,
          valueOption: "Id",
          showOption: (tmp) => {
            return this.iso === "es" ? tmp.Nombre : tmp.NombreEn;
          },
          required: true,
        },
        {
          key: "Idioma",
          fieldIso: "language",
          section: "contrat",
          type: "select",
          size: 3,
          isInfo: false,
          options: "CatIdiomas",
          optionsIsCatalogue: true,
          valueOption: "Id",
          showOption: (tmp) => {
            return this.iso === "es" ? tmp.Nombre : tmp.NombreEn;
          },
          required: true,
        },
        {
          key: "Numero",
          section: "contrat",
          fieldIso: "contractNumber",
          type: "text",
          size: 3,
          isInfo: false,
          required: true,
        },
        {
          key: "LoginID",
          fieldIso: "LoginID",
          section: "membresia",
          type: "text",
          size: 3,
          isInfo: false,
          required: true,
        },
        {
          key: "EstadoMembresia",
          fieldIso: "membershipStatus",
          section: "membresia",
          isParse: true,
          parse: (value) => {
            return value
              ? this.i18n.active[this.iso]
              : this.i18n.inactive[this.iso];
          },
        },
        {
          key: "FechaActivacion",
          type: "date",
          isInfo: false,
          fieldIso: "activationDate",
          section: "membresia",
          isParse: true,
          parse: (value) => {
            return this.parseDate(value);
          },
        },
        {
          key: "FechaRenovacion",
          type: "date",
          isInfo: false,
          fieldIso: "renovationDate",
          section: "membresia",
          isParse: true,
          /* parse: (value) => {
            return this.parseDate(value);
          }, */
          parse: (value) => {
            const now = Date.now();
            this.isExpired = value <= now;
            return this.isExpired
              ? this.parseDate(value)
              : this.parseDate(value);
          },
        },
        {
          key: "Years",
          section: "contrat",
          fieldIso: "years",
          type: "text",
          size: 3,
          isInfo: false,
          required: true,
        },
        ...(!this.isCap
          ? [
              {
                key: "Tarifa",
                fieldIso: "fee",
                section: "membresia",
                type: "number",
                isParse: true,
                edit: true,
                parse: (value, obj = []) => {
                  return `$ ${value} ${obj.Moneda}`;
                },
              },
            ]
          : [{}]),
        {
          key: "Periodicidad",
          fieldIso: "period",
          section: "membresia",
          isParse: true,
          parse: (value) => {
            const cat = this.catalogues["CatPeriodicidad"];

            if (cat) {
              const rgx = new RegExp(value, "ig");
              const tmp = cat.find((c) => rgx.test(c.Id));
              if (tmp) return this.iso === "en" ? tmp?.NombreEn : tmp?.Nombre;
              else return "";
            } else return "";
          },
        },
        {
          key: "FechaRegistro",
          required: true,
          type: "text",
          isInfo: false,
          section: "contrat",
          fieldIso: "registrationDate",
          isParse: true,
          parse: (value) => {
            return this.parseDate(value);
          },
        },
        {
          key: "FechaCompra",
          section: "contrat",
          required: true,
          type: "text",
          isInfo: false,
          fieldIso: "purchaseDate",
          isParse: true,
          parse: (value) => {
            return this.parseDate(value);
          },
        },
        {
          key: "FechaProcesable",
          section: "contrat",
          required: true,
          type: "text",
          isInfo: false,
          fieldIso: "processableDate",
          isParse: true,
          parse: (value) => {
            return this.parseDate(value);
          },
        },
        {
          key: "FechaCancelado",
          section: "contrat",
          required: true,
          type: "text",
          isInfo: false,
          fieldIso: "cancellationDate",
          isParse: true,
          parse: (value) => {
            return this.parseDate(value);
          },
        },

        {
          key: "FechaExpiracion",
          required: true,
          section: "suscripcion",
          isInfo: false,
          type: "text",
          fieldIso: "subscription",
          isParse: true,
          /* parse: (value) => {
            return this.parseDate(value);
          }, */
          parse: (value) => {
            const now = Date.now();
            this.isExpired = value <= now;
            return this.isExpired
              ? this.i18n.expired[this.iso]
              : this.parseDate(value);
          },
        },
      ],
      infoVoucher: [
        {
          key: "Cantidad",
          fieldIso: "travelVoucher",
          type: "text",
          size: 3,
          isInfo: false,
          required: true,
        },

        {
          key: "Monto",
          fieldIso: "discountTravelVoucher",
          type: "text",
          size: 3,
          isInfo: false,
          required: true,
        },
      ],
      infoDetailsContract: [
        {
          key: "PrecioContrato",
          fieldIso: "priceContract",
          isParse: true,
          parse: (value) => {
            if (!value && value !== 0) return "";
            let parts = value.toString().split(".");
            let v = parts[0].replace(/\D/g, ""),
              dec = parts[1];
            let n = new Intl.NumberFormat("en-EN").format(v);
            n = dec !== undefined ? n + "." + dec : n;
            return `$ ${n}`;
          },
        },
        {
          key: "CostoAdministracion",
          fieldIso: "administrationCost",
          isParse: true,
          parse: (value) => {
            if (!value && value !== 0) return "";
            let parts = value.toString().split(".");
            let v = parts[0].replace(/\D/g, ""),
              dec = parts[1];
            let n = new Intl.NumberFormat("en-EN").format(v);
            n = dec !== undefined ? n + "." + dec : n;
            return `$ ${n}`;
          },
        },
        {
          key: "PagoInicial",
          fieldIso: "initialPayment",
          isParse: true,
          parse: (value) => {
            if (!value && value !== 0) return "";
            let parts = value.toString().split(".");
            let v = parts[0].replace(/\D/g, ""),
              dec = parts[1];
            let n = new Intl.NumberFormat("en-EN").format(v);
            n = dec !== undefined ? n + "." + dec : n;
            return `$ ${n}`;
          },
        },
        {
          key: "PorcentajePagoInicial",
          fieldIso: "downPaymentPercentage",
          isParse: true,
          parse: (value) => {
            if (!value && value !== 0) return "";
            let parts = value.toString().split(".");
            let v = parts[0].replace(/\D/g, ""),
              dec = parts[1];
            let n = new Intl.NumberFormat("en-EN").format(v);
            n = dec !== undefined ? n + "." + dec : n;
            return `${n}%`;
          },
        },
        {
          key: "Saldo",
          fieldIso: "balance",
          isParse: true,
          parse: (value) => {
            if (!value && value !== 0) return "";
            let parts = value.toString().split(".");
            let v = parts[0].replace(/\D/g, ""),
              dec = parts[1];
            let n = new Intl.NumberFormat("en-EN").format(v);
            n = dec !== undefined ? n + "." + dec : n;
            return `$ ${n}`;
          },
        },
        {
          key: "Mensualidades",
          fieldIso: "monthlyPayments",
          type: "number",
          size: 3,
          isInfo: false,
          required: false,
        },
        {
          key: "PagoMensual",
          fieldIso: "monthlyPayment",
          isParse: true,
          parse: (value) => {
            if (!value && value !== 0) return "";
            let parts = value.toString().split(".");
            let v = parts[0].replace(/\D/g, ""),
              dec = parts[1];
            let n = new Intl.NumberFormat("en-EN").format(v);
            n = dec !== undefined ? n + "." + dec : n;
            return `$ ${n}`;
          },
        },
        {
          key: "FechaPrimeraMensualidad",
          fieldIso: "firstMonthlyDate",
          isParse: true,
          parse: (value) => {
            if (!value) return "";
            const date = moment(value).utc().locale(this.iso).format("ll");
            return date;
          },
        },
        {
          key: "TasaInteres",
          fieldIso: "interestRate",
          isParse: true,
          parse: (value) => {
            if (!value && value !== 0) return "";
            let parts = value.toString().split(".");
            let v = parts[0].replace(/\D/g, ""),
              dec = parts[1];
            let n = new Intl.NumberFormat("en-EN").format(v);
            n = dec !== undefined ? n + "." + dec : n;
            return `${n}%`;
          },
        },
      ],

      missingFields: [],
      ModalOptionActive: false,
    };
  },
  props: ["isCap"],
  computed: {
    // El discovery solo se levanta cuando la bienvenida se cierra como completada:
    // es la unica sesion en la que el agente alcanza a hacer esas preguntas.
    isBienvenidaCompletada() {
      return (
        this.tutorialModal.selectedMotivo === "Bienvenida" &&
        Number(this.tutorialModal.selectedTema) === 27
      );
    },
    tutorialSolicitanteNombre() {
      const { solicitanteTipo, solicitanteBeneficiario } =
        this.tutorialModal.discovery;

      const fullName = (p) =>
        [p?.Nombre, p?.ApellidoPaterno].filter(Boolean).join(" ").trim();

      if (solicitanteTipo === "T") return fullName(this.member);
      if (solicitanteTipo === "C") return fullName(this.coOwner);
      if (solicitanteTipo === "F" && solicitanteBeneficiario !== null)
        return fullName(this.beneficiaries[solicitanteBeneficiario]);

      return "";
    },
    // totalAmount() {
    //   let t = this.contract.Tarifa * this.formPayment.Years;

    //   if (this.formPayment.Years === 99) t = this.contract.Tarifa * 10;

    //   this.formPayment.Monto = parseFloat(t.toFixed(2));
    //   return parseFloat(t.toFixed(2));
    //   // return `$ ${t.toFixed(2)} USD`;
    // },
    totalAmountPaymentLink() {
      let t = this.contract.Tarifa * this.yearsRenew;
      // this.priceOriginal = parseFloat(t.toFixed(2));
      // let d = 0
      // if (this.yearsRenew === 3) {
      //   t = t - t * (10 / 100);
      //   this.discountYears = parseFloat((t * (10 / 100)).toFixed(2));
      // }
      // if (this.yearsRenew === 5) {
      //   t = t - t * (20 / 100);
      //   this.discountYears = parseFloat((t * (20 / 100)).toFixed(2));
      // }

      if (this.yearsRenew === 99) t = this.contract.Tarifa * 10;

      this.priceOriginal = parseFloat(t.toFixed(2));

      if (this.cuponRenew) {
        const discount = this.cupons.find((c) => c.code === this.cuponRenew);
        if (discount) {
          t = t - t * (discount.discount / 100);
          this.discountCupon = parseFloat(
            (this.priceOriginal * (discount.discount / 100)).toFixed(2)
          );
        }
      }

      this.priceFinal = parseFloat(t.toFixed(2));

      return `$ ${this.priceFinal} USD`;
    },
    onlinePaymentTotal() {
      if (!this.contract || !this.contract.Tarifa) return 0;
      let tarifa = this.contract.Tarifa;
      let qty = this.onlinePaymentParams.qty == '99' ? 10 : Number(this.onlinePaymentParams.qty);
      let subtotal = tarifa * qty;
      let discount = 0;
      if (this.onlinePaymentParams.promo === "RNCC05") discount = subtotal * 0.05;
      else if (this.onlinePaymentParams.promo === "RNCC10") discount = subtotal * 0.10;
      else if (this.onlinePaymentParams.promo === "RNCC15") discount = subtotal * 0.15;
      else if (this.onlinePaymentParams.promo === "RNCC20") discount = subtotal * 0.20;
      else if (this.onlinePaymentParams.promo === "RNCC25") discount = subtotal * 0.25;
      
      let feeextra = Number(this.onlinePaymentParams.feeextra) || 0;
      return (subtotal - discount + feeextra).toFixed(2);
    },
    maxDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Los meses son indexados desde 0
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    sortedRenovations() {
      // return this.renovations.slice().sort((a, b) => {
      //   if (!a.FechaPago) return 1;
      //   if (!b.FechaPago) return -1;
      //   return new Date(b.FechaPago) - new Date(a.FechaPago);
      // });
      return this.renovations;
    },
    lastRenovationDate() {
      if (this.renovations && this.renovations.length > 0) {
        const lastRenovation = this.renovations[this.renovations.length - 1];
        return lastRenovation ? lastRenovation.FechaFinPeriodo : null;
      }
      return null;
    },
    periodOptions() {
      const periods = [];
      let dateA =
        this.contract?.FechaRenovacion || this.contract?.FechaRegistro;
      let YearsCondoned = 0;
      if (this.codeReset) {
        let newDateA = moment().valueOf();
        YearsCondoned = moment(newDateA).diff(moment(dateA), "years");
        dateA = newDateA;
      }

      for (let i = 1; i <= 10; i++) {
        let dateB = this.calculateNewExpirationDate(dateA, i);
        if (this.codeReset) dateB = this.calculateNewExpirationDate(dateA, i);
        periods.push({
          value: i,
          label: `${i} ${this.i18n.years[this.iso]} (${this.parseDate(
            dateA
          )} - ${this.parseDate(dateB)}) `, //${i === 3 ? "[10%]" : i === 5 ? "[20%]" : ""}
          showPeriodIfCodeReset: `${this.parseDate(dateA)} - ${this.parseDate(
            dateB
          )}`,
          YearsCondoned,
        });
      }
      periods.push({
        value: 99,
        label: NO_MORE_FEES, //[25%]
        YearsCondoned,
        showPeriodIfCodeReset: NO_MORE_FEES,
      });
      // this.allPeriods = periods;
      return periods;
    },
    /* addEmailOwner(){
      this.emails.push(this.newPhoneNumber);
    } */
  },
  async created() {
    if (!this.$route.query?.id && !this.$route.query?.ContratoId)
      this.$router.push("/catcher-members");
    if (this.$route.query?.view === "contract") this.activeTab = 1;

    this.iso = localStorage.getItem("iso");
    this.$bus.on("change-iso", () => {
      this.iso = localStorage.getItem("iso");
    });

    //UserId
    this.userId = localStorage.getItem("userId");

    //PerPage
    const perPageLocalStorage = localStorage.getItem("perPageReserves");
    if (!perPageLocalStorage) this.savePerPage();
    else this.perPage = perPageLocalStorage;

    //Permissions
    this.permissions = localStorage.getItem("role");
    this.allPermissions = localStorage.getItem("permissions")
      ? JSON.parse(localStorage.getItem("permissions"))
      : [];

    console.log(this.permissions);

    //
    await this.getCatalogues();
    await this.getTypePayment();
    await this.getProfile();
    await this.allUsersStaff();
  },
  components: {
    CommentMember,
    ActionsMember,
    MemberBookings,
    ContractMember,
    ModalSendSms,
    FinancingMember,
    PointsContent,
    ModalFFAgeWarning,
  },
  mounted() {},
  methods: {
    generateOnlinePaymentLink() {
      let url = `https://vacancyrewards.com/renewals?qty=${this.onlinePaymentParams.qty}${this.onlinePaymentParams.promo ? `&promo=${this.onlinePaymentParams.promo}` : ``}&reset=${this.onlinePaymentParams.reset}`;
      if (this.onlinePaymentParams.feeextra) {
        url += `&feeextra=${this.onlinePaymentParams.feeextra}`;
      }
      if (this.onlinePaymentParams.exp) {
        url += `&exp=${new Date(this.onlinePaymentParams.exp).getTime()}`;
      }
      this.onlinePaymentGeneratedLink = url;
      this.ModalOnlinePayment = false;
      this.ModalOnlinePaymentResult = true;
    },
    async copyOnlinePaymentLink() {
      try {
        await navigator.clipboard.writeText(this.onlinePaymentGeneratedLink);
        this.$buefy.toast.open({
          message: this.i18n?.copied?.[this.iso] || "Copiado",
          type: "is-success",
        });
      } catch (err) {
        console.error("Failed to copy: ", err);
      }
    },
    async getProfile() {
      try {
        let query = {};
        if (this.$route.query?.id) query.idMongo = this.$route.query?.id;
        if (this.$route.query?.ContratoId)
          query.ContratoId = this.$route.query?.ContratoId;
        const qs = new URLSearchParams(query);

        const { data } = await axios.get(
          `${API_URL}/catcher/members?${qs.toString()}`
        );
        this.data = data;
        await this.parseData(this.data);
        await this.loadTutorialComments();

        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al consultar datos de socio",
          type: "is-danger",
        });
      }
    },
    async loadTutorialComments() {
      try {
        if (!this.contract?.Id) return;

        const { data } = await axios.post(
          `${API_URL}/catcher/members/comments/list`,
          {
            ContratoId: this.contract.Id,
            Tipo: 'contract'
          }
        );

        this.tutorialComments = data?.comments || [];

        // Solo una bienvenida COMPLETADA (tema 27) cierra el motivo. Una reagendada,
        // no-show o cancelada todavía permite registrar después la completada, que es
        // la que otorga los puntos. Misma regla que el backend (EstadoTutorial).
        this.hasBienvenidaTutorial =
          this.contract?.EstadoTutorial === true ||
          this.tutorialComments.some(
            comment => comment.Motivo === 'Bienvenida' && Number(comment.Tema) === 27
          );
      } catch (err) {
        console.log('Error al obtener comentarios de tutorial:', err);
      }
    },
    async getFinancingData() {
      try {
        this.loadingFinancing = true;
        const { data } = await axios.get(
          `${API_URL}/financing/member/${this.memberId}`
        );
        this.financingData = data;
        this.loadingFinancing = false;
      } catch (err) {
        this.loadingFinancing = false;
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al consultar datos de financiamiento",
          type: "is-danger",
        });
      }
    },
    async onPaymentAdded(paymentData) {
      // Recargar los datos de financiamiento cuando se agrega un pago
      await this.getFinancingData();

      this.$buefy.notification.open({
        duration: 5000,
        message: `Nuevo pago registrado: Mensualidad ${paymentData.financing.Mensualidad} - $${paymentData.payment.amount} USD`,
        position: "is-top-right",
        type: "is-success",
        hasIcon: true,
      });
    },
    allowEdit() {
      this.isEdit = true;
    },
    allowCoEdit() {
      this.isCoEdit = true;
    },
    cancelEdit() {
      this.isEdit = false;
      this.parseData(this.data);
    },
    cancelCoEdit() {
      this.isCoEdit = false;
    },
    async editProfile() {
      try {
        this.loading = true;
        await axios.put(`${API_URL}/catcher/members/edit/${this.memberId}`, {
          ...this.member,
        });
        this.cancelEdit();
        this.getProfile();
        this.loading = false;
        this.$buefy.toast.open({
          message: "Updated OK",
          type: "is-success",
        });
      } catch (err) {
        this.loading = false;
        console.log(err);
        let typeError = err?.response?.data?.typeError;
        if (typeError) {
          this.$buefy.toast.open({
            message:
              typeError?.message[this.iso] || "Error al editar datos de socio",
            type: "is-danger",
          });
        } else {
          this.$buefy.toast.open({
            message: "Error al editar datos de socio",
            type: "is-danger",
          });
        }
      }
    },
    async editFriendsAndFamily() {
      try {
        this.loading = true;
        for (const benef of this.beneficiaries) {
          try {
            await axios.put(`${API_URL}/catcher/members/edit/${benef._id}`, {
              Nombre: benef.Nombre,
              ApellidoPaterno: benef.ApellidoPaterno,
              Parentesco: benef.Parentesco,
              Email: (benef.Email || "").toString().trim() || null,
              LadaTelefono: benef.LadaTelefono || null,
              Telefono: (benef.Telefono || "").toString() || null,
            });
          } catch (err) {
            console.log(`Error al actualizar el beneficiario`, err);
            this.$buefy.toast.open({
              message: `Error al actualizar el beneficiario`,
              type: "is-danger",
            });
          }
        }
        this.cancelEdit();
        await this.getProfile();
        this.loading = false;
        this.$buefy.toast.open({
          message: "Updated OK",
          type: "is-success",
        });
      } catch (err) {
        this.loading = false;
        console.log(err);
        let typeError = err?.response?.data?.typeError;
        if (typeError) {
          this.$buefy.toast.open({
            message:
              typeError?.message[this.iso] ||
              "Error al editar datos de amigos y familia",
            type: "is-danger",
          });
        } else {
          this.$buefy.toast.open({
            message: "Error al editar datos de amigos y familia",
            type: "is-danger",
          });
        }
      }
    },
    async editCoProfile() {
      try {
        this.loading = true;
        await axios.put(`${API_URL}/catcher/members/edit/${this.coMemberId}`, {
          ...this.coOwner,
        });
        this.cancelEdit();
        this.getProfile();
        this.loading = false;
        this.isCoEdit = false;
        this.$buefy.toast.open({
          message: "Updated OK",
          type: "is-success",
        });
      } catch (err) {
        this.loading = false;
        this.cancelCoEdit();
        console.log(err);
        let typeError = err?.response?.data?.typeError;
        if (typeError) {
          this.$buefy.toast.open({
            message:
              typeError?.message[this.iso] ||
              "Error al editar datos de co titular",
            type: "is-danger",
          });
        } else {
          this.$buefy.toast.open({
            message: "Error al editar datos de co titular",
            type: "is-danger",
          });
        }
      }
    },
    parseData(data) {
      if (data?.member) {
        this.memberId = data.member?._id;
        this.LoginID = data.member?.ContratoId?.LoginID;
        this.AccesoWebSocio = data.member?.AccesoWebSocio;

        for (let i in this.member) {
          this.member[i] = data.member[i];
        }

        // Agregar el _id manualmente ya que no está en TEMPLATE_MEMBER
        this.member._id = data.member._id;

        this.memberPuntos = data.member?.Puntos ?? 0;
        this.memberPuntosHistorial = data.member?.PuntosHistorial ?? [];

        this.memberTravelVouchers = data.member?.travelVouchers ?? [];

        if (this.member.FechaNacimiento) {
          this.member.FechaNacimiento = new Date(this.member.FechaNacimiento);
        } else this.member.FechaNacimiento = null;

        if (data.member && data.member.HsData && data.member.HsData.id_hs_contact) {
          this.$set(this.member, 'HsData', data.member.HsData.id_hs_contact);
        } else {
          this.$set(this.member, 'HsData', null);
        }

        if (data.member?.beneficiaries) {
          this.beneficiaries = data.member?.beneficiaries;
        }

        if (data.member?.numberOfWeeks) {
          this.numberOfWeek = data.member?.numberOfWeeks;
        }

        // if (data.member?.detailsContract?.TravelVoucher) {
        //   this.travelVoucher = data.member?.detailsContract?.TravelVoucher;
        // }

        if (data?.member?.detailsContract) {
          let tmp = data.member.detailsContract;

          this.travelVoucher = tmp.TravelVoucher || [];

          delete tmp._id;
          delete tmp.Eliminado;
          delete tmp.FechaRegistro;
          delete tmp.__v;
          delete tmp.TravelVoucher;
          delete tmp.ContratoId;
          this.detailsContract = tmp;
        }

        if (data.member?.coOwner) {
          this.coMemberId = data.member?.coOwner._id;
          for (let i in this.coOwner) {
            this.coOwner[i] = data.member.coOwner[i];
          }
          this.coOwnerPuntos = data.member.coOwner?.Puntos ?? 0;
          this.coOwnerPuntosHistorial =
            data.member.coOwner?.PuntosHistorial ?? [];
          if (this.coOwner.FechaNacimiento) {
            this.coOwner.FechaNacimiento = new Date(
              this.coOwner.FechaNacimiento
            );
          } else this.coOwner.FechaNacimiento = null;

          if (this.coOwner.FechaRegistro) {
            this.coOwner.FechaRegistro = moment(
              this.coOwner.FechaRegistro
            ).format("DD-MM-YYYY");
          } else this.coOwner.FechaRegistro = null;

          if (data.member?.coOwner?.FechaUltimoInicioSesion) {
            this.FechaUltimoInicioSesionCoOwner = this.parseDate(
              data.member.coOwner.FechaUltimoInicioSesion
            );
          } else this.FechaUltimoInicioSesionCoOwner = null;

          if (data.member?.coOwner?.HsData && data.member?.coOwner?.HsData.id_hs_contact) {
            this.coOwner.HsData = data.member.coOwner.HsData.id_hs_contact
          } else {
            this.coOwner.HsData = null
          }
        }

        if (data?.member?.ContratoId) {
          this.contract = data?.member?.ContratoId;

          // Agregar información del contrato al objeto member para que llegue al modal
          this.member.ContratoId = data.member.ContratoId.Id;
          this.member.NumeroContrato = data.member.ContratoId.Numero;

          this.club.Nombre = data.member.ContratoId?.ClubId?.Nombre || "";
          this.club.FirmasPlantillas = data.member.ContratoId?.ClubId?.FirmasPlantillas || null;
          this.club.Plantillas = [];
          if (data.member.ContratoId?.ClubId?.Plantillas) {
            const Plantillas = data.member.ContratoId?.ClubId?.Plantillas;
            for (let i in Plantillas) {
              const doc = data.member?.files.find((f) => f.Referencia === i);
              const docPayload = {
                Referencia: i,
                Nombre: doc?.Nombre || null,
                FechaCreacion: doc?.FechaCreacion || null,
                Id: doc?.Id || null,
                CreadoPor: doc?.CreadoPor || null,
              };
              this.club.Plantillas.push(docPayload);
            }
          }
        }

        if (data?.member?.renovations) {
          this.renovations = data.member.renovations;

          //Check vip
          let isvip = data.member.renovations.find((r) => r.Anualidades === 99);
          this.isVip = isvip ? true : false;
        }

        if (data?.member?.statusAccount) {
          this.statusAccounts = data.member.statusAccount;
        }

        if (data?.member?.bitrixFound) {
          this.bitrix24 = data.member.bitrixFound.map((b) => b.ID).join(", ");
        }

        if (data?.member?.FechaUltimoInicioSesion) {
          this.FechaUltimoInicioSesion = this.parseDate(
            data.member.FechaUltimoInicioSesion
          );
        }

        if (data?.member?.AgenteRenovacion) {
          this.AgenteRenovacion = `${
            data?.member?.AgenteRenovacion?.Nombre || ""
          } ${data?.member?.AgenteRenovacion?.Apellido || ""}`;
        }

        if (data?.member?.Tutorial) {
          this.Tutorial = data?.member?.Tutorial;
        }

        if (
          !this.bitrix24
          // &&
          // data?.member?.ContratoId?.EstadoMembresia &&
          // data?.member?.ContratoId?.EstadoContrato === 2 &&
          // data?.member?.ContratoId?.FechaRenovacion > Date.now()
        ) {
          this.ifSyncBitrix = true;
        }

        if (data?.member?.payLink && data?.member?.payLink.length > 0) {
          for (let payLink of data.member.payLink) {
            this.payLink.push(payLink);
            // const payLink = pl;
            const payloadLink = {
              SolicitudId: "",
              ContratoId: this.member?.ContratoId?.Id,
              FechaPago: "",
              FechaInicioPeriodo:
                payLink?.DatosUtiles?.FechaInicioPeriodo ||
                this.contract?.FechaRenovacion ||
                this.contract?.Expiracion ||
                this.contract?.Registro,
              FechaFinPeriodo: payLink?.DatosUtiles?.FechaFinPeriodo || "",
              Anualidades: payLink?.AniosRenovacion || "",
              Cargo: payLink?.Monto || "",
              MemberId: payLink?.CreadoPorEmail || "",
              FechaEnvio: payLink?.FechaEnvio || "",
              ConfirmacionPago: "",
              isPayLink: true,
              PayLinkId: payLink?.Id,
              EsDiferido: payLink?.DatosUtiles?.isDeferred || false,
            };
            this.renovations = [payloadLink, ...this.renovations];
          }
        }

        if (
          data?.member?.paymentsDeferred &&
          data.member?.paymentsDeferred?.main
        ) {
          this.paymentsDeferred = [data.member?.paymentsDeferred];
        }
      }
    },
    async getCatalogues() {
      try {
        this.loading = true;

        const promises = [];

        for (let cat of listCatalogues) {
          promises.push(
            axios
              .get(`${API_URL}/catalogue/${cat}`)
              .then(({ data }) => {
                this.catalogues[cat] = data;
              })
              .catch((err) => {
                console.log(err);
                this.$buefy.toast.open({
                  message: "Error al consultar datos de catalogos",
                  type: "is-danger",
                });
              })
          );
          // const { data } = await axios.get(`${API_URL}/catalogue/${cat}`);
          // this.catalogues[cat] = data;
        }

        await Promise.all(promises);

        // console.log("catalogues", this.catalogues);
        // this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al consultar datos de catalogos",
          type: "is-danger",
        });
      }
    },

    parseDate(value, withUtc = true) {
      moment.locale(this.iso);
      if (withUtc)
        return value ? moment(value).utc().format("MMMM D, YYYY") : "";
      else return value ? moment(value).format("MMMM D, YYYY") : "";
    },

    emitGoLastComment() {
      this.$refs.commentmember.goLastToComment();
    },
    actionTab(tab) {
      if (tab === 5) this.getFinancingData(); // Cargar datos de financing
      if (tab === 6) this.emitGoLastComment();
    },
    /* renew() {
      this.$buefy.dialog.prompt({
        message: this.i18n.renew__message1[this.iso],
        confirmText: this.i18n.next[this.iso],
        inputAttrs: {
          type: "number",
          value: 1,
          min: 0,
          max: 99,
        },
        trapFocus: true,
      });
      this.$buefy.dialog.prompt({
        message: this.i18n.renew__message2[this.iso],
        confirmText: this.i18n.send[this.iso],
        inputAttrs: {
          maxlength: 10,
          required: false,
        },
        trapFocus: true,
        onConfirm: (cupon) => this.sendRenew(years, cupon),
      });
    }, */
    activateModal() {
      this.missingFields = [];
      for (const m of this.infoMembers) {
        if (!m.isInfo && !this.member[m.key]) {
          this.missingFields.push(this.i18n[m.fieldIso][this.iso]);
        }
      }
    },
    async createBenef() {
      this.newBeneficiario.ContratoId = this.contract.Id;

      /**
       * Validación client-side por campo (patrón Capturador)
       */
      if (
        !this.newBeneficiario.Nombre ||
        !this.newBeneficiario.ApellidoPaterno ||
        !this.newBeneficiario.Parentesco
      ) {
        this.$buefy.dialog.alert({
          title: this.i18n.validationError[this.iso],
          message: this.i18n.allFieldsAreRequired[this.iso],
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
        return;
      }

      const emailFF = (this.newBeneficiario.Email || "").toString().trim();
      if (!emailFF) {
        this.$buefy.dialog.alert({
          title: this.i18n.validationError[this.iso],
          message: this.i18n.friendsFamily__email_required[this.iso],
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
        return;
      }
      if (!/^[a-z0-9._+\-]+@([a-z0-9-]+\.){1,}[a-z]{2,16}$/.test(emailFF)) {
        this.$buefy.dialog.alert({
          title: this.i18n.validationError[this.iso],
          message: this.i18n.email__err3[this.iso],
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
        return;
      }

      if (!this.newBeneficiarioAgeConfirmed) {
        this.$buefy.dialog.alert({
          title: this.i18n.friendsFamily__ageWarningTitle[this.iso],
          message: this.i18n.friendsFamily__ageWarningCheck[this.iso],
          type: "is-warning",
          hasIcon: true,
          icon: "exclamation-triangle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
        return;
      }

      try {
        await axios.post(`${API_URL}/catcher/members/create`, {
          ...this.newBeneficiario,
          Email: emailFF,
          MayorEdadConfirmada: true,
        });

        this.showModal = false;
        this.newBeneficiarioAgeConfirmed = false;
        this.$buefy.toast.open({
          message: "OK",
          type: "is-success",
        });
        await this.getProfile();
      } catch (err) {
        this.$buefy.toast.open({
          message: this.ffErrorMessage(err),
          type: "is-danger",
        });
      }
    },
    ffErrorMessage(err) {
      const raw =
        (typeof err?.response?.data?.error === "string" &&
          err.response.data.error) ||
        (typeof err?.response?.data?.message === "string" &&
          err.response.data.message) ||
        null;
      if (!raw) return this.i18n.friendsFamily__create_error[this.iso];
      if (raw === "EMAIL_DUPLICATE" || raw.includes("ya está registrado"))
        return this.i18n.friendsFamily__duplicate[this.iso];
      if (raw === "Required" || /invalid email/i.test(raw))
        return this.i18n.friendsFamily__email_required[this.iso];
      return raw;
    },
    async sendRenew(qty, cupon) {
      try {
        this.loadingButtonRenewalPaymentLink = true;

        const cuponObject = this.cupons.find((c) => c.code === cupon);
        const { YearsCondoned } = this.periodOptions.find(
          (p) => p.value === this.yearsRenew
        );

        await axios.post(`${API_URL}/renewals/create?type=individual`, {
          LoginID: this.LoginID,
          Seal: "profile-member",
          qty,
          discountCode: cupon === "" ? null : cupon,
          CreadoPorEmail: localStorage.getItem("userEmail") || null,
          agentEmail:
            this.agentEmail || localStorage.getItem("userEmail") || null,
          amount: this.priceFinal,
          dataUtil: {
            cupon: cuponObject,
            FechaExpiracion: this.calculateNewExpirationDate(
              this.contract?.FechaRenovacion || this.contract?.FechaRegistro,
              this.yearsRenew
            ),
            Years: this.yearsRenew,
            priceOriginal: this.priceOriginal,
            discountYears: this.discountYears,
            discountCupon: this.discountCupon,
            codeCupon: cupon,
            priceFinal: this.priceFinal,
            PrincipalPagador: this.PrincipalPagador,
            codeReset: this.codeReset,
            YearsCondoned,
          },
        });

        this.codeReset = false;
        this.agentEmail = null;
        this.codeReset = false;

        // this.renewalUrl = response.data.url;
        this.$buefy.toast.open({
          message: this.i18n.createPaymentsLinks__msgOk[this.iso],
          type: "is-success",
        });

        this.loadingButtonRenewalPaymentLink = false;
        this.showModal = false;
        this.getProfile();
      } catch (err) {
        console.log(err);
        this.loadingButtonRenewalPaymentLink = false;
        this.showModal = false;
        this.$buefy.toast.open({
          message: "Error al crear enlace de pago",
          type: "is-danger",
        });
      }
    },
    async sendRenewDeferred(qty, cupon, EsPrimerPagoDiferido = false) {
      try {
        this.loadingButtonRenewalPaymentLink = true;

        const cuponObject = this.cupons.find((c) => c.code === cupon);
        const { YearsCondoned } = this.periodOptions.find(
          (p) => p.value === this.yearsRenew
        );

        const isDeferred = {
          MontoTotalPagoDiferido: this.priceFinal,
          EsPrimerPagoDiferido,
        };

        await axios.post(`${API_URL}/renewals/create?type=individual`, {
          LoginID: this.LoginID,
          Seal: "profile-member",
          qty,
          discountCode: cupon === "" ? null : cupon,
          CreadoPorEmail: localStorage.getItem("userEmail") || null,
          agentEmail:
            this.agentEmail || localStorage.getItem("userEmail") || null,
          amount: this.AbonoInicialDeferred,
          isDeferred,
          dataUtil: {
            cupon: cuponObject,
            FechaExpiracion: this.calculateNewExpirationDate(
              this.contract?.FechaRenovacion || this.contract?.FechaRegistro,
              this.yearsRenew
            ),
            Years: this.yearsRenew,
            priceOriginal: this.AbonoInicialDeferred,
            discountYears: this.discountYears,
            discountCupon: this.discountCupon,
            codeCupon: cupon,
            priceFinal: this.AbonoInicialDeferred,
            PrincipalPagador: this.PrincipalPagador,
            codeReset: this.codeReset,
            YearsCondoned,
          },
        });

        this.codeReset = false;
        this.agentEmail = null;
        this.codeReset = false;
        this.AbonoInicialDeferred = null;

        // this.renewalUrl = response.data.url;
        this.$buefy.toast.open({
          message: this.i18n.createPaymentsLinks__msgOk[this.iso],
          type: "is-success",
        });

        this.loadingButtonRenewalPaymentLink = false;
        this.showModal = false;
        this.getProfile();
      } catch (err) {
        console.log(err);
        this.loadingButtonRenewalPaymentLink = false;
        this.showModal = false;
        this.$buefy.toast.open({
          message: "Error al crear enlace de pago",
          type: "is-danger",
        });
      }
    },
    async sendRenewDeferred__other() {
      try {
        this.loadingButtonRenewalPaymentLink = true;

        const PayDeferred =
          this.paymentsDeferred && this.paymentsDeferred[0]
            ? this.paymentsDeferred[0].main
            : null;
        if (!PayDeferred) {
          this.$buefy.toast.open({
            message: "Error al crear enlace de pago",
            type: "is-danger",
          });
          return;
        }

        const isDeferred = {
          MontoTotalPagoDiferido: PayDeferred?.MontoTotalPagoDiferido,
          EsPrimerPagoDiferido: false,
        };

        await axios.post(`${API_URL}/renewals/create?type=individual`, {
          LoginID: this.LoginID,
          Seal: "profile-member",
          qty: PayDeferred?.moreInfo?.Years,
          discountCode: PayDeferred?.CuponAplicado || null,
          CreadoPorEmail: localStorage.getItem("userEmail") || null,
          agentEmail:
            this.agentEmail || localStorage.getItem("userEmail") || null,
          amount: this.AbonoInicialDeferred,
          isDeferred,
          dataUtil: {
            cupon: null,
            FechaExpiracion: PayDeferred?.moreInfo?.FechaFinPeriodo,
            Years: PayDeferred?.moreInfo?.Years,
            priceOriginal: this.AbonoInicialDeferred,
            discountYears: null,
            discountCupon: PayDeferred?.TotalDescuento || null,
            codeCupon: PayDeferred?.CuponAplicado || null,
            priceFinal: this.AbonoInicialDeferred,
            PrincipalPagador: "B",
            codeReset: PayDeferred?.moreInfo?.codeReset,
            YearsCondoned: 0,
            EsPagoDiferido: true,
            ReferenciaPagoDiferido: PayDeferred?.ReferenciaPagoDiferido,
            MontoTotalPagadoDiferido: (
              parseFloat(PayDeferred?.MontoTotalPagoDiferido) -
              parseFloat(PayDeferred?.missingAmount)
            ).toFixed(2),
            PagoCompletado:
              parseFloat(PayDeferred?.missingAmount) -
                this.AbonoInicialDeferred ===
              0
                ? true
                : false,
          },
        });

        this.codeReset = false;
        this.agentEmail = null;
        this.codeReset = false;
        this.AbonoInicialDeferred = null;

        // this.renewalUrl = response.data.url;
        this.$buefy.toast.open({
          message: this.i18n.createPaymentsLinks__msgOk[this.iso],
          type: "is-success",
        });

        this.loadingButtonRenewalPaymentLink = false;
        this.showModal = false;
        this.getProfile();
      } catch (err) {
        console.log(err);
        this.loadingButtonRenewalPaymentLink = false;
        this.showModal = false;
        this.$buefy.toast.open({
          message: "Error al crear enlace de pago",
          type: "is-danger",
        });
      }
    },
    async editStatusMembership(opt) {
      try {
        this.ModalOptionActive = false;
        this.loadingButtonEditStatusMembership = true;
        await axios.put(
          `${API_URL}/catcher/edit-status-membership/contract/${
            this.contract.Id
          }?updatedBy=${localStorage.getItem("user")}&option=${opt}`
        );
        // this.showModal = false;

        this.$buefy.toast.open({
          message: this.i18n.membershipActivatedOk[this.iso],
          type: "is-success",
        });
        await this.getProfile();
        await this.$bus.emit("refresh-comments");
      } catch (err) {
        console.log(err);
        this.showModal = false;
        this.$buefy.toast.open({
          message: "Error al editar contrato",
          type: "is-danger",
        });
      }
    },
    async editStatusContract() {
      try {
        await axios.put(
          `${API_URL}/catcher/edit-status/contract/${this.contract.Id}?status=${
            this.contract.EstadoContrato
          }&updatedBy=${localStorage.getItem("user")}`
        );
        this.showModal = false;
        this.$buefy.toast.open({
          message: "OK",
          type: "is-success",
        });
        await this.getProfile();
        await this.$bus.emit("refresh-comments");
      } catch (err) {
        console.log(err);
        this.showModal = false;
        this.$buefy.toast.open({
          message: "Error al editar contrato",
          type: "is-danger",
        });
      }
    },
    async editLenguage() {
      try {
        this.loading = true;
        await axios.put(
          `${API_URL}/catcher/contract/edit/${this.contract.Id}`,
          {
            Idioma: this.contract.Idioma,
          }
        );

        this.showModal = false;
        this.$buefy.toast.open({
          message: "OK",
          type: "is-success",
        });
        await this.getProfile();
      } catch (err) {
        console.log(err);
        this.showModal = false;
        this.$buefy.toast.open({
          message: "Error al editar contrato",
          type: "is-danger",
        });
      }
    },
    /* async sendEmailStatusMembership() {
      try {
        this.loadingButtonSendEmailMembershipStatus = true;
        await axios.put(
          `${API_URL}/catcher/edit-status-membership/contract/${this.contract.Id}?forceTrue=y`
        );
        this.loadingButtonSendEmailMembershipStatus = false;
        this.$buefy.toast.open({
          message: "OK",
          type: "is-success",
        });
        await this.getProfile();
      } catch (err) {
        console.log(err);
        this.loadingButtonSendEmailMembershipStatus = false;
        this.$buefy.toast.open({
          message: "Error al enviar email",
          type: "is-danger",
        });
      }
    }, */
    async getTypePayment() {
      try {
        const { data } = await axios.get(`${API_URL}/payment-type/list`);

        this.paymentMethod = data.response;
      } catch (err) {
        console.error("Error fetching payment types:", err);
      }
    },
    openModal(key) {
      if (key === "formulario") {
        this.modalType = "formulario";
        this.newBeneficiarioAgeConfirmed = false;
      } else if (key === "activate") {
        this.modalType = "activate";
        this.activateModal();
      } else if (key === "EstadoContrato") {
        this.modalType = "contrato";
        this.newStatus = this.contract[key];
      } else if (key === "Idioma") {
        this.modalType = "idioma";
        this.newStatus = this.contract[key];
      } else if (key === "renovar") {
        this.modalType = "renovar";
      } else if (key === "addPayment") {
        this.modalType = "addPayment";
      } else if (key === "addPaymentDeferred") {
        this.modalType = "addPaymentDeferred";
      } else if (key === "addPaymentDeferred__step1") {
        this.modalType = "addPaymentDeferred__step1";
      } else if (key === "addPaymentDeferred__step2") {
        this.modalType = "addPaymentDeferred__step2";
      } else if (key === "renovarDiferido") {
        this.modalType = "renovarDiferido";
      } else if (key === "renovarDiferido__step1") {
        this.modalType = "renovarDiferido__step1";
      }
      this.showModal = true;
    },
    handleButtonStatus(newStatus) {
      if (!isNaN(newStatus)) {
        this.editStatusContract();
      } else {
        this.editLenguage();
      }
    },
    goPath(row) {
      const { ApellidoPaterno, Nombre, Email } = this.member;
      const pushPath = this.$router.resolve({
        path: "/details-renewals",
        query: {
          id: row,
          details: row.details,
          loginID: this.LoginID,
          apellidoPaterno: ApellidoPaterno,
          nombre: Nombre,
          email: Email,
        },
      });
      window.open(pushPath.href, "_blank");
    },
    toggleButtons() {
      this.showButtons = !this.showButtons;
    },
    calculateNewExpirationDate(startDateTimestamp, yearsToAdd) {
      let startDate = moment(startDateTimestamp);
      if (this.codeReset) startDate = moment();
      const endDate = startDate.add(yearsToAdd, "years");
      return endDate.valueOf();
    },
    handleButtonClick(option) {
      this.selectedOption = option;

      if (option === "copy" && this.renewalUrl) {
        this.copyToClipboard(this.renewalUrl);
        this.$buefy.toast.open({
          message: "Copied Link",
          type: "is-success",
        });
      }
    },
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          console.log("Texto copiado al portapapeles");
        })
        .catch((err) => {
          console.error("Error al copiar el texto: ", err);
        });
    },
    openHubSpotContact(id) {
      if (id) {
        window.open(
          `https://app.hubspot.com/contacts/49762464/record/0-1/${id}`,
          "_blank"
        );
      }
    },
    openHubSpotContract() {
      if (this.contract.HsData && this.contract.HsData.id_hs_contract) {
        window.open(
          `https://app.hubspot.com/contacts/49762464/record/2-49039623/${this.contract.HsData.id_hs_contract}`,
          "_blank"
        );
      }
    },
    openHubSpotMembership() {
      if (this.contract.HsData && this.contract.HsData.id_hs_membership) {
        window.open(
          `https://app.hubspot.com/contacts/49762464/record/2-48993375/${this.contract.HsData.id_hs_membership}`,
          "_blank"
        );
      }
    },
    async sendPayment() {
      try {
        this.loadingButtonSendPaymentExternal = true;
        await axios.post(`${API_URL}/renewals/create-manual`, {
          // Monto: parseFloat(this.totalAmount),
          CreadoPor: localStorage.getItem("user") || null,
          agentEmail:
            this.agentEmail || localStorage.getItem("userEmail") || null,
          ContratoId: this.contract.Id,
          codeReset: this.codeReset,
          ...this.formPayment,
        });

        this.$buefy.toast.open({
          message: this.i18n.externalPayment__msg1[this.iso],
          type: "is-success",
        });

        this.formPayment.Monto = 0;
        this.formPayment.FechaPago = null;
        this.formPayment.TipoPago = null;
        this.formPayment.Years = null;
        this.formPayment.Referencia = null;
        this.formPayment.AbonoInicial = null;
        // this.paymentsDeferred = []

        await this.getProfile();
        // window.location.reload();
        this.loadingButtonSendPaymentExternal = false;
        this.showModal = false;
      } catch (err) {
        console.log(err);
        this.loadingButtonSendPaymentExternal = false;
        this.$buefy.toast.open({
          message: this.i18n.externalPayment__msg2[this.iso],
          type: "is-danger",
        });
      }
    },
    async sendPaymentDeferred() {
      try {
        this.loadingButtonSendPaymentDeferred = true;
        const isPagoCompletado =
          this.paymentsDeferred && this.paymentsDeferred[0]
            ? this.paymentsDeferred[0].main.missingAmount -
              this.formPayment.AbonoInicial
            : null;
        await axios.post(`${API_URL}/payment/manual/create-deferred`, {
          agentEmail:
            this.agentEmail || localStorage.getItem("userEmail") || null,
          ContratoId: this.contract.Id,
          codeReset: this.codeReset,
          ...this.formPayment,
          AbonoPrincipal:
            this.paymentsDeferred && this.paymentsDeferred[0]
              ? this.paymentsDeferred[0].main
              : null,
          PagoCompletado: isPagoCompletado === 0 ? true : false,
        });

        this.$buefy.toast.open({
          message: this.i18n.addPaymentDeferred__msg1[this.iso],
          type: "is-success",
        });

        this.formPayment.Monto = 0;
        this.formPayment.FechaPago = null;
        this.formPayment.TipoPago = null;
        this.formPayment.Years = null;
        this.formPayment.Referencia = null;
        this.formPayment.AbonoInicial = null;
        // this.paymentsDeferred = []

        // await this.getProfile();
        window.location.reload();
        this.loadingButtonSendPaymentDeferred = false;
        this.showModal = false;
      } catch (err) {
        console.log(err);
        this.loadingButtonSendPaymentDeferred = false;
        const msg =
          err?.response?.data?.error ||
          this.i18n.addPaymentDeferred__msg2[this.iso];

        this.$buefy.dialog.alert({
          message: msg,
          type: "is-danger",
          confirmText: "Ok",
          // icon: "times",
          // iconPack: "fas",
        });
        // this.$buefy.toast.open({
        //   message: msg,
        //   type: "is-danger",
        // });
      }
    },
    async sendPaymentDeferred__step1() {
      try {
        this.loadingButtonSendPaymentDeferred__step1 = true;
        await axios.post(`${API_URL}/payment/manual/create-deferred/add`, {
          agentEmail:
            this.agentEmail || localStorage.getItem("userEmail") || null,
          ContratoId: this.contract.Id,
          ...this.formPayment,
        });

        this.$buefy.toast.open({
          message: this.i18n.addPaymentDeferred__msg1[this.iso],
          type: "is-success",
        });

        this.formPayment.Monto = 0;
        this.formPayment.FechaPago = null;
        this.formPayment.TipoPago = null;
        this.formPayment.Years = null;
        this.formPayment.Referencia = null;
        this.formPayment.AbonoInicial = null;

        await this.getProfile();
        this.loadingButtonSendPaymentDeferred__step1 = false;
        this.showModal = false;
      } catch (err) {
        console.log(err);
        this.loadingButtonSendPaymentDeferred__step1 = false;
        this.$buefy.toast.open({
          message: this.i18n.addPaymentDeferred__msg2[this.iso],
          type: "is-danger",
        });
      }
    },
    formattedAnnualPlan(item) {
      const { i18n, iso, contract } = this;
      const nextInvoice = i18n.nextInvoice[iso];
      const tarifa = contract.Tarifa;
      const forText = i18n.for[iso];
      const value = item.isParse
        ? item.parse(contract[item.key], contract)
        : contract[item.key];

      return `${nextInvoice} ${value} ${forText} $${tarifa} USD`;
    },
    addNumber() {
      if (this.newPhoneNumber) {
        this.phones.push(this.newPhoneNumber);
        this.newPhoneNumber = "";
      }
    },
    removeNumber(index) {
      this.phones.splice(index, 1);
    },
    addEmails() {
      if (this.newEmail) {
        this.emails.push(this.newEmail);
        this.newEmail = "";
      }
    },
    removeEmail(index) {
      this.emails.splice(index, 1);
    },
    async editFF(IdFF, idx) {
      try {
        if (this.beneficiaries[idx].edit) {
          this.beneficiaries[idx].loading = true;
          this.$forceUpdate();

          const emailFF = (this.beneficiaries[idx].Email || "")
            .toString()
            .trim();
          if (!emailFF) {
            this.$buefy.dialog.alert({
              title: this.i18n.validationError[this.iso],
              message: this.i18n.friendsFamily__email_required[this.iso],
              type: "is-danger",
              hasIcon: true,
              icon: "times-circle",
              iconPack: "fa",
              ariaRole: "alertdialog",
              ariaModal: true,
            });
            this.beneficiaries[idx].loading = false;
            return;
          }
          if (!/^[a-z0-9._+\-]+@([a-z0-9-]+\.){1,}[a-z]{2,16}$/.test(emailFF)) {
            this.$buefy.dialog.alert({
              title: this.i18n.validationError[this.iso],
              message: this.i18n.email__err3[this.iso],
              type: "is-danger",
              hasIcon: true,
              icon: "times-circle",
              iconPack: "fa",
              ariaRole: "alertdialog",
              ariaModal: true,
            });
            this.beneficiaries[idx].loading = false;
            return;
          }

          await axios.put(`${API_URL}/catcher/members/edit/${IdFF}`, {
            Nombre: this.beneficiaries[idx].Nombre,
            ApellidoPaterno: this.beneficiaries[idx].ApellidoPaterno,
            Parentesco: this.beneficiaries[idx].Parentesco,
            Email: emailFF,
            Telefono: (this.beneficiaries[idx].Telefono || "").toString() || null,
            LadaTelefono: this.beneficiaries[idx].LadaTelefono || null,
          });
          await this.getProfile();
          this.beneficiaries[idx].edit = false;
          this.beneficiaries[idx].loading = false;
          this.$buefy.toast.open({
            message: "OK",
            type: "is-success",
          });
        } else {
          this.beneficiaries[idx].edit = true;
          this.$forceUpdate();
        }
      } catch (err) {
        console.log(err);
        this.beneficiaries[idx].loading = false;
        this.$buefy.toast.open({
          message: this.ffErrorMessage(err),
          type: "is-danger",
        });
      }
    },
    openFFAgeWarning(idx) {
      const ff = this.beneficiaries[idx] || {};
      const name = `${ff.Nombre || ""} ${ff.ApellidoPaterno || ""}`.trim();
      this.ffAgeModal = {
        active: true,
        names: [name || "Friends & Family"],
        index: idx,
        loading: false,
      };
    },
    cancelFFAgeWarning() {
      if (this.ffAgeModal.loading) return;
      this.ffAgeModal = { active: false, names: [], index: null, loading: false };
    },
    async confirmFFAgeWarning() {
      const idx = this.ffAgeModal.index;
      if (idx === null || idx === undefined) return;
      this.ffAgeModal.loading = true;
      try {
        const ok = await this.createFF(idx);
        if (ok) {
          this.ffAgeModal = { active: false, names: [], index: null, loading: false };
        } else {
          this.ffAgeModal.loading = false;
        }
      } catch (error) {
        this.ffAgeModal.loading = false;
      }
    },
    ffStatus(ff) {
      return resolveFFInvitationStatus(ff);
    },
    ffStatusLabel(status) {
      return ffInvitationLabelKey(status);
    },
    ffStatusBadge(status) {
      return ffInvitationBadgeType(status);
    },
    ffCanResend(ff) {
      return canResendInvitation(ff);
    },
    ffCanRevoke(ff) {
      return canRevokeInvitation(ff);
    },
    formatFFDate(value) {
      return value ? moment(value).format("DD/MM/YYYY") : "";
    },
    async resendFFInvitation(ff) {
      this.$buefy.dialog.confirm({
        title: this.i18n.friendsFamily__resendInvitation[this.iso],
        message: this.i18n.friendsFamily__resendConfirm[this.iso],
        confirmText: this.i18n.friendsFamily__resendInvitation[this.iso],
        cancelText: this.i18n.friendsFamily__ageWarningCancel[this.iso],
        type: "is-info",
        onConfirm: async () => {
          try {
            await axios.post(
              `${API_URL}/catcher/members/${ff._id}/ff-invitation/resend`
            );
            await this.getProfile();
            this.$buefy.toast.open({
              message: this.i18n.friendsFamily__resendOk[this.iso],
              type: "is-success",
            });
          } catch (error) {
            this.$buefy.toast.open({
              message:
                error?.response?.data?.message ||
                this.i18n.friendsFamily__invitationError[this.iso],
              type: "is-danger",
            });
          }
        },
      });
    },
    async revokeFFInvitation(ff) {
      this.$buefy.dialog.confirm({
        title: this.i18n.friendsFamily__revokeInvitation[this.iso],
        message: this.i18n.friendsFamily__revokeConfirm[this.iso],
        confirmText: this.i18n.friendsFamily__revokeInvitation[this.iso],
        cancelText: this.i18n.friendsFamily__ageWarningCancel[this.iso],
        type: "is-danger",
        onConfirm: async () => {
          try {
            await axios.post(
              `${API_URL}/catcher/members/${ff._id}/ff-invitation/revoke`
            );
            await this.getProfile();
            this.$buefy.toast.open({
              message: this.i18n.friendsFamily__revokeOk[this.iso],
              type: "is-success",
            });
          } catch (error) {
            this.$buefy.toast.open({
              message:
                error?.response?.data?.message ||
                this.i18n.friendsFamily__invitationError[this.iso],
              type: "is-danger",
            });
          }
        },
      });
    },
    async createFF(idx) {
      try {
        this.beneficiaries[idx].loading = true;

        if (
          !this.beneficiaries[idx].Nombre ||
          !this.beneficiaries[idx].ApellidoPaterno ||
          !this.beneficiaries[idx].Parentesco
        ) {
          this.$buefy.dialog.alert({
            title: this.i18n.validationError[this.iso],
            message: this.i18n.allFieldsAreRequired[this.iso],
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
          this.beneficiaries[idx].loading = false;
          return false;
        }

        const emailFF = (this.beneficiaries[idx].Email || "")
          .toString()
          .trim();
        if (!emailFF) {
          this.$buefy.dialog.alert({
            title: this.i18n.validationError[this.iso],
            message: this.i18n.friendsFamily__email_required[this.iso],
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
          this.beneficiaries[idx].loading = false;
          return false;
        }
        if (!/^[a-z0-9._+\-]+@([a-z0-9-]+\.){1,}[a-z]{2,16}$/.test(emailFF)) {
          this.$buefy.dialog.alert({
            title: this.i18n.validationError[this.iso],
            message: this.i18n.email__err3[this.iso],
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
          this.beneficiaries[idx].loading = false;
          return false;
        }

        const payload = {
          ContratoId: this.contract.Id,
          Nombre: this.beneficiaries[idx].Nombre,
          ApellidoPaterno: this.beneficiaries[idx].ApellidoPaterno,
          Parentesco: this.beneficiaries[idx].Parentesco,
          Seal: this.SEAL,
          Idioma: this.contract.Idioma,
          TipoSocio: "F",
          Password: this.contract.LoginID,
          Email: emailFF,
          Telefono: (this.beneficiaries[idx].Telefono || "").toString() || null,
          LadaTelefono: this.beneficiaries[idx].LadaTelefono || null,
          MayorEdadConfirmada: true,
        };

        const { data } = await axios.post(
          `${API_URL}/catcher/members/create`,
          payload
        );

        this.beneficiaries[idx].edit = false;
        await this.getProfile();
        this.beneficiaries[idx].loading = false;
        this.$forceUpdate();

        const invitationError = data?.member?.FFInvitacion?.UltimoError;
        this.$buefy.toast.open({
          message: invitationError
            ? this.i18n.friendsFamily__invitationError[this.iso]
            : this.i18n.friendsFamily__invitationSent[this.iso],
          type: invitationError ? "is-warning" : "is-success",
        });
        return true;
      } catch (err) {
        this.beneficiaries[idx].loading = false;
        console.log(err);
        this.$buefy.toast.open({
          message: this.ffErrorMessage(err),
          type: "is-danger",
        });
        return false;
      }
    },
    cancelEditFF(idx) {
      this.beneficiaries[idx].edit = false;
      this.$forceUpdate();
    },
    /**
     * Cancela la edición de un F&F existente, o elimina la fila
     * si todavía no tiene _id (fila nueva alta cancelada).
     */
    cancelOrRemoveFF(idx) {
      if (!this.beneficiaries[idx]._id) {
        let tmp = [];
        for (let i in this.beneficiaries) {
          if (parseInt(i) !== idx) tmp.push(this.beneficiaries[i]);
        }
        this.beneficiaries = [...tmp];
        this.$forceUpdate();
        return;
      }
      this.cancelEditFF(idx);
    },
    activateMembershipOption() {
      this.ModalOptionActive = true;
    },
    activateMembership() {
      const fieldsRequiered = this.infoMembers.filter((f) => f.required);
      let missingFields = [];
      for (let field of fieldsRequiered) {
        if (!this.member[field.key] || this.member[field.key] === "")
          missingFields.push(field.fieldIso);
      }

      missingFields = missingFields
        .map((f) => `<b>${this.i18n[f][this.iso]}</b>`)
        .join(", ");

      if (missingFields.length > 0) {
        this.$buefy.dialog.confirm({
          title: this.i18n.confirmActivation[this.iso],
          message: `${this.i18n.fieldsIncomplete[this.iso]} (${missingFields})`,
          confirmText: this.i18n.activate[this.iso],
          cancelText: this.i18n.cancel[this.iso],
          type: "is-warning",
          hasIcon: true,
          onConfirm: () => this.activateMembershipOption(),
        });
      } else {
        this.$buefy.dialog.confirm({
          title: this.i18n.confirmActivation[this.iso],
          message: `${this.i18n.fieldsComplete[this.iso]}`,
          confirmText: this.i18n.activate[this.iso],
          cancelText: this.i18n.cancel[this.iso],
          type: "is-info",
          hasIcon: true,
          onConfirm: () => this.activateMembershipOption(),
        });
      }
    },
    copyPaymentLink(Id) {
      navigator.clipboard.writeText(
        `${process.env.VUE_APP_SHORT_URL_PAYMENTLINK}/${Id}`
      );
      this.$buefy.toast.open({
        message: this.i18n.copyPaymentLink__msg1[this.iso],
        type: "is-success",
      });
    },
    async reSendPaymentLink(Id) {
      try {
        this.loadingResendPaymentLink = Id;
        await axios.get(`${API_URL}/renewals/resend-vaucher/${Id}`);

        this.$buefy.toast.open({
          message: this.i18n.sendLinkPayment__msg1[this.iso],
          type: "is-success",
        });
        this.loadingResendPaymentLink = null;
      } catch (err) {
        this.loadingResendPaymentLink = null;
        console.log(err);
        this.$buefy.toast.open({
          message: this.i18n.sendLinkPayment__msg2[this.iso],
          type: "is-danger",
        });
      }
    },
    async cancelPaymentLink(Id) {
      try {
        this.loadingCancelPaymentLink = Id;
        await axios.delete(`${API_URL}/renewals/cancel/${Id}`);

        this.$buefy.toast.open({
          message: this.i18n.cancelLinkPayment__msg1[this.iso],
          type: "is-success",
        });
        this.loadingCancelPaymentLink = null;
        this.payLink = [];
        await this.getProfile();
      } catch (err) {
        this.loadingCancelPaymentLink = null;
        console.log(err);
        this.$buefy.toast.open({
          message: this.i18n.cancelLinkPayment__msg2[this.iso],
          type: "is-danger",
        });
      }
    },
    onChangeYears(value) {
      console.log(value);
      let t = this.contract.Tarifa * this.formPayment.Years;
      if (this.formPayment.Years === 99) t = this.contract.Tarifa * 10;
      this.formPayment.Monto = parseFloat(t.toFixed(2));
    },
    async allUsersStaff() {
      try {
        // this.loading = true;
        const { data } = await axios.post(`${API_URL}/system/list-staff`, {});
        this.usersStaff = data?.users || [];
        // this.loading = false;
        // this.$buefy.toast.open({
        //   message: "Updated OK",
        //   type: "is-success",
        // });
      } catch (err) {
        // this.loading = false;
        console.log(err);
      }
    },
    async editAccesoTemporal() {
      try {
        // this.loading = true;
        await axios.put(
          `${API_URL}/catcher/contract/edit/${this.contract.Id}`,
          {
            AccesoTemporal: this.contract.AccesoTemporal,
          }
        );

        this.$buefy.toast.open({
          message: this.i18n.webTemporary__msg1[this.iso],
          type: "is-success",
        });
        // await this.getProfile();
      } catch (err) {
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al editar contrato",
          type: "is-danger",
        });
      }
    },
    async editAccesoWebSocio() {
      try {
        // this.loading = true;
        await axios.put(
          `${API_URL}/catcher/members/edit/${this.memberId}`,
          {
            AccesoWebSocio: this.AccesoWebSocio,
          }
        );

        this.$buefy.toast.open({
          message: this.i18n.accessWebMember__msg1[this.iso],
          type: "is-success",
        });
        // await this.getProfile();
      } catch (err) {
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al editar contrato",
          type: "is-danger",
        });
      }
    },
    async editAccesoMyDeals() {
      try {
        // this.loading = true;
        await axios.put(
          `${API_URL}/catcher/contract/edit/${this.contract.Id}`,
          {
            AccesoMyDeals: this.contract.AccesoMyDeals,
          }
        );

        this.$buefy.toast.open({
          message: this.i18n.myDealsAccess__msg1[this.iso],
          type: "is-success",
        });
        // await this.getProfile();
      } catch (err) {
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al editar contrato",
          type: "is-danger",
        });
      }
    },
    async editFee() {
      try {
        // this.loading = true;
        await axios.put(
          `${API_URL}/catcher/contract/edit/${this.contract.Id}`,
          {
            Tarifa: this.contract.Tarifa,
          }
        );

        this.$buefy.toast.open({
          message: this.i18n.editFee__msg1[this.iso],
          type: "is-success",
        });
        // await this.getProfile();
      } catch (err) {
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al editar contrato",
          type: "is-danger",
        });
      }
    },
    closeModalOptionActive() {
      this.ModalOptionActive = false;
    },
    openSmsModal(persona, memberId, rol) {
      this.smsModal = { isOpen: true, persona: { ...persona }, memberId: String(memberId), rol };
    },
    openTutorialModal() {
      this.tutorialModal.isOpen = true;
      this.tutorialModal.step = 'tutorial';
      this.tutorialModal.selectedMotivo = null;
      this.tutorialModal.selectedTema = null;
      this.tutorialModal.comentario = '';
      this.resetTutorialDiscovery();
    },
    resetTutorialDiscovery() {
      this.tutorialModal.discovery = {
        solicitanteTipo: null,
        solicitanteBeneficiario: null,
        interesPrincipal: null,
        frecuenciaViaje: null,
        friccionClub: null,
        fechaDestino: null,
        canalPreferido: null,
        horarioPreferido: null
      };
    },
    warnTutorial(es, en) {
      this.$buefy.toast.open({
        message: this.iso === 'es' ? es : en,
        type: 'is-warning'
      });
      return false;
    },
    validateTutorialStep() {
      if (!this.tutorialModal.selectedMotivo)
        return this.warnTutorial('Debes seleccionar un motivo', 'You must select a reason');

      if (this.tutorialModal.selectedMotivo === 'Bienvenida' && this.hasBienvenidaTutorial)
        return this.warnTutorial(
          'La bienvenida de este socio ya está completada',
          "This member's welcome tutorial is already completed"
        );

      if (!this.tutorialModal.selectedTema)
        return this.warnTutorial('Debes seleccionar un resultado', 'You must select a result');

      if (!this.tutorialModal.comentario.trim()) {
        this.$buefy.toast.open({
          message: this.i18n.commentRequired?.[this.iso] || 'El comentario es requerido',
          type: 'is-warning'
        });
        return false;
      }

      return true;
    },
    validateDiscoveryStep() {
      const discovery = this.tutorialModal.discovery;

      if (!discovery.solicitanteTipo)
        return this.warnTutorial(
          'Debes indicar quién solicitó el tutorial',
          'You must indicate who requested the tutorial'
        );

      if (discovery.solicitanteTipo === 'F' && discovery.solicitanteBeneficiario === null)
        return this.warnTutorial(
          'Debes indicar cuál Friends and Family solicitó el tutorial',
          'You must indicate which Friends and Family member requested the tutorial'
        );

      if (!this.tutorialSolicitanteNombre)
        return this.warnTutorial(
          'No se pudo identificar el nombre de quien solicitó el tutorial',
          'Could not identify the name of who requested the tutorial'
        );

      const requeridos = [
        ['interesPrincipal', 'el interés principal', 'the main interest'],
        ['frecuenciaViaje', 'la frecuencia de viaje', 'the travel frequency'],
        ['friccionClub', 'la fricción con el Club', 'the friction with the Club'],
        ['fechaDestino', 'si tiene fecha o destino', 'whether there is a date or destination'],
        ['canalPreferido', 'el canal de seguimiento', 'the follow-up channel'],
        ['horarioPreferido', 'el horario de contacto', 'the contact time']
      ];

      for (const [campo, es, en] of requeridos) {
        if (!discovery[campo])
          return this.warnTutorial(`Debes seleccionar ${es}`, `You must select ${en}`);
      }

      return true;
    },
    buildDiscoveryPayload() {
      const discovery = this.tutorialModal.discovery;

      // Titular y cotitular son unicos por contrato, pero los F&F no: se manda el
      // _id para que el backend sepa a cual de ellos le corresponde el discovery.
      const beneficiario =
        discovery.solicitanteTipo === "F" && discovery.solicitanteBeneficiario !== null
          ? this.beneficiaries[discovery.solicitanteBeneficiario]
          : null;

      return {
        SolicitanteTipo: discovery.solicitanteTipo,
        SolicitanteNombre: this.tutorialSolicitanteNombre,
        ...(beneficiario?._id ? { SolicitanteMemberId: beneficiario._id } : {}),
        InteresPrincipal: discovery.interesPrincipal,
        FrecuenciaViaje: discovery.frecuenciaViaje,
        FriccionClub: discovery.friccionClub,
        FechaDestino: discovery.fechaDestino,
        CanalPreferido: discovery.canalPreferido,
        HorarioPreferido: discovery.horarioPreferido
      };
    },
    async saveTutorialComment() {
      if (this.tutorialModal.step === 'tutorial') {
        if (!this.validateTutorialStep()) return;

        // La bienvenida completada es la unica que pide discovery: se avanza al
        // segundo paso en lugar de guardar.
        if (this.isBienvenidaCompletada) {
          this.tutorialModal.step = 'discovery';
          return;
        }
      } else if (!this.validateDiscoveryStep()) return;

      const created = await this.createComment(
        this.tutorialModal.comentario,
        this.tutorialModal.selectedTema,
        this.tutorialModal.selectedMotivo,
        this.isBienvenidaCompletada ? this.buildDiscoveryPayload() : null
      );

      // Si el guardado falla el modal se queda abierto: cerrarlo borraba lo
      // capturado y dejaba al agente sin forma de reintentar.
      if (created) this.tutorialModal.isOpen = false;
    },
    async createComment(text, tema, motivo, discovery = null) {
      try {
        this.loadingAddCommentTutorial = true;
        await axios.post(`${API_URL}/catcher/members/comments/create`, {
          Comentario: `${text} byBO`,
          Tipo: "contract",
          ContratoId: this.contract.Id,
          CreadoPor: localStorage.getItem("user"),
          Tema: tema,
          Motivo: motivo,
          ...(discovery ? { Discovery: discovery } : {}),
        });
        await this.getProfile();
        await this.loadTutorialComments();

        this.loadingAddCommentTutorial = false;
        this.$buefy.toast.open({
          message: this.i18n.addTutorial__msg3[this.iso],
          type: "is-success",
        });
        return true;
      } catch (error) {
        this.loadingAddCommentTutorial = false;
        console.log(error);

        // El backend manda el motivo real del rechazo en data.error; antes se
        // descartaba y el agente solo veia un mensaje generico.
        const apiError = error?.response?.data?.error;
        this.$buefy.toast.open({
          message:
            typeof apiError === "string" && apiError.trim()
              ? apiError
              : this.iso === "es"
              ? "Error al crear el tutorial"
              : "Error creating the tutorial",
          type: "is-danger",
          duration: 5000,
        });
        return false;
      }
    },
    openDatetimepicker() {
      const datetimeInput = document.getElementById("myDatetimeInput");
      datetimeInput.showPicker();
      this.showDatetimepicker = true;
    },
    closeDatetimepicker() {
      const datetimeInput = document.getElementById("myDatetimeInput");
      datetimeInput.blur();
      this.showDatetimepicker = false;
    },
    clearCatPaises() {
      const newCatPaises = [];

      for (let c of this.catalogues.CatPaises) {
        const exists = newCatPaises.find((a) => a.Lada === c.Lada);
        if (!exists) newCatPaises.push(c);
      }

      return newCatPaises.sort((a, b) =>
        a.Lada > b.Lada ? 1 : b.Lada > a.Lada ? -1 : 0
      );
    },
    checkFieldsOK(member, key) {
      if (key === "Email" && member.Email === member.EmailOK) return true;
      else if (key === "Telefono" && member.Telefono === member.TelefonoOK)
        return true;
      else return false;
    },
    openAddPointsModal() {
      this.addPointsForm = {
        monto: null,
        Motivo: "",
        MotivoDetalle: "",
        destinatario: "titular",
      };
      this.pointsModalStep = "form";
      this.pointsOtpCode = "";
      this.showAddPointsModal = true;
    },
    validatePointsForm() {
      if (
        this.addPointsForm.monto === null ||
        this.addPointsForm.monto === ""
      ) {
        this.$buefy.toast.open({
          message: this.i18n.addPoints__msg3[this.iso],
          type: "is-warning",
        });
        return null;
      }
      if (this.addPointsForm.destinatario === "cotitular" && !this.coMemberId) {
        this.$buefy.toast.open({
          message: this.i18n.noCoOwnerSelected[this.iso],
          type: "is-warning",
        });
        return null;
      }
      return this.addPointsForm.destinatario === "cotitular"
        ? this.coMemberId
        : this.member._id;
    },
    async sendPointsOtp() {
      const memberId = this.validatePointsForm();
      if (!memberId) return;
      try {
        this.loadingPointsOtp = true;
        await axios.post(`${API_URL}/puntos/manuales/otp`, {
          userAgent: localStorage.getItem("user") || null,
          monto: Number(this.addPointsForm.monto),
          Motivo: this.addPointsForm.Motivo,
          MotivoDetalle: this.addPointsForm.MotivoDetalle,
        });
        this.pointsModalStep = "otp";
        this.pointsOtpCode = "";
        this.$buefy.toast.open({
          message: this.i18n.otpSent[this.iso],
          type: "is-success",
        });
      } catch (err) {
        console.log(err);
        this.$buefy.toast.open({
          message: this.i18n.otpSendError[this.iso],
          type: "is-danger",
        });
      } finally {
        this.loadingPointsOtp = false;
      }
    },
    async addPoints() {
      if (
        !this.pointsOtpCode ||
        this.pointsOtpCode.trim().length !== 4
      ) {
        this.$buefy.toast.open({
          message: this.i18n.otpRequired[this.iso],
          type: "is-warning",
        });
        return;
      }
      const memberId = this.validatePointsForm();
      if (!memberId) return;
      try {
        this.loadingAddPoints = true;
        await axios.post(`${API_URL}/puntos/manuales`, {
          memberId,
          monto: Number(this.addPointsForm.monto),
          Motivo: this.addPointsForm.Motivo,
          MotivoDetalle: this.addPointsForm.MotivoDetalle,
          creadoPor: localStorage.getItem("user") || null,
          otpCode: this.pointsOtpCode.trim(),
          userAgent: localStorage.getItem("user") || null,
        });
        this.$buefy.toast.open({
          message: this.i18n.addPoints__msg1[this.iso],
          type: "is-success",
        });
        this.showAddPointsModal = false;
        this.loadingAddPoints = false;
        await this.getProfile();
      } catch (err) {
        console.log(err);
        this.loadingAddPoints = false;
        this.pointsOtpCode = "";
        let typeError = err?.response?.data?.typeError;
        this.$buefy.toast.open({
          message:
            (typeError && typeError?.message?.[this.iso]) ||
            this.i18n.otpInvalid[this.iso],
          type: "is-danger",
        });
      }
    },
    // Los vouchers automáticos guardan 'na' (welcome bonus) o 'renewal' en vez de un usuario
    voucherAsignadoPor(row) {
      const usuario = row.CreadoPor;
      if (usuario === "renewal") return this.i18n.assignedByRenewal[this.iso];
      if (usuario && usuario !== "na") return usuario;
      if (row.Origen === "manual") return "—";
      return this.i18n.assignedBySystem[this.iso];
    },
    openAddTravelVoucherModal() {
      this.addTravelVoucherForm = {
        monto: null,
        sendCertificate: "no",
      };
      this.showAddTravelVoucherModal = true;
    },
    async createTravelVoucher() {
      if (
        this.addTravelVoucherForm.monto === null ||
        this.addTravelVoucherForm.monto === ""
      ) {
        this.$buefy.toast.open({
          message: this.i18n.addTravelVoucher__msg3[this.iso],
          type: "is-warning",
        });
        return;
      }
      try {
        this.loadingAddTravelVoucher = true;
        const res = await axios.post(`${API_URL}/travel-vouchers/create`, {
          email: this.member.Email || "",
          userAgent: localStorage.getItem("user") || null,
          monto: Number(this.addTravelVoucherForm.monto),
        });
        if (
          res?.data?.success &&
          this.addTravelVoucherForm.sendCertificate === "si"
        ) {
          try {
            await axios.post(`${API_URL}/travel-vouchers/send-email`, {
              codigo: res.data.codigo,
            });
            this.$buefy.toast.open({
              message: this.i18n.sendCertificate__msg1[this.iso],
              type: "is-success",
            });
          } catch (errCert) {
            console.log(errCert);
            this.$buefy.toast.open({
              message: this.i18n.sendCertificate__msg2[this.iso],
              type: "is-danger",
            });
          }
        }
        this.$buefy.toast.open({
          message: this.i18n.addTravelVoucher__msg1[this.iso],
          type: "is-success",
        });
        this.showAddTravelVoucherModal = false;
        this.loadingAddTravelVoucher = false;
        await this.getProfile();
      } catch (err) {
        console.log(err);
        this.loadingAddTravelVoucher = false;
        this.$buefy.toast.open({
          message: this.i18n.addTravelVoucher__msg2[this.iso],
          type: "is-danger",
        });
      }
    },
    async addCoOwner() {
      try {
        this.loadingAddCoOwner = true;
        await axios.post(`${API_URL}/catcher/members/add-coowner`, {
          Id: this.contract.Id,
          agentEmail: localStorage.getItem("userEmail" || null),
        });
        this.$buefy.toast.open({
          message: this.i18n.addCoOwner__msg1[this.iso],
          type: "is-success",
        });
        this.loadingAddCoOwner = false;
        window.location.reload();
      } catch (err) {
        console.log(err);
        this.loadingAddCoOwner = false;
        this.$buefy.toast.open({
          message: this.i18n.addCoOwner__msg2[this.iso],
          type: "is-danger",
        });
      }
    },
  },
};
</script>

<style scoped>
.articles {
  margin: 5rem 0;
  margin-top: -200px;
}

.articles .content p {
  line-height: 1.9;
  margin: 15px 0;
}

.author-image {
  position: absolute;
  top: -30px;
  left: 50%;
  width: 60px;
  height: 60px;
  margin-left: -30px;
  /* border: 3px solid #ccc; */
  /* border-radius: 50%; */
}

.author-image-vip {
  position: absolute;
  top: -90px;
  left: 47%;
  width: 130px;
  height: 130px;
  margin-left: -30px;
  /* border: 3px solid #ccc; */
  /* border-radius: 50%; */
}

.media-center {
  display: block;
  margin-bottom: 1rem;
}

.media-content {
  margin-top: 3rem;
}

.article,
.promo-block {
  margin-top: 6rem;
}

/* div.column.is-8:first-child {
  padding-top: 0;
  margin-top: 0;
} */
.article-title {
  font-size: 2rem;
  font-weight: lighter;
  line-height: 2;
}

.article-subtitle {
  color: #909aa0;
  margin-bottom: 3rem;
}

.article-body {
  line-height: 1.4;
  margin: 0 6rem;
}

.promo-block .container {
  margin: 1rem 5rem;
}

.btns {
  width: 200px;
}

/* .columns {
  display: flex;
  justify-content: flex-end;
} */
.row {
  display: flex;
  width: 53%;
  justify-content: flex-end;
}

.row-friendsfamily {
  gap: 1em;
  display: flex;
  width: 100%;
  justify-content: flex-end;
  padding-right: 10px;
}

.row-friendsfamily-2 {
  gap: 1em;
  display: flex;
  width: 3%;
  justify-content: flex-end;
}

.column-content {
  display: flex;
  flex-direction: column;
}
.row-content {
  display: flex;
  width: 100%;
  gap: 1rem;
  margin-bottom: 15px;
}

.row-content-benef {
  display: flex;
  width: 80%;
  margin-bottom: 3px;
}

.field-text {
  display: block;
  width: 100%;
  height: 39px;
  padding: 0.9em;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background-color: #ff000042;
  font-size: 1em;
  line-height: 1.5;
  color: #495057;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

/* .column-content {
  display: flex;
  flex-direction: column;
} */
.content-estatus {
  background-color: aqua;
}

.btn-active {
  width: 200px;
}

.btn-inactive {
  width: 200px;
  background-color: #ff000042;
}

.short-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
  cursor: pointer;
  display: inline-block;
}

.short-text:hover {
  overflow: visible;
  z-index: 1000;
  max-width: none;
}

.buttons {
  display: flex;
  justify-content: center;
}

.button-wrapper {
  display: flex;
  align-items: baseline;
  margin: 5px;
  flex-direction: row;
  justify-content: space-between;
}

.label {
  margin-left: 10px;
}

.truncated-url {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}

.renewUrl {
  width: 270px;
  background-color: #dffaf0;
  border-radius: 10px;
  margin: auto;
  padding: 5px;
}

.datetime-input-container {
  position: relative; /* Necesario para posicionar el icono */
  display: inline-block; /* Para que el contenedor se ajuste al input */
}

.datetime-input-container input[type="datetime-local"] {
  padding-right: 30px; /* Deja espacio para el icono */
  /* Otros estilos para tu input, por ejemplo: */
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  box-sizing: border-box; /* Asegura que el padding no aumente el ancho total */
}

.datetime-icon {
  position: absolute;
  right: 10px; /* Ajusta la posición del icono desde la derecha */
  top: 50%;
  transform: translateY(-50%); /* Centra verticalmente el icono */
  width: 20px; /* Ancho del icono */
  height: 20px; /* Alto del icono */
  /* Aquí es donde agregas tu icono personalizado. Puedes usar: */
  /* 1. Una imagen de fondo: */
  background-image: url("https://cdn-icons-png.flaticon.com/512/1067/1067374.png"); /* Reemplaza con la URL de tu icono */
  background-size: cover; /* Ajusta la imagen al tamaño del span */
  background-repeat: no-repeat;
  background-position: center;

  /* 2. Un icono de fuente (ej. Font Awesome): */
  /* font-family: 'Font Awesome 5 Free'; */
  /* font-weight: 900; */
  /* content: '\f073'; /* Código Unicode del icono de calendario (ejemplo) */
  /* color: #555; */

  /* 3. Un SVG en línea (si es simple y no lo necesitas en otro lugar): */
  /* background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='4' width='18' height='18' rx='2' ry='2'%3E%3C/rect%3E%3Cline x1='16' y1='2' x2='16' y2='6'%3E%3C/line%3E%3Cline x1='8' y1='2' x2='8' y2='6'%3E%3C/line%3E%3Cline x1='3' y1='10' x2='21' y2='10'%3E%3C/line%3E%3C/svg%3E"); */
}

/* Cursor pointer al pasar el mouse sobre el contenedor */
.datetime-input-container:hover {
  cursor: pointer;
}

/* Opcional: Cursor pointer al pasar el mouse sobre el input mismo si quieres un control más granular */
.datetime-input-container input[type="datetime-local"]:hover {
  cursor: pointer;
}
</style>

<style>
tr.is-selected-row {
  background: #7eb0e9;
  color: #fff;
}

.custom-icon {
  background-color: #48c774;
  border-radius: 10px;
  color: white;
  padding: 15px;
  margin-right: 10px;
}

tr.is-info {
  background: #fdffc2;
  color: #35374b;
}
</style>
